import { store } from '../Store/Store'

export function getNaceCodeText(naceCode: string): string | undefined {
  const language = store.getState().interface.activeLanguage
  return (
    NaceCodes.find((nc) => nc.code === naceCode) as Record<string, string>
  )?.[language]
}

export function getNaceSelectOptions(): Array<{
  value: string
  label: string
}> {
  const language = store.getState().interface.activeLanguage
  return NaceCodes.map((nc) => ({
    value: nc.code,
    label: `${nc.code}: ${(nc as Record<string, string>)[language]}`,
  }))
}

export const NaceCodes = [
  {
    code: '0111',
    nl: 'Teelt van granen (m.u.v. rijst), peulgewassen en oliehoudende zaden',
    fr: "Culture de céréales (à l'exception du riz), de légumineuses et de graines oléagineuses",
    en: 'Growing of cereals (except rice), leguminous crops and oil seeds',
  },
  {
    code: '0112',
    nl: 'Teelt van rijst',
    fr: 'Culture du riz',
    en: 'Growing of rice',
  },
  {
    code: '0113',
    nl: 'Teelt van groenten, meloenen en wortel- en knolgewassen',
    fr: 'Culture de légumes, de melons, de racines et de tubercules',
    en: 'Growing of vegetables and melons, roots and tubers',
  },
  {
    code: '0114',
    nl: 'Teelt van suikerriet',
    fr: 'Culture de la canne à sucre',
    en: 'Growing of sugar cane',
  },
  {
    code: '0115',
    nl: 'Teelt van tabak',
    fr: 'Culture du tabac',
    en: 'Growing of tobacco',
  },
  {
    code: '0116',
    nl: 'Teelt van vezelgewassen',
    fr: 'Culture de plantes à fibres',
    en: 'Growing of fibre crops',
  },
  {
    code: '0119',
    nl: 'Teelt van andere eenjarige gewassen',
    fr: 'Autres cultures non permanentes',
    en: 'Growing of other non-perennial crops',
  },
  {
    code: '0121',
    nl: 'Teelt van druiven',
    fr: 'Culture de la vigne',
    en: 'Growing of grapes',
  },
  {
    code: '0122',
    nl: 'Teelt van tropisch en subtropisch fruit',
    fr: 'Culture de fruits tropicaux et subtropicaux',
    en: 'Growing of tropical and subtropical fruits',
  },
  {
    code: '0123',
    nl: 'Teelt van citrusvruchten',
    fr: "Culture d'agrumes",
    en: 'Growing of citrus fruits',
  },
  {
    code: '0124',
    nl: 'Teelt van pit- en steenvruchten',
    fr: 'Culture de fruits à pépins et à noyau',
    en: 'Growing of pome fruits and stone fruits',
  },
  {
    code: '0125',
    nl: 'Teelt van andere boomvruchten, kleinfruit en noten',
    fr: "Culture d'autres fruits d'arbres ou d'arbustes et de fruits à coque",
    en: 'Growing of other tree and bush fruits and nuts',
  },
  {
    code: '0126',
    nl: 'Teelt van oliehoudende vruchten',
    fr: 'Culture de fruits oléagineux',
    en: 'Growing of oleaginous fruits',
  },
  {
    code: '0127',
    nl: 'Teelt van gewassen bestemd voor de vervaardiging van dranken',
    fr: 'Culture de plantes à boissons',
    en: 'Growing of beverage crops',
  },
  {
    code: '0128',
    nl: 'Teelt van specerijgewassen en van aromatische en medicinale gewassen',
    fr: 'Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques',
    en: 'Growing of spices, aromatic, drug and pharmaceutical crops',
  },
  {
    code: '0129',
    nl: 'Teelt van andere meerjarige gewassen',
    fr: 'Autres cultures permanentes',
    en: 'Growing of other perennial crops',
  },
  {
    code: '0130',
    nl: 'Plantenvermeerdering',
    fr: 'Reproduction de plantes',
    en: 'Plant propagation',
  },
  {
    code: '0141',
    nl: 'Fokken van melkvee',
    fr: 'Élevage de vaches laitières',
    en: 'Raising of dairy cattle',
  },
  {
    code: '0142',
    nl: 'Fokken van andere runderen en buffels',
    fr: "Élevage d'autres bovins et de buffles",
    en: 'Raising of other cattle and buffaloes',
  },
  {
    code: '0143',
    nl: 'Fokken van paarden en andere paardachtigen',
    fr: "Élevage de chevaux et d'autres équidés",
    en: 'Raising of horses and other equines',
  },
  {
    code: '0144',
    nl: 'Fokken van kamelen en andere kameelachtigen',
    fr: "Élevage de chameaux et d'autres camélidés",
    en: 'Raising of camels and camelids',
  },
  {
    code: '0145',
    nl: 'Fokken van schapen en geiten',
    fr: "Élevage d'ovins et de caprins",
    en: 'Raising of sheep and goats',
  },
  {
    code: '0146',
    nl: 'Fokken van varkens',
    fr: 'Élevage de porcins',
    en: 'Raising of swine/pigs',
  },
  {
    code: '0147',
    nl: 'Fokken van pluimvee',
    fr: 'Élevage de volailles',
    en: 'Raising of poultry',
  },
  {
    code: '0149',
    nl: 'Fokken van andere dieren',
    fr: "Élevage d'autres animaux",
    en: 'Raising of other animals',
  },
  {
    code: '0150',
    nl: 'Gemengd bedrijf',
    fr: 'Culture et élevage associés',
    en: 'Mixed farming',
  },
  {
    code: '0161',
    nl: 'Ondersteunende activiteiten in verband met de teelt van gewassen',
    fr: 'Activités de soutien aux cultures',
    en: 'Support activities for crop production',
  },
  {
    code: '0162',
    nl: 'Ondersteunende activiteiten in verband met de veeteelt',
    fr: 'Activités de soutien à la production animale',
    en: 'Support activities for animal production',
  },
  {
    code: '0163',
    nl: 'Activiteiten met betrekking tot gewassen na de oogst',
    fr: 'Traitement primaire des récoltes',
    en: 'Post-harvest crop activities',
  },
  {
    code: '0164',
    nl: 'Zaadbewerking met het oog op vermeerdering',
    fr: 'Traitement des semences',
    en: 'Seed processing for propagation',
  },
  {
    code: '0170',
    nl: 'Jacht, zetten van vallen en diensten in verband met deze activiteiten',
    fr: 'Chasse, piégeage et services annexes',
    en: 'Hunting, trapping and related service activities',
  },
  {
    code: '0210',
    nl: 'Bosbouw',
    fr: 'Sylviculture et autres activités forestières',
    en: 'Silviculture and other forestry activities',
  },
  {
    code: '0220',
    nl: 'Exploitatie van bossen',
    fr: 'Exploitation forestière',
    en: 'Logging',
  },
  {
    code: '0230',
    nl: 'Verzamelen van in het wild groeiende producten met uitzondering van hout',
    fr: "Récolte de produits forestiers non ligneux poussant à l'état sauvage",
    en: 'Gathering of wild growing non-wood products',
  },
  {
    code: '0240',
    nl: 'Ondersteunende diensten in verband met de bosbouw',
    fr: "Services de soutien à l'exploitation forestière",
    en: 'Support services to forestry',
  },
  { code: '0311', nl: 'Zeevisserij', fr: 'Pêche en mer', en: 'Marine fishing' },
  {
    code: '0312',
    nl: 'Binnenvisserij',
    fr: 'Pêche en eau douce',
    en: 'Freshwater fishing',
  },
  {
    code: '0321',
    nl: 'Mariene aquacultuur',
    fr: 'Aquaculture en mer',
    en: 'Marine aquaculture',
  },
  {
    code: '0322',
    nl: 'Aquacultuur in zoet water',
    fr: 'Aquaculture en eau douce',
    en: 'Freshwater aquaculture',
  },
  {
    code: '0510',
    nl: 'Winning van steenkool',
    fr: 'Extraction de houille',
    en: 'Mining of hard coal',
  },
  {
    code: '0520',
    nl: 'Winning van bruinkool',
    fr: 'Extraction de lignite',
    en: 'Mining of lignite',
  },
  {
    code: '0610',
    nl: 'Winning van aardolie',
    fr: 'Extraction de pétrole brut',
    en: 'Extraction of crude petroleum',
  },
  {
    code: '0620',
    nl: 'Winning van aardgas',
    fr: 'Extraction de gaz naturel',
    en: 'Extraction of natural gas',
  },
  {
    code: '0710',
    nl: 'Winning van ijzererts',
    fr: 'Extraction de minerais de fer',
    en: 'Mining of iron ores',
  },
  {
    code: '0721',
    nl: 'Winning van uranium- en thoriumerts',
    fr: "Extraction de minerais d'uranium et de thorium",
    en: 'Mining of uranium and thorium ores',
  },
  {
    code: '0729',
    nl: 'Winning van andere non-ferrometaalertsen',
    fr: "Extraction d'autres minerais de métaux non ferreux",
    en: 'Mining of other non-ferrous metal ores',
  },
  {
    code: '0811',
    nl: 'Winning van bouw- en siersteen, kalksteen, gips, krijt en leisteen',
    fr: "Extraction de pierres ornementales et de construction, de pierres calcaires, de gypse, de craie et d'ardoise",
    en: 'Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate',
  },
  {
    code: '0812',
    nl: 'Winning van grind, zand, klei en kaolien',
    fr: "Exploitation de gravières et de sablières, extraction d'argiles et de kaolin",
    en: 'Operation of gravel and sand pits; mining of clays and kaolin',
  },
  {
    code: '0891',
    nl: 'Winning van mineralen voor de chemische en de kunstmestindustrie',
    fr: "Extraction des minéraux chimiques et d'engrais minéraux",
    en: 'Mining of chemical and fertiliser minerals',
  },
  {
    code: '0892',
    nl: 'Winning van turf',
    fr: 'Extraction de tourbe',
    en: 'Extraction of peat',
  },
  {
    code: '0893',
    nl: 'Zoutwinning',
    fr: 'Production de sel',
    en: 'Extraction of salt',
  },
  {
    code: '0899',
    nl: 'Overige winning van delfstoffen, n.e.g.',
    fr: 'Autres activités extractives n.c.a.',
    en: 'Other mining and quarrying n.e.c.',
  },
  {
    code: '0910',
    nl: 'Ondersteunende activiteiten in verband met de aardolie- en aardgaswinning',
    fr: "Activités de soutien à l'extraction d'hydrocarbures",
    en: 'Support activities for petroleum and natural gas extraction',
  },
  {
    code: '0990',
    nl: 'Ondersteunende activiteiten in verband met de overige winning van delfstoffen',
    fr: 'Activités de soutien aux autres industries extractives',
    en: 'Support activities for other mining and quarrying',
  },
  {
    code: '1011',
    nl: 'Verwerking en conservering van vlees, exclusief vlees van gevogelte',
    fr: "Transformation et conservation de la viande de boucherie, à l'exclusion de la viande de volaille",
    en: 'Processing and preserving of meat',
  },
  {
    code: '1012',
    nl: 'Verwerking en conservering van gevogelte',
    fr: 'Transformation et conservation de la viande de volaille',
    en: 'Processing and preserving of poultry meat',
  },
  {
    code: '1013',
    nl: 'Vervaardiging van producten van vlees of van vlees van gevogelte',
    fr: 'Préparation de produits à base de viande ou de viande de volaille',
    en: 'Production of meat and poultry meat products',
  },
  {
    code: '1020',
    nl: 'Verwerking en conservering van vis en van schaal- en weekdieren',
    fr: 'Transformation et conservation de poisson, de crustacés et de mollusques',
    en: 'Processing and preserving of fish, crustaceans and molluscs',
  },
  {
    code: '1031',
    nl: 'Verwerking en conservering van aardappelen',
    fr: 'Transformation et conservation de pommes de terre',
    en: 'Processing and preserving of potatoes',
  },
  {
    code: '1032',
    nl: 'Vervaardiging van groente- en fruitsappen',
    fr: 'Préparation de jus de fruits et de légumes',
    en: 'Manufacture of fruit and vegetable juice',
  },
  {
    code: '1039',
    nl: 'Overige verwerking en conservering van groenten en fruit',
    fr: 'Autre transformation et conservation de fruits et de légumes',
    en: 'Other processing and preserving of fruit and vegetables',
  },
  {
    code: '1041',
    nl: 'Vervaardiging van oliën en vetten',
    fr: "Fabrication d'huiles et de graisses",
    en: 'Manufacture of oils and fats',
  },
  {
    code: '1042',
    nl: 'Vervaardiging van margarine en andere spijsvetten',
    fr: 'Fabrication de margarine et de graisses comestibles similaires',
    en: 'Manufacture of margarine and similar edible fats',
  },
  {
    code: '1051',
    nl: 'Zuivelfabrieken en kaasmakerijen',
    fr: 'Exploitation de laiteries et fabrication de fromage',
    en: 'Operation of dairies and cheese making',
  },
  {
    code: '1052',
    nl: 'Vervaardiging van consumptie-ijs',
    fr: 'Fabrication de glaces de consommation',
    en: 'Manufacture of ice cream',
  },
  {
    code: '1061',
    nl: 'Vervaardiging van maalderijproducten',
    fr: 'Travail des grains',
    en: 'Manufacture of grain mill products',
  },
  {
    code: '1062',
    nl: 'Vervaardiging van zetmeel en zetmeelproducten',
    fr: 'Fabrication de produits amylacés',
    en: 'Manufacture of starches and starch products',
  },
  {
    code: '1071',
    nl: 'Vervaardiging van brood en van vers banketbakkerswerk',
    fr: 'Fabrication de pain et de pâtisserie fraîche',
    en: 'Manufacture of bread; manufacture of fresh pastry goods and cakes',
  },
  {
    code: '1072',
    nl: 'Vervaardiging van beschuit en biscuit en van ander houdbaar banketbakkerswerk',
    fr: 'Fabrication de biscuits, de biscottes et de pâtisseries de conservation',
    en: 'Manufacture of rusks and biscuits; manufacture of preserved pastry goods and cakes',
  },
  {
    code: '1073',
    nl: 'Vervaardiging van macaroni, noedels, koeskoes en dergelijke deegwaren',
    fr: 'Fabrication de pâtes alimentaires',
    en: 'Manufacture of macaroni, noodles, couscous and similar farinaceous products',
  },
  {
    code: '1081',
    nl: 'Vervaardiging van suiker',
    fr: 'Fabrication de sucre',
    en: 'Manufacture of sugar',
  },
  {
    code: '1082',
    nl: 'Vervaardiging van cacao, chocolade en suikerwerk',
    fr: 'Fabrication de cacao, de chocolat et de produits de confiserie',
    en: 'Manufacture of cocoa, chocolate and sugar confectionery',
  },
  {
    code: '1083',
    nl: 'Verwerking van thee en koffie',
    fr: 'Transformation du thé et du café',
    en: 'Processing of tea and coffee',
  },
  {
    code: '1084',
    nl: 'Vervaardiging van specerijen, sauzen en kruiderijen',
    fr: "Fabrication de condiments et d'assaisonnements",
    en: 'Manufacture of condiments and seasonings',
  },
  {
    code: '1085',
    nl: 'Vervaardiging van bereide maaltijden en schotels',
    fr: 'Fabrication de plats préparés',
    en: 'Manufacture of prepared meals and dishes',
  },
  {
    code: '1086',
    nl: 'Vervaardiging van gehomogeniseerde voedingspreparaten en dieetvoeding',
    fr: "Fabrication d'aliments homogénéisés et diététiques",
    en: 'Manufacture of homogenised food preparations and dietetic food',
  },
  {
    code: '1089',
    nl: 'Vervaardiging van andere voedingsmiddelen, n.e.g.',
    fr: "Fabrication d'autres produits alimentaires n.c.a.",
    en: 'Manufacture of other food products n.e.c.',
  },
  {
    code: '1091',
    nl: 'Vervaardiging van veevoeders',
    fr: "Fabrication d'aliments pour animaux de ferme",
    en: 'Manufacture of prepared feeds for farm animals',
  },
  {
    code: '1092',
    nl: 'Vervaardiging van voeders voor huisdieren',
    fr: "Fabrication d'aliments pour animaux de compagnie",
    en: 'Manufacture of prepared pet foods',
  },
  {
    code: '1101',
    nl: 'Vervaardiging van gedistilleerde dranken door distilleren, rectificeren en mengen',
    fr: 'Production de boissons alcooliques distillées',
    en: 'Distilling, rectifying and blending of spirits',
  },
  {
    code: '1102',
    nl: 'Vervaardiging van wijn uit druiven',
    fr: 'Production de vin (de raisin)',
    en: 'Manufacture of wine from grape',
  },
  {
    code: '1103',
    nl: 'Vervaardiging van cider en van andere vruchtenwijnen',
    fr: "Fabrication de cidre et de vins d'autres fruits",
    en: 'Manufacture of cider and other fruit wines',
  },
  {
    code: '1104',
    nl: 'Vervaardiging van andere niet-gedistilleerde gegiste dranken',
    fr: "Production d'autres boissons fermentées non distillées",
    en: 'Manufacture of other non-distilled fermented beverages',
  },
  {
    code: '1105',
    nl: 'Vervaardiging van bier',
    fr: 'Fabrication de bière',
    en: 'Manufacture of beer',
  },
  {
    code: '1106',
    nl: 'Vervaardiging van mout',
    fr: 'Fabrication de malt',
    en: 'Manufacture of malt',
  },
  {
    code: '1107',
    nl: 'Vervaardiging van frisdranken; productie van mineraalwater en ander gebotteld water',
    fr: 'Industrie des eaux minérales et autres eaux embouteillées et des boissons rafraîchissantes',
    en: 'Manufacture of soft drinks; production of mineral waters and other bottled waters',
  },
  {
    code: '1200',
    nl: 'Vervaardiging van tabaksproducten',
    fr: 'Fabrication de produits à base de tabac',
    en: 'Manufacture of tobacco products',
  },
  {
    code: '1310',
    nl: 'Bewerken en spinnen van textielvezels',
    fr: 'Préparation de fibres textiles et filature',
    en: 'Preparation and spinning of textile fibres',
  },
  {
    code: '1320',
    nl: 'Weven van textiel',
    fr: 'Tissage',
    en: 'Weaving of textiles',
  },
  {
    code: '1330',
    nl: 'Textielveredeling',
    fr: 'Ennoblissement textile',
    en: 'Finishing of textiles',
  },
  {
    code: '1391',
    nl: 'Vervaardiging van gebreide en gehaakte stoffen',
    fr: "Fabrication d'étoffes à mailles",
    en: 'Manufacture of knitted and crocheted fabrics',
  },
  {
    code: '1392',
    nl: 'Vervaardiging van geconfectioneerde artikelen van textiel, exclusief kleding',
    fr: "Fabrication d'articles textiles confectionnés, sauf habillement",
    en: 'Manufacture of made-up textile articles, except apparel',
  },
  {
    code: '1393',
    nl: 'Vervaardiging van vloerkleden en tapijt',
    fr: 'Fabrication de tapis et de moquettes',
    en: 'Manufacture of carpets and rugs',
  },
  {
    code: '1394',
    nl: 'Vervaardiging van koord, bindgaren, touw en netten',
    fr: 'Fabrication de ficelles, de cordes et de filets',
    en: 'Manufacture of cordage, rope, twine and netting',
  },
  {
    code: '1395',
    nl: 'Vervaardiging van gebonden textielvlies en van artikelen van gebonden textielvlies, exclusief kleding',
    fr: 'Fabrication de non-tissés, sauf habillement',
    en: 'Manufacture of non-wovens and articles made from non-wovens, except apparel',
  },
  {
    code: '1396',
    nl: 'Vervaardiging van ander technisch en industrieel textiel',
    fr: "Fabrication d'autres textiles techniques et industriels",
    en: 'Manufacture of other technical and industrial textiles',
  },
  {
    code: '1399',
    nl: 'Vervaardiging van andere textielproducten, n.e.g.',
    fr: "Fabrication d'autres textiles n.c.a.",
    en: 'Manufacture of other textiles n.e.c.',
  },
  {
    code: '1411',
    nl: 'Vervaardiging van kleding van leer',
    fr: 'Fabrication de vêtements en cuir',
    en: 'Manufacture of leather clothes',
  },
  {
    code: '1412',
    nl: 'Vervaardiging van werkkleding',
    fr: 'Fabrication de vêtements de travail',
    en: 'Manufacture of workwear',
  },
  {
    code: '1413',
    nl: 'Vervaardiging van andere bovenkleding',
    fr: "Fabrication d'autres vêtements de dessus",
    en: 'Manufacture of other outerwear',
  },
  {
    code: '1414',
    nl: 'Vervaardiging van onderkleding',
    fr: 'Fabrication de vêtements de dessous',
    en: 'Manufacture of underwear',
  },
  {
    code: '1419',
    nl: 'Vervaardiging van andere kleding en toebehoren',
    fr: "Fabrication d'autres vêtements et accessoires",
    en: 'Manufacture of other wearing apparel and accessories',
  },
  {
    code: '1420',
    nl: 'Vervaardiging van artikelen van bont',
    fr: "Fabrication d'articles en fourrure",
    en: 'Manufacture of articles of fur',
  },
  {
    code: '1431',
    nl: 'Vervaardiging van gebreide en gehaakte kousen en sokken',
    fr: "Fabrication d'articles chaussants à mailles",
    en: 'Manufacture of knitted and crocheted hosiery',
  },
  {
    code: '1439',
    nl: 'Vervaardiging van andere gebreide en gehaakte kleding',
    fr: "Fabrication d'autres articles à mailles",
    en: 'Manufacture of other knitted and crocheted apparel',
  },
  {
    code: '1511',
    nl: 'Looien en bereiden van leer; bereiden en verven van bont',
    fr: 'Apprêt et tannage des cuirs; préparation et teinture des fourrures',
    en: 'Tanning and dressing of leather; dressing and dyeing of fur',
  },
  {
    code: '1512',
    nl: 'Vervaardiging van koffers, tassen en dergelijke en van zadel- en tuigmakerswerk',
    fr: "Fabrication d'articles de voyage, de maroquinerie et de sellerie",
    en: 'Manufacture of luggage, handbags and the like, saddlery and harness',
  },
  {
    code: '1520',
    nl: 'Vervaardiging van schoeisel',
    fr: 'Fabrication de chaussures',
    en: 'Manufacture of footwear',
  },
  {
    code: '1610',
    nl: 'Zagen en schaven van hout',
    fr: 'Sciage et rabotage du bois',
    en: 'Sawmilling and planing of wood',
  },
  {
    code: '1621',
    nl: 'Vervaardiging van fineer en van panelen op basis van hout',
    fr: 'Fabrication de placage et de panneaux de bois',
    en: 'Manufacture of veneer sheets and wood-based panels',
  },
  {
    code: '1622',
    nl: 'Vervaardiging van geassembleerde parketvloeren',
    fr: 'Fabrication de parquets assemblés',
    en: 'Manufacture of assembled parquet floors',
  },
  {
    code: '1623',
    nl: 'Vervaardiging van ander schrijn- en timmerwerk',
    fr: "Fabrication de charpentes et d'autres menuiseries",
    en: "Manufacture of other builders' carpentry and joinery",
  },
  {
    code: '1624',
    nl: 'Vervaardiging van houten emballage',
    fr: "Fabrication d'emballages en bois",
    en: 'Manufacture of wooden containers',
  },
  {
    code: '1629',
    nl: 'Vervaardiging van andere artikelen van hout; vervaardiging van artikelen van kurk, riet of vlechtwerk',
    fr: "Fabrication d'objets divers en bois; fabrication d'objets en liège, vannerie et sparterie",
    en: 'Manufacture of other products of wood; manufacture of articles of cork, straw and plaiting materials',
  },
  {
    code: '1711',
    nl: 'Vervaardiging van papierpulp',
    fr: 'Fabrication de pâte à papier',
    en: 'Manufacture of pulp',
  },
  {
    code: '1712',
    nl: 'Vervaardiging van papier en karton',
    fr: 'Fabrication de papier et de carton',
    en: 'Manufacture of paper and paperboard',
  },
  {
    code: '1721',
    nl: 'Vervaardiging van gegolfd papier en golfkarton en van verpakkingsmateriaal van papier en karton',
    fr: "Fabrication de papier et de carton ondulés et d'emballages en papier ou en carton",
    en: 'Manufacture of corrugated paper and paperboard and of containers of paper and paperboard',
  },
  {
    code: '1722',
    nl: 'Vervaardiging van huishoudelijke en sanitaire papierwaren',
    fr: "Fabrication d'articles en papier à usage sanitaire ou domestique",
    en: 'Manufacture of household and sanitary goods and of toilet requisites',
  },
  {
    code: '1723',
    nl: 'Vervaardiging van kantoorbenodigdheden van papier',
    fr: "Fabrication d'articles de papeterie",
    en: 'Manufacture of paper stationery',
  },
  {
    code: '1724',
    nl: 'Vervaardiging van behangpapier',
    fr: 'Fabrication de papiers peints',
    en: 'Manufacture of wallpaper',
  },
  {
    code: '1729',
    nl: 'Vervaardiging van andere artikelen van papier of karton',
    fr: "Fabrication d'autres articles en papier ou en carton",
    en: 'Manufacture of other articles of paper and paperboard',
  },
  {
    code: '1811',
    nl: 'Krantendrukkerijen',
    fr: 'Imprimerie de journaux',
    en: 'Printing of newspapers',
  },
  {
    code: '1812',
    nl: 'Overige drukkerijen',
    fr: 'Autre imprimerie (labeur)',
    en: 'Other printing',
  },
  {
    code: '1813',
    nl: 'Prepress- en premediadiensten',
    fr: 'Activités de prépresse',
    en: 'Pre-press and pre-media services',
  },
  {
    code: '1814',
    nl: 'Binderijen en aanverwante diensten',
    fr: 'Reliure et activités annexes',
    en: 'Binding and related services',
  },
  {
    code: '1820',
    nl: 'Reproductie van opgenomen media',
    fr: "Reproduction d'enregistrements",
    en: 'Reproduction of recorded media',
  },
  {
    code: '1910',
    nl: 'Vervaardiging van cokesovenproducten',
    fr: 'Cokéfaction',
    en: 'Manufacture of coke oven products',
  },
  {
    code: '1920',
    nl: 'Vervaardiging van geraffineerde aardolieproducten',
    fr: 'Raffinage du pétrole',
    en: 'Manufacture of refined petroleum products',
  },
  {
    code: '2011',
    nl: 'Vervaardiging van industriële gassen',
    fr: 'Fabrication de gaz industriels',
    en: 'Manufacture of industrial gases',
  },
  {
    code: '2012',
    nl: 'Vervaardiging van kleurstoffen en pigmenten',
    fr: 'Fabrication de colorants et de pigments',
    en: 'Manufacture of dyes and pigments',
  },
  {
    code: '2013',
    nl: 'Vervaardiging van andere anorganische chemische basisproducten',
    fr: "Fabrication d'autres produits chimiques inorganiques de base",
    en: 'Manufacture of other inorganic basic chemicals',
  },
  {
    code: '2014',
    nl: 'Vervaardiging van andere organische chemische basisproducten',
    fr: "Fabrication d'autres produits chimiques organiques de base",
    en: 'Manufacture of other organic basic chemicals',
  },
  {
    code: '2015',
    nl: 'Vervaardiging van kunstmeststoffen en stikstofverbindingen',
    fr: "Fabrication de produits azotés et d'engrais",
    en: 'Manufacture of fertilisers and nitrogen compounds',
  },
  {
    code: '2016',
    nl: 'Vervaardiging van kunststoffen in primaire vormen',
    fr: 'Fabrication de matières plastiques de base',
    en: 'Manufacture of plastics in primary forms',
  },
  {
    code: '2017',
    nl: 'Vervaardiging van synthetische rubber in primaire vormen',
    fr: 'Fabrication de caoutchouc synthétique',
    en: 'Manufacture of synthetic rubber in primary forms',
  },
  {
    code: '2020',
    nl: 'Vervaardiging van verdelgingsmiddelen en van andere chemische producten voor de landbouw',
    fr: "Fabrication de pesticides et d'autres produits agrochimiques",
    en: 'Manufacture of pesticides and other agrochemical products',
  },
  {
    code: '2030',
    nl: 'Vervaardiging van verf, vernis e.d., drukinkt en mastiek',
    fr: "Fabrication de peintures, de vernis, d'encres et de mastics",
    en: 'Manufacture of paints, varnishes and similar coatings, printing ink a mastics',
  },
  {
    code: '2041',
    nl: 'Vervaardiging van zeep en wasmiddelen, poets- en reinigingsmiddelen',
    fr: "Fabrication de savons, de détergents et de produits d'entretien",
    en: 'Manufacture of soap and detergents, cleaning and polishing preparations',
  },
  {
    code: '2042',
    nl: 'Vervaardiging van parfums en toiletartikelen',
    fr: 'Fabrication de parfums et de produits de toilette',
    en: 'Manufacture of perfumes and toilet preparations',
  },
  {
    code: '2051',
    nl: 'Vervaardiging van kruit en springstoffen',
    fr: 'Fabrication de produits explosifs',
    en: 'Manufacture of explosives',
  },
  {
    code: '2052',
    nl: 'Vervaardiging van lijm',
    fr: 'Fabrication de colles',
    en: 'Manufacture of glues',
  },
  {
    code: '2053',
    nl: 'Vervaardiging van etherische oliën',
    fr: "Fabrication d'huiles essentielles",
    en: 'Manufacture of essential oils',
  },
  {
    code: '2059',
    nl: 'Vervaardiging van andere chemische producten, n.e.g.',
    fr: "Fabrication d'autres produits chimiques n.c.a.",
    en: 'Manufacture of other chemical products n.e.c.',
  },
  {
    code: '2060',
    nl: 'Vervaardiging van synthetische en kunstmatige vezels',
    fr: 'Fabrication de fibres artificielles ou synthétiques',
    en: 'Manufacture of man-made fibres',
  },
  {
    code: '2110',
    nl: 'Vervaardiging van farmaceutische grondstoffen',
    fr: 'Fabrication de produits pharmaceutiques de base',
    en: 'Manufacture of basic pharmaceutical products',
  },
  {
    code: '2120',
    nl: 'Vervaardiging van farmaceutische producten',
    fr: 'Fabrication de préparations pharmaceutiques',
    en: 'Manufacture of pharmaceutical preparations',
  },
  {
    code: '2211',
    nl: 'Vervaardiging van binnen- en buitenbanden van rubber; loopvlakvernieuwing',
    fr: 'Fabrication et rechapage de pneumatiques',
    en: 'Manufacture of rubber tyres and tubes; retreading and rebuilding of rubber tyres',
  },
  {
    code: '2219',
    nl: 'Vervaardiging van andere producten van rubber',
    fr: "Fabrication d'autres articles en caoutchouc",
    en: 'Manufacture of other rubber products',
  },
  {
    code: '2221',
    nl: 'Vervaardiging van platen, vellen, buizen en profielen van kunststof',
    fr: 'Fabrication de plaques, feuilles, tubes et profilés en matières plastiques',
    en: 'Manufacture of plastic plates, sheets, tubes and profiles',
  },
  {
    code: '2222',
    nl: 'Vervaardiging van verpakkingsmateriaal van kunststof',
    fr: "Fabrication d'emballages en matières plastiques",
    en: 'Manufacture of plastic packing goods',
  },
  {
    code: '2223',
    nl: 'Vervaardiging van kunststofartikelen voor de bouw',
    fr: "Fabrication d'éléments en matières plastiques pour la construction",
    en: "Manufacture of builders' ware of plastic",
  },
  {
    code: '2229',
    nl: 'Vervaardiging van andere producten van kunststof',
    fr: "Fabrication d'autres articles en matières plastiques",
    en: 'Manufacture of other plastic products',
  },
  {
    code: '2311',
    nl: 'Vervaardiging van vlakglas',
    fr: 'Fabrication de verre plat',
    en: 'Manufacture of flat glass',
  },
  {
    code: '2312',
    nl: 'Vormen en bewerken van vlakglas',
    fr: 'Façonnage et transformation du verre plat',
    en: 'Shaping and processing of flat glass',
  },
  {
    code: '2313',
    nl: 'Vervaardiging van holglas',
    fr: 'Fabrication de verre creux',
    en: 'Manufacture of hollow glass',
  },
  {
    code: '2314',
    nl: 'Vervaardiging van glasvezels',
    fr: 'Fabrication de fibres de verre',
    en: 'Manufacture of glass fibres',
  },
  {
    code: '2319',
    nl: 'Vervaardiging en bewerking van ander glas (inclusief technisch glaswerk)',
    fr: "Fabrication et façonnage d'autres articles en verre, y compris verre technique",
    en: 'Manufacture and processing of other glass, including technical glassware',
  },
  {
    code: '2320',
    nl: 'Vervaardiging van vuurvaste producten',
    fr: 'Fabrication de produits réfractaires',
    en: 'Manufacture of refractory products',
  },
  {
    code: '2331',
    nl: 'Vervaardiging van keramische tegels en plavuizen',
    fr: 'Fabrication de carreaux en céramique',
    en: 'Manufacture of ceramic tiles and flags',
  },
  {
    code: '2332',
    nl: 'Vervaardiging van bakstenen, tegels en producten voor de bouw van gebakken klei',
    fr: 'Fabrication de briques, de tuiles et de produits de construction en terre cuite',
    en: 'Manufacture of bricks, tiles and construction products, in baked clay',
  },
  {
    code: '2341',
    nl: 'Vervaardiging van huishoudelijk en sieraardewerk',
    fr: "Fabrication d'articles céramiques à usage domestique ou ornemental",
    en: 'Manufacture of ceramic household and ornamental articles',
  },
  {
    code: '2342',
    nl: 'Vervaardiging van sanitair aardewerk',
    fr: "Fabrication d'appareils sanitaires en céramique",
    en: 'Manufacture of ceramic sanitary fixtures',
  },
  {
    code: '2343',
    nl: 'Vervaardiging van isolatoren en isolatiemateriaal, van keramische stoffen',
    fr: "Fabrication d'isolateurs et de pièces isolantes en céramique",
    en: 'Manufacture of ceramic insulators and insulating fittings',
  },
  {
    code: '2344',
    nl: 'Vervaardiging van ander technisch aardewerk',
    fr: "Fabrication d'autres produits céramiques à usage technique",
    en: 'Manufacture of other technical ceramic products',
  },
  {
    code: '2349',
    nl: 'Vervaardiging van andere keramische producten',
    fr: "Fabrication d'autres produits céramiques",
    en: 'Manufacture of other ceramic products',
  },
  {
    code: '2351',
    nl: 'Vervaardiging van cement',
    fr: 'Fabrication de ciment',
    en: 'Manufacture of cement',
  },
  {
    code: '2352',
    nl: 'Vervaardiging van kalk en gips',
    fr: 'Fabrication de chaux et de plâtre',
    en: 'Manufacture of lime and plaster',
  },
  {
    code: '2361',
    nl: 'Vervaardiging van artikelen van beton voor de bouw',
    fr: "Fabrication d'éléments en béton pour la construction",
    en: 'Manufacture of concrete products for construction purposes',
  },
  {
    code: '2362',
    nl: 'Vervaardiging van artikelen van gips voor de bouw',
    fr: "Fabrication d'éléments en plâtre pour la construction",
    en: 'Manufacture of plaster products for construction purposes',
  },
  {
    code: '2363',
    nl: 'Vervaardiging van stortklare beton',
    fr: "Fabrication de béton prêt à l'emploi",
    en: 'Manufacture of ready-mixed concrete',
  },
  {
    code: '2364',
    nl: 'Vervaardiging van mortel',
    fr: 'Fabrication de mortiers et de bétons secs',
    en: 'Manufacture of mortars',
  },
  {
    code: '2365',
    nl: 'Vervaardiging van producten van vezelcement',
    fr: "Fabrication d'ouvrages en fibre-ciment",
    en: 'Manufacture of fibre cement',
  },
  {
    code: '2369',
    nl: 'Vervaardiging van andere artikelen van beton, gips en cement',
    fr: "Fabrication d'autres ouvrages en béton, en ciment ou en plâtre",
    en: 'Manufacture of other articles of concrete, plaster and cement',
  },
  {
    code: '2370',
    nl: 'Houwen, bewerken en afwerken van natuursteen',
    fr: 'Taille, façonnage et finissage de pierres',
    en: 'Cutting, shaping and finishing of stone',
  },
  {
    code: '2391',
    nl: 'Vervaardiging van schuur-, slijp- en polijstmiddelen',
    fr: 'Fabrication de produits abrasifs',
    en: 'Production of abrasive products',
  },
  {
    code: '2399',
    nl: 'Vervaardiging van andere niet-metaalhoudende minerale producten, n.e.g.',
    fr: "Fabrication d'autres produits minéraux non métalliques n.c.a.",
    en: 'Manufacture of other non-metallic mineral products n.e.c.',
  },
  {
    code: '2410',
    nl: 'Vervaardiging van ijzer en staal en van ferrolegeringen',
    fr: 'Sidérurgie',
    en: 'Manufacture of basic iron and steel and of ferro-alloys',
  },
  {
    code: '2420',
    nl: 'Vervaardiging van buizen, pijpen, holle profielen en fittings daarvoor, van staal',
    fr: "Fabrication de tubes, de tuyaux, de profilés creux et d'accessoires correspondants en acier",
    en: 'Manufacture of tubes, pipes, hollow profiles and related fittings, of steel',
  },
  {
    code: '2431',
    nl: 'Koudtrekken van staven',
    fr: 'Étirage à froid de barres',
    en: 'Cold drawing of bars',
  },
  {
    code: '2432',
    nl: 'Koudwalsen van bandstaal',
    fr: 'Laminage à froid de feuillards',
    en: 'Cold rolling of narrow strip',
  },
  {
    code: '2433',
    nl: 'Koudvervormen of koudfelsen',
    fr: 'Profilage à froid par formage ou pliage',
    en: 'Cold forming or folding',
  },
  {
    code: '2434',
    nl: 'Koudtrekken van draad',
    fr: 'Tréfilage à froid',
    en: 'Cold drawing of wire',
  },
  {
    code: '2441',
    nl: 'Productie van edelmetalen',
    fr: 'Production de métaux précieux',
    en: 'Precious metals production',
  },
  {
    code: '2442',
    nl: 'Productie van aluminium',
    fr: "Métallurgie de l'aluminium",
    en: 'Aluminium production',
  },
  {
    code: '2443',
    nl: 'Productie van lood, zink en tin',
    fr: "Métallurgie du plomb, du zinc ou de l'étain",
    en: 'Lead, zinc and tin production',
  },
  {
    code: '2444',
    nl: 'Productie van koper',
    fr: 'Métallurgie du cuivre',
    en: 'Copper production',
  },
  {
    code: '2445',
    nl: 'Productie van andere non-ferrometalen',
    fr: 'Métallurgie des autres métaux non ferreux',
    en: 'Other non-ferrous metal production',
  },
  {
    code: '2446',
    nl: 'Bewerking van splijt- en kweekstoffen',
    fr: 'Élaboration et transformation de matières nucléaires',
    en: 'Processing of nuclear fuel',
  },
  {
    code: '2451',
    nl: 'Gieten van ijzer',
    fr: 'Fonderie de fonte',
    en: 'Casting of iron',
  },
  {
    code: '2452',
    nl: 'Gieten van staal',
    fr: "Fonderie d'acier",
    en: 'Casting of steel',
  },
  {
    code: '2453',
    nl: 'Gieten van lichte metalen',
    fr: 'Fonderie de métaux légers',
    en: 'Casting of light metals',
  },
  {
    code: '2454',
    nl: 'Gieten van andere non-ferrometalen',
    fr: "Fonderie d'autres métaux non ferreux",
    en: 'Casting of other non-ferrous metals',
  },
  {
    code: '2511',
    nl: 'Vervaardiging van metalen constructiewerken en delen daarvan',
    fr: 'Fabrication de structures métalliques et de parties de structures',
    en: 'Manufacture of metal structures and parts of structures',
  },
  {
    code: '2512',
    nl: 'Vervaardiging van metalen deuren en vensters',
    fr: 'Fabrication de portes et de fenêtres en métal',
    en: 'Manufacture of doors and windows of metal',
  },
  {
    code: '2521',
    nl: 'Vervaardiging van radiatoren en ketels voor centrale verwarming',
    fr: 'Fabrication de radiateurs et de chaudières pour le chauffage central',
    en: 'Manufacture of central heating radiators and boilers',
  },
  {
    code: '2529',
    nl: 'Vervaardiging van andere tanks, reservoirs en bergingsmiddelen, van metaal',
    fr: "Fabrication d'autres réservoirs, citernes et conteneurs métalliques",
    en: 'Manufacture of other tanks, reservoirs and containers of metal',
  },
  {
    code: '2530',
    nl: 'Vervaardiging van stoomketels, exclusief warmwaterketels voor centrale verwarming',
    fr: "Fabrication de générateurs de vapeur, à l'exception des chaudières pour le chauffage central",
    en: 'Manufacture of steam generators, except central heating hot water boilers',
  },
  {
    code: '2540',
    nl: 'Vervaardiging van wapens en munitie',
    fr: "Fabrication d'armes et de munitions",
    en: 'Manufacture of weapons and ammunition',
  },
  {
    code: '2550',
    nl: 'Smeden, persen, stampen en profielwalsen van metaal; poedermetallurgie',
    fr: 'Forge, emboutissage, estampage des métaux; métallurgie des poudres',
    en: 'Forging, pressing, stamping and roll-forming of metal; powder metallurgy',
  },
  {
    code: '2561',
    nl: 'Oppervlaktebehandeling van metalen',
    fr: 'Traitement et revêtement des métaux',
    en: 'Treatment and coating of metals',
  },
  {
    code: '2562',
    nl: 'Verspanend bewerken van metalen',
    fr: 'Usinage',
    en: 'Machining',
  },
  {
    code: '2571',
    nl: 'Vervaardiging van scharen, messen, bestekken, enz.',
    fr: 'Fabrication de coutellerie',
    en: 'Manufacture of cutlery',
  },
  {
    code: '2572',
    nl: 'Vervaardiging van hang- en sluitwerk',
    fr: 'Fabrication de serrures et de ferrures',
    en: 'Manufacture of locks and hinges',
  },
  {
    code: '2573',
    nl: 'Vervaardiging van gereedschap',
    fr: "Fabrication d'outillage",
    en: 'Manufacture of tools',
  },
  {
    code: '2591',
    nl: 'Vervaardiging van stalen vaten en dergelijke',
    fr: "Fabrication de fûts et d'emballages métalliques similaires",
    en: 'Manufacture of steel drums and similar containers',
  },
  {
    code: '2592',
    nl: 'Vervaardiging van verpakkingsmiddelen van licht metaal',
    fr: "Fabrication d'emballages métalliques légers",
    en: 'Manufacture of light metal packaging',
  },
  {
    code: '2593',
    nl: 'Vervaardiging van artikelen van draad en van kettingen en veren',
    fr: "Fabrication d'articles en fils métalliques, de chaînes et de ressorts",
    en: 'Manufacture of wire products, chain and springs',
  },
  {
    code: '2594',
    nl: 'Vervaardiging van bouten, schroeven en moeren',
    fr: 'Fabrication de vis et de boulons',
    en: 'Manufacture of fasteners and screw machine products',
  },
  {
    code: '2599',
    nl: 'Vervaardiging van andere producten van metaal, n.e.g.',
    fr: "Fabrication d'autres produits métalliques n.c.a.",
    en: 'Manufacture of other fabricated metal products n.e.c.',
  },
  {
    code: '2611',
    nl: 'Vervaardiging van elektronische onderdelen',
    fr: 'Fabrication de composants électroniques',
    en: 'Manufacture of electronic components',
  },
  {
    code: '2612',
    nl: 'Vervaardiging van elektronische printplaten',
    fr: 'Fabrication de cartes électroniques assemblées',
    en: 'Manufacture of loaded electronic boards',
  },
  {
    code: '2620',
    nl: 'Vervaardiging van computers en randapparatuur',
    fr: "Fabrication d'ordinateurs et d'équipements périphériques",
    en: 'Manufacture of computers and peripheral equipment',
  },
  {
    code: '2630',
    nl: 'Vervaardiging van communicatieapparatuur',
    fr: "Fabrication d'équipements de communication",
    en: 'Manufacture of communication equipment',
  },
  {
    code: '2640',
    nl: 'Vervaardiging van consumentenelektronica',
    fr: 'Fabrication de produits électroniques grand public',
    en: 'Manufacture of consumer electronics',
  },
  {
    code: '2651',
    nl: 'Vervaardiging van meet-, controle- en navigatie-instrumenten en -apparatuur',
    fr: "Fabrication d'instruments et d'appareils de mesure, d'essai et de navigation",
    en: 'Manufacture of instruments and appliances for measuring, testing and navigation',
  },
  {
    code: '2652',
    nl: 'Vervaardiging van uurwerken',
    fr: 'Horlogerie',
    en: 'Manufacture of watches and clocks',
  },
  {
    code: '2660',
    nl: 'Vervaardiging van bestralingsapparatuur en van elektromedische en elektrotherapeutische apparatuur',
    fr: "Fabrication d'équipements d'irradiation médicale, d'équipements électromédicaux et électrothérapeutiques",
    en: 'Manufacture of irradiation, electromedical and electrotherapeutic equipment',
  },
  {
    code: '2670',
    nl: 'Vervaardiging van optische instrumenten en van foto- en filmapparatuur',
    fr: 'Fabrication de matériels optiques et photographiques',
    en: 'Manufacture of optical instruments and photographic equipment',
  },
  {
    code: '2680',
    nl: 'Vervaardiging van magnetische en optische media',
    fr: 'Fabrication de supports magnétiques et optiques',
    en: 'Manufacture of magnetic and optical media',
  },
  {
    code: '2711',
    nl: 'Vervaardiging van elektromotoren en van elektrische generatoren en transformatoren',
    fr: 'Fabrication de moteurs, de génératrices et de transformateurs électriques',
    en: 'Manufacture of electric motors, generators and transformers',
  },
  {
    code: '2712',
    nl: 'Vervaardiging van schakel- en verdeelinrichtingen',
    fr: 'Fabrication de matériel de distribution et de commande électrique',
    en: 'Manufacture of electricity distribution and control apparatus',
  },
  {
    code: '2720',
    nl: 'Vervaardiging van batterijen en accumulatoren',
    fr: "Fabrication de piles et d'accumulateurs électriques",
    en: 'Manufacture of batteries and accumulators',
  },
  {
    code: '2731',
    nl: 'Vervaardiging van kabels van optische vezels',
    fr: 'Fabrication de câbles de fibres optiques',
    en: 'Manufacture of fibre optic cables',
  },
  {
    code: '2732',
    nl: 'Vervaardiging van andere elektrische en elektronische kabels',
    fr: "Fabrication d'autres fils et de câbles électroniques ou électriques",
    en: 'Manufacture of other electronic and electric wires and cables',
  },
  {
    code: '2733',
    nl: 'Vervaardiging van schakelaars, stekkers, stopcontacten e.d.',
    fr: "Fabrication de matériel d'installation électrique",
    en: 'Manufacture of wiring devices',
  },
  {
    code: '2740',
    nl: 'Vervaardiging van lampen en verlichtingsapparaten',
    fr: "Fabrication de lampes et d'appareils d'éclairage électrique",
    en: 'Manufacture of electric lighting equipment',
  },
  {
    code: '2751',
    nl: 'Vervaardiging van elektrische huishoudapparaten',
    fr: "Fabrication d'appareils électroménagers",
    en: 'Manufacture of electric domestic appliances',
  },
  {
    code: '2752',
    nl: 'Vervaardiging van niet-elektrische huishoudapparaten',
    fr: "Fabrication d'appareils ménagers non électriques",
    en: 'Manufacture of non-electric domestic appliances',
  },
  {
    code: '2790',
    nl: 'Vervaardiging van andere elektrische apparatuur',
    fr: "Fabrication d'autres matériels électriques",
    en: 'Manufacture of other electrical equipment',
  },
  {
    code: '2811',
    nl: 'Vervaardiging van motoren en turbines, exclusief motoren voor luchtvaartuigen, motorvoertuigen en bromfietsen',
    fr: "Fabrication de moteurs et de turbines, à l'exception des moteurs d'avions, de véhicules automobiles et de motocycles",
    en: 'Manufacture of engines and turbines, except aircraft, vehicle and cyclengines',
  },
  {
    code: '2812',
    nl: 'Vervaardiging van hydraulische apparatuur',
    fr: "Fabrication d'équipements hydrauliques et pneumatiques",
    en: 'Manufacture of fluid power equipment',
  },
  {
    code: '2813',
    nl: 'Vervaardiging van andere pompen en compressoren',
    fr: "Fabrication d'autres pompes et de compresseurs",
    en: 'Manufacture of other pumps and compressors',
  },
  {
    code: '2814',
    nl: 'Vervaardiging van andere kranen en dergelijke artikelen',
    fr: "Fabrication d'autres articles de robinetterie",
    en: 'Manufacture of other taps and valves',
  },
  {
    code: '2815',
    nl: 'Vervaardiging van tandwielen, lagers en andere drijfwerkelementen',
    fr: "Fabrication d'engrenages et d'organes mécaniques de transmission",
    en: 'Manufacture of bearings, gears, gearing and driving elements',
  },
  {
    code: '2821',
    nl: 'Vervaardiging van ovens en branders',
    fr: 'Fabrication de fours et de brûleurs',
    en: 'Manufacture of ovens, furnaces and furnace burners',
  },
  {
    code: '2822',
    nl: 'Vervaardiging van hijs-, hef- en transportwerktuigen',
    fr: 'Fabrication de matériel de levage et de manutention',
    en: 'Manufacture of lifting and handling equipment',
  },
  {
    code: '2823',
    nl: 'Vervaardiging van kantoormachines en -uitrusting (exclusief compu-ters en randapparatuur)',
    fr: "Fabrication de machines et d'équipements de bureau (à l'exception des ordinateurs et des équipements périphériques)",
    en: 'Manufacture of office machinery and equipment (except computers and peripheral equipment)',
  },
  {
    code: '2824',
    nl: 'Vervaardiging van elektrisch handgereedschap',
    fr: "Fabrication d'outillage portatif à moteur incorporé",
    en: 'Manufacture of power-driven hand tools',
  },
  {
    code: '2825',
    nl: 'Vervaardiging van machines en apparaten voor de koeltechniek en de klimaatregeling, voor niet-huishoudelijk gebruik',
    fr: "Fabrication d'équipements aérauliques et frigorifiques industriels",
    en: 'Manufacture of non-domestic cooling and ventilation equipment',
  },
  {
    code: '2829',
    nl: 'Vervaardiging van andere machines en apparaten voor algemeen gebruik, n.e.g.',
    fr: "Fabrication de machines diverses d'usage général",
    en: 'Manufacture of other general-purpose machinery n.e.c.',
  },
  {
    code: '2830',
    nl: 'Vervaardiging van machines en werktuigen voor de landbouw en de bosbouw',
    fr: 'Fabrication de machines agricoles et forestières',
    en: 'Manufacture of agricultural and forestry machinery',
  },
  {
    code: '2841',
    nl: 'Vervaardiging van machines voor de metaalbewerking',
    fr: 'Fabrication de machines de formage des métaux',
    en: 'Manufacture of metal forming machinery',
  },
  {
    code: '2849',
    nl: 'Vervaardiging van andere gereedschapswerktuigen',
    fr: "Fabrication d'autres machines-outils",
    en: 'Manufacture of other machine tools',
  },
  {
    code: '2891',
    nl: 'Vervaardiging van machines voor de metallurgie',
    fr: 'Fabrication de machines pour la métallurgie',
    en: 'Manufacture of machinery for metallurgy',
  },
  {
    code: '2892',
    nl: 'Vervaardiging van machines voor de winning van delfstoffen en voor de bouw',
    fr: "Fabrication de machines pour l'extraction ou la construction",
    en: 'Manufacture of machinery for mining, quarrying and construction',
  },
  {
    code: '2893',
    nl: 'Vervaardiging van machines voor de productie van voedings- en genotmiddelen',
    fr: "Fabrication de machines pour l'industrie agro-alimentaire",
    en: 'Manufacture of machinery for food, beverage and tobacco processing',
  },
  {
    code: '2894',
    nl: 'Vervaardiging van machines voor de productie van textiel, kleding en leer',
    fr: 'Fabrication de machines pour les industries textiles',
    en: 'Manufacture of machinery for textile, apparel and leather production',
  },
  {
    code: '2895',
    nl: 'Vervaardiging van machines voor de productie van papier en karton',
    fr: 'Fabrication de machines pour les industries du papier et du carton',
    en: 'Manufacture of machinery for paper and paperboard production',
  },
  {
    code: '2896',
    nl: 'Vervaardiging van machines voor de kunststof- en rubberindustrie',
    fr: 'Fabrication de machines pour le travail du caoutchouc ou des plastiques',
    en: 'Manufacture of plastic and rubber machinery',
  },
  {
    code: '2899',
    nl: 'Vervaardiging van andere machines, apparaten en werktuigen voor specifieke doeleinden, n.e.g.',
    fr: "Fabrication d'autres machines d'usage spécifique n.c.a.",
    en: 'Manufacture of other special-purpose machinery n.e.c.',
  },
  {
    code: '2910',
    nl: 'Vervaardiging en assemblage van motorvoertuigen',
    fr: 'Construction et assemblage de véhicules automobiles',
    en: 'Manufacture of motor vehicles',
  },
  {
    code: '2920',
    nl: 'Vervaardiging van carrosserieën voor motorvoertuigen; vervaardiging van aanhangwagens en opleggers',
    fr: 'Fabrication de carrosseries de véhicules automobiles; fabrication de remorques et de semi-remorques',
    en: 'Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi-trailers',
  },
  {
    code: '2931',
    nl: 'Vervaardiging van elektrische en elektronische benodigdheden voor motorvoertuigen',
    fr: "Fabrication d'équipements électriques et électroniques pour véhicules automobiles",
    en: 'Manufacture of electrical and electronic equipment for motor vehicles',
  },
  {
    code: '2932',
    nl: 'Vervaardiging van andere delen en toebehoren van motorvoertuigen',
    fr: "Fabrication d'autres équipements pour véhicules automobiles",
    en: 'Manufacture of other parts and accessories for motor vehicles',
  },
  {
    code: '3011',
    nl: 'Bouw van schepen en drijvend materieel',
    fr: 'Construction de navires et de structures flottantes',
    en: 'Building of ships and floating structures',
  },
  {
    code: '3012',
    nl: 'Bouw van plezier- en sportvaartuigen',
    fr: 'Construction de bateaux de plaisance',
    en: 'Building of pleasure and sporting boats',
  },
  {
    code: '3020',
    nl: 'Vervaardiging van rollend materieel voor spoorwegen',
    fr: "Construction de locomotives et d'autre matériel ferroviaire roulant",
    en: 'Manufacture of railway locomotives and rolling stock',
  },
  {
    code: '3030',
    nl: 'Vervaardiging van lucht- en ruimtevaartuigen en van toestellen in verband daarmee',
    fr: 'Construction aéronautique et spatiale',
    en: 'Manufacture of air and spacecraft and related machinery',
  },
  {
    code: '3040',
    nl: 'Vervaardiging van militaire gevechtsvoertuigen',
    fr: 'Construction de véhicules militaires de combat',
    en: 'Manufacture of military fighting vehicles',
  },
  {
    code: '3091',
    nl: 'Vervaardiging van motorfietsen',
    fr: 'Fabrication de motocycles',
    en: 'Manufacture of motorcycles',
  },
  {
    code: '3092',
    nl: 'Vervaardiging van fietsen en invalidenwagens',
    fr: 'Fabrication de bicyclettes et de véhicules pour invalides',
    en: 'Manufacture of bicycles and invalid carriages',
  },
  {
    code: '3099',
    nl: 'Vervaardiging van andere transportmiddelen, n.e.g.',
    fr: "Fabrication d'autres équipements de transport n.c.a.",
    en: 'Manufacture of other transport equipment n.e.c.',
  },
  {
    code: '3101',
    nl: 'Vervaardiging van kantoor- en winkelmeubelen',
    fr: 'Fabrication de meubles de bureau et de magasin',
    en: 'Manufacture of office and shop furniture',
  },
  {
    code: '3102',
    nl: 'Vervaardiging van keukenmeubelen',
    fr: 'Fabrication de meubles de cuisine',
    en: 'Manufacture of kitchen furniture',
  },
  {
    code: '3103',
    nl: 'Vervaardiging van matrassen',
    fr: 'Fabrication de matelas',
    en: 'Manufacture of mattresses',
  },
  {
    code: '3109',
    nl: 'Vervaardiging van andere meubelen',
    fr: "Fabrication d'autres meubles",
    en: 'Manufacture of other furniture',
  },
  {
    code: '3211',
    nl: 'Slaan van munten',
    fr: 'Frappe de monnaie',
    en: 'Striking of coins',
  },
  {
    code: '3212',
    nl: 'Bewerken van edelstenen en vervaardiging van sieraden',
    fr: "Travail des pierres précieuses; fabrication d'articles de joaillerie et de bijouterie",
    en: 'Manufacture of jewellery and related articles',
  },
  {
    code: '3213',
    nl: 'Vervaardiging van imitatiesieraden en dergelijke artikelen',
    fr: "Fabrication d'articles de bijouterie de fantaisie et d'articles similaires",
    en: 'Manufacture of imitation jewellery and related articles',
  },
  {
    code: '3220',
    nl: 'Vervaardiging van muziekinstrumenten',
    fr: "Fabrication d'instruments de musique",
    en: 'Manufacture of musical instruments',
  },
  {
    code: '3230',
    nl: 'Vervaardiging van sportartikelen',
    fr: "Fabrication d'articles de sport",
    en: 'Manufacture of sports goods',
  },
  {
    code: '3240',
    nl: 'Vervaardiging van spellen en speelgoed',
    fr: 'Fabrication de jeux et de jouets',
    en: 'Manufacture of games and toys',
  },
  {
    code: '3250',
    nl: 'Vervaardiging van medische en tandheelkundige instrumenten en benodigdheden',
    fr: "Fabrication d'instruments et de fournitures à usage médical et dentaire",
    en: 'Manufacture of medical and dental instruments and supplies',
  },
  {
    code: '3291',
    nl: 'Vervaardiging van borstelwaren',
    fr: "Fabrication d'articles de brosserie",
    en: 'Manufacture of brooms and brushes',
  },
  {
    code: '3299',
    nl: 'Overige industrie, n.e.g.',
    fr: 'Autres activités manufacturières n.c.a.',
    en: 'Other manufacturing n.e.c.',
  },
  {
    code: '3311',
    nl: 'Reparatie van producten van metaal',
    fr: "Réparation d'ouvrages en métaux",
    en: 'Repair of fabricated metal products',
  },
  {
    code: '3312',
    nl: 'Reparatie van machines',
    fr: 'Réparation de machines',
    en: 'Repair of machinery',
  },
  {
    code: '3313',
    nl: 'Reparatie van elektronische en optische apparatuur',
    fr: 'Réparation de matériels électroniques et optiques',
    en: 'Repair of electronic and optical equipment',
  },
  {
    code: '3314',
    nl: 'Reparatie van elektrische apparatuur',
    fr: "Réparation d'équipements électriques",
    en: 'Repair of electrical equipment',
  },
  {
    code: '3315',
    nl: 'Reparatie en onderhoud van schepen',
    fr: 'Réparation et maintenance navale',
    en: 'Repair and maintenance of ships and boats',
  },
  {
    code: '3316',
    nl: 'Reparatie en onderhoud van lucht- en ruimtevaartuigen',
    fr: "Réparation et maintenance d'aéronefs et d'engins spatiaux",
    en: 'Repair and maintenance of aircraft and spacecraft',
  },
  {
    code: '3317',
    nl: 'Reparatie en onderhoud van andere transportmiddelen',
    fr: "Réparation et maintenance d'autres équipements de transport",
    en: 'Repair and maintenance of other transport equipment',
  },
  {
    code: '3319',
    nl: 'Reparatie van andere apparatuur',
    fr: "Réparation d'autres équipements",
    en: 'Repair of other equipment',
  },
  {
    code: '3320',
    nl: 'Installatie van industriële machines, toestellen en werktuigen',
    fr: "Installation de machines et d'équipements industriels",
    en: 'Installation of industrial machinery and equipment',
  },
  {
    code: '3511',
    nl: 'Productie van elektriciteit',
    fr: "Production d'électricité",
    en: 'Production of electricity',
  },
  {
    code: '3512',
    nl: 'Transmissie van elektriciteit',
    fr: "Transport d'électricité",
    en: 'Transmission of electricity',
  },
  {
    code: '3513',
    nl: 'Distributie van elektriciteit',
    fr: "Distribution d'électricité",
    en: 'Distribution of electricity',
  },
  {
    code: '3514',
    nl: 'Handel in elektriciteit',
    fr: "Commerce d'électricité",
    en: 'Trade of electricity',
  },
  {
    code: '3521',
    nl: 'Productie van gas',
    fr: 'Production de combustibles gazeux',
    en: 'Manufacture of gas',
  },
  {
    code: '3522',
    nl: 'Distributie van gasvormige brandstoffen via leidingen',
    fr: 'Distribution de combustibles gazeux par conduites',
    en: 'Distribution of gaseous fuels through mains',
  },
  {
    code: '3523',
    nl: 'Handel in gas via leidingen',
    fr: 'Commerce de combustibles gazeux par conduites',
    en: 'Trade of gas through mains',
  },
  {
    code: '3530',
    nl: 'Productie en distributie van stoom en gekoelde lucht',
    fr: "Production et distribution de vapeur et d'air conditionné",
    en: 'Steam and air conditioning supply',
  },
  {
    code: '3600',
    nl: 'Winning, behandeling en distributie van water',
    fr: "Captage, traitement et distribution d'eau",
    en: 'Water collection, treatment and supply',
  },
  {
    code: '3700',
    nl: 'Afvalwaterafvoer',
    fr: 'Collecte et traitement des eaux usées',
    en: 'Sewerage',
  },
  {
    code: '3811',
    nl: 'Inzameling van ongevaarlijk afval',
    fr: 'Collecte des déchets non dangereux',
    en: 'Collection of non-hazardous waste',
  },
  {
    code: '3812',
    nl: 'Inzameling van gevaarlijk afval',
    fr: 'Collecte des déchets dangereux',
    en: 'Collection of hazardous waste',
  },
  {
    code: '3821',
    nl: 'Verwerking en verwijdering van ongevaarlijk afval',
    fr: 'Traitement et élimination des déchets non dangereux',
    en: 'Treatment and disposal of non-hazardous waste',
  },
  {
    code: '3822',
    nl: 'Verwerking en verwijdering van gevaarlijk afval',
    fr: 'Traitement et élimination des déchets dangereux',
    en: 'Treatment and disposal of hazardous waste',
  },
  {
    code: '3831',
    nl: 'Sloop van wrakken',
    fr: "Démantèlement d'épaves",
    en: 'Dismantling of wrecks',
  },
  {
    code: '3832',
    nl: 'Terugwinning van gesorteerd materiaal',
    fr: 'Récupération de déchets triés',
    en: 'Recovery of sorted materials',
  },
  {
    code: '3900',
    nl: 'Sanering en ander afvalbeheer',
    fr: 'Dépollution et autres services de gestion des déchets',
    en: 'Remediation activities and other waste management services',
  },
  {
    code: '4110',
    nl: 'Ontwikkeling van bouwprojecten',
    fr: 'Promotion immobilière',
    en: 'Development of building projects',
  },
  {
    code: '4120',
    nl: 'Burgerlijke en utiliteitsbouw',
    fr: 'Construction de bâtiments résidentiels et non résidentiels',
    en: 'Construction of residential and non-residential buildings',
  },
  {
    code: '4211',
    nl: 'Bouw van autowegen en andere wegen',
    fr: "Construction de routes et d'autoroutes",
    en: 'Construction of roads and motorways',
  },
  {
    code: '4212',
    nl: 'Bouw van boven- en ondergrondse spoorwegen',
    fr: 'Construction de voies ferrées de surface et souterraines',
    en: 'Construction of railways and underground railways',
  },
  {
    code: '4213',
    nl: 'Bouw van bruggen en tunnels',
    fr: 'Construction de ponts et de tunnels',
    en: 'Construction of bridges and tunnels',
  },
  {
    code: '4221',
    nl: 'Bouw van civieltechnische werken voor vloeistoffen',
    fr: 'Construction de réseaux pour fluides',
    en: 'Construction of utility projects for fluids',
  },
  {
    code: '4222',
    nl: 'Bouw van civieltechnische werken voor elektriciteit en telecommunicatie',
    fr: 'Construction de réseaux électriques et de télécommunications',
    en: 'Construction of utility projects for electricity and telecommunicatio',
  },
  {
    code: '4291',
    nl: 'Waterbouw',
    fr: "Construction d'ouvrages maritimes et fluviaux",
    en: 'Construction of water projects',
  },
  {
    code: '4299',
    nl: 'Bouw van andere civieltechnische werken, n.e.g.',
    fr: "Construction d'autres ouvrages de génie civil n.c.a.",
    en: 'Construction of other civil engineering projects n.e.c.',
  },
  { code: '4311', nl: 'Slopen', fr: 'Travaux de démolition', en: 'Demolition' },
  {
    code: '4312',
    nl: 'Bouwrijp maken van terreinen',
    fr: 'Travaux de préparation des sites',
    en: 'Site preparation',
  },
  {
    code: '4313',
    nl: 'Proefboren en boren',
    fr: "Forages d'essai et sondages",
    en: 'Test drilling and boring',
  },
  {
    code: '4321',
    nl: 'Elektrische installatie',
    fr: 'Installation électrique',
    en: 'Electrical installation',
  },
  {
    code: '4322',
    nl: 'Loodgieterswerk, installatie van verwarming en klimaatregeling',
    fr: "Travaux de plomberie et installation de chauffage et de conditionnement d'air",
    en: 'Plumbing, heat and air conditioning installation',
  },
  {
    code: '4329',
    nl: 'Overige bouwinstallatie',
    fr: "Autres travaux d'installation",
    en: 'Other construction installation',
  },
  {
    code: '4331',
    nl: 'Stukadoorswerk',
    fr: 'Travaux de plâtrerie',
    en: 'Plastering',
  },
  {
    code: '4332',
    nl: 'Schrijnwerk',
    fr: 'Travaux de menuiserie',
    en: 'Joinery installation',
  },
  {
    code: '4333',
    nl: 'Vloerafwerking en behangen',
    fr: 'Travaux de revêtement des sols et des murs',
    en: 'Floor and wall covering',
  },
  {
    code: '4334',
    nl: 'Schilderen en glaszetten',
    fr: 'Travaux de peinture et vitrerie',
    en: 'Painting and glazing',
  },
  {
    code: '4339',
    nl: 'Overige werkzaamheden in verband met de afwerking van gebouwen',
    fr: 'Autres travaux de finition',
    en: 'Other building completion and finishing',
  },
  {
    code: '4391',
    nl: 'Dakwerkzaamheden',
    fr: 'Travaux de couverture',
    en: 'Roofing activities',
  },
  {
    code: '4399',
    nl: 'Overige gespecialiseerde bouwactiviteiten, n.e.g.',
    fr: 'Autres travaux de construction spécialisés n.c.a.',
    en: 'Other specialised construction activities n.e.c.',
  },
  {
    code: '4511',
    nl: "Handel in auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
    fr: "Commerce d'automobiles et d'autres véhicules automobiles légers (inférieur ou égal à 3,5 tonnes )",
    en: 'Sale of cars and light motor vehicles',
  },
  {
    code: '4519',
    nl: 'Handel in andere motorvoertuigen',
    fr: "Commerce d'autres véhicules automobiles",
    en: 'Sale of other motor vehicles',
  },
  {
    code: '4520',
    nl: 'Onderhoud en reparatie van motorvoertuigen',
    fr: 'Entretien et réparation de véhicules automobiles',
    en: 'Maintenance and repair of motor vehicles',
  },
  {
    code: '4531',
    nl: 'Groothandel in onderdelen en accessoires van motorvoertuigen',
    fr: "Commerce de gros d'équipements de véhicules automobiles",
    en: 'Wholesale trade of motor vehicle parts and accessories',
  },
  {
    code: '4532',
    nl: 'Detailhandel in onderdelen en accessoires van motorvoertuigen',
    fr: "Commerce de détail d'équipements de véhicules automobiles",
    en: 'Retail trade of motor vehicle parts and accessories',
  },
  {
    code: '4540',
    nl: 'Handel in en onderhoud en reparatie van motorfietsen en delen en toebehoren van motorfietsen',
    fr: 'Commerce, entretien et réparation de motocycles et de pièces et accessoires de motocycles',
    en: 'Sale, maintenance and repair of motorcycles and related parts and accessories',
  },
  {
    code: '4611',
    nl: 'Handelsbemiddeling in landbouwproducten, levende dieren en textielgrondstoffen en halffabrikaten',
    fr: 'Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis',
    en: 'Agents involved in the sale of agricultural raw materials, live anima textile raw materials and semi-finished goods',
  },
  {
    code: '4612',
    nl: 'Handelsbemiddeling in brandstoffen, ertsen, metalen en chemische producten',
    fr: 'Intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques',
    en: 'Agents involved in the sale of fuels, ores, metals and industrial chemicals',
  },
  {
    code: '4613',
    nl: 'Handelsbemiddeling in hout en bouwmaterialen',
    fr: 'Intermédiaires du commerce en bois et matériaux de construction',
    en: 'Agents involved in the sale of timber and building materials',
  },
  {
    code: '4614',
    nl: 'Handelsbemiddeling in machines, apparaten en werktuigen voor de industrie en in schepen en luchtvaartuigen',
    fr: 'Intermédiaires du commerce en machines, équipements industriels, navires et avions',
    en: 'Agents involved in the sale of machinery, industrial equipment, ships and aircraft',
  },
  {
    code: '4615',
    nl: 'Handelsbemiddeling in meubelen, huishoudelijke artikelen en ijzerwaren',
    fr: 'Intermédiaires du commerce en meubles, articles de ménage et quincaillerie',
    en: 'Agents involved in the sale of furniture, household goods, hardware and ironmongery',
  },
  {
    code: '4616',
    nl: 'Handelsbemiddeling in textiel, kleding, bont, schoeisel en lederwaren',
    fr: 'Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir',
    en: 'Agents involved in the sale of textiles, clothing, fur, footwear and leather goods',
  },
  {
    code: '4617',
    nl: 'Handelsbemiddeling in voedings- en genotmiddelen',
    fr: 'Intermédiaires du commerce en denrées, boissons et tabac',
    en: 'Agents involved in the sale of food, beverages and tobacco',
  },
  {
    code: '4618',
    nl: 'Handelsbemiddeling gespecialiseerd in andere goederen',
    fr: "Intermédiaires spécialisés dans le commerce d'autres produits spécifiques",
    en: 'Agents specialised in the sale of other particular products',
  },
  {
    code: '4619',
    nl: 'Handelsbemiddeling in goederen, algemeen assortiment',
    fr: 'Intermédiaires du commerce en produits divers',
    en: 'Agents involved in the sale of a variety of goods',
  },
  {
    code: '4621',
    nl: 'Groothandel in granen, ruwe tabak, zaden en veevoeders',
    fr: "Commerce de gros de céréales, de tabac non manufacturé, de semences et d'aliments pour le bétail",
    en: 'Wholesale of grain, unmanufactured tobacco, seeds and animal feeds',
  },
  {
    code: '4622',
    nl: 'Groothandel in bloemen en planten',
    fr: 'Commerce de gros de fleurs et de plantes',
    en: 'Wholesale of flowers and plants',
  },
  {
    code: '4623',
    nl: 'Groothandel in levende dieren',
    fr: "Commerce de gros d'animaux vivants",
    en: 'Wholesale of live animals',
  },
  {
    code: '4624',
    nl: 'Groothandel in huiden, vellen en leer',
    fr: 'Commerce de gros de cuirs et de peaux',
    en: 'Wholesale of hides, skins and leather',
  },
  {
    code: '4631',
    nl: 'Groothandel in groenten en fruit',
    fr: 'Commerce de gros de fruits et de légumes',
    en: 'Wholesale of fruit and vegetables',
  },
  {
    code: '4632',
    nl: 'Groothandel in vlees en vleesproducten',
    fr: 'Commerce de gros de viandes et de produits à base de viande',
    en: 'Wholesale of meat and meat products',
  },
  {
    code: '4633',
    nl: 'Groothandel in zuivelproducten, eieren en spijsoliën en -vetten',
    fr: 'Commerce de gros de produits laitiers, oeufs, huiles et matières grasses comestibles',
    en: 'Wholesale of dairy products, eggs and edible oils and fats',
  },
  {
    code: '4634',
    nl: 'Groothandel in dranken',
    fr: 'Commerce de gros de boissons',
    en: 'Wholesale of beverages',
  },
  {
    code: '4635',
    nl: 'Groothandel in tabaksproducten',
    fr: 'Commerce de gros de produits à base de tabac',
    en: 'Wholesale of tobacco products',
  },
  {
    code: '4636',
    nl: 'Groothandel in suiker, chocolade en suikerwerk',
    fr: 'Commerce de gros de sucre, de chocolat et de confiserie',
    en: 'Wholesale of sugar and chocolate and sugar confectionery',
  },
  {
    code: '4637',
    nl: 'Groothandel in koffie, thee, cacao en specerijen',
    fr: "Commerce de gros de café, de thé, de cacao et d'épices",
    en: 'Wholesale of coffee, tea, cocoa and spices',
  },
  {
    code: '4638',
    nl: 'Groothandel in andere voedingsmiddelen, met inbegrip van vis en schaal- en weekdieren',
    fr: "Commerce de gros d'autres produits alimentaires, y compris poissons, crustacés et mollusques",
    en: 'Wholesale of other food, including fish, crustaceans and molluscs',
  },
  {
    code: '4639',
    nl: 'Niet-gespecialiseerde groothandel in voedings- en genotmiddelen',
    fr: 'Commerce de gros non spécialisé de denrées, boissons et tabac',
    en: 'Non-specialised wholesale of food, beverages and tobacco',
  },
  {
    code: '4641',
    nl: 'Groothandel in textiel',
    fr: 'Commerce de gros de textiles',
    en: 'Wholesale of textiles',
  },
  {
    code: '4642',
    nl: 'Groothandel in kleding en schoeisel',
    fr: "Commerce de gros d'habillement et de chaussures",
    en: 'Wholesale of clothing and footwear',
  },
  {
    code: '4643',
    nl: 'Groothandel in elektrische huishoudelijke apparaten',
    fr: "Commerce de gros d'appareils électroménagers",
    en: 'Wholesale of electrical household appliances',
  },
  {
    code: '4644',
    nl: 'Groothandel in porselein, glaswerk en reinigingsmiddelen',
    fr: "Commerce de gros de porcelaine, de verrerie et de produits d'entretien",
    en: 'Wholesale of china and glassware and cleaning materials',
  },
  {
    code: '4645',
    nl: 'Groothandel in parfumerieën en cosmetica',
    fr: 'Commerce de gros de parfumerie et de produits de beauté',
    en: 'Wholesale of perfume and cosmetics',
  },
  {
    code: '4646',
    nl: 'Groothandel in farmaceutische producten',
    fr: 'Commerce de gros de produits pharmaceutiques',
    en: 'Wholesale of pharmaceutical goods',
  },
  {
    code: '4647',
    nl: 'Groothandel in huismeubilair, tapijten en verlichtingsapparatuur',
    fr: "Commerce de gros de mobilier domestique, de tapis et d'appareils d'éclairage",
    en: 'Wholesale of furniture, carpets and lighting equipment',
  },
  {
    code: '4648',
    nl: 'Groothandel in uurwerken en sieraden',
    fr: "Commerce de gros d'articles d'horlogerie et de bijouterie",
    en: 'Wholesale of watches and jewellery',
  },
  {
    code: '4649',
    nl: 'Groothandel in andere consumentenartikelen',
    fr: "Commerce de gros d'autres biens domestiques",
    en: 'Wholesale of other household goods',
  },
  {
    code: '4651',
    nl: 'Groothandel in computers, randapparatuur en software',
    fr: "Commerce de gros d'ordinateurs, d'équipements informatiques périphériques et de logiciels",
    en: 'Wholesale of computers, computer peripheral equipment and software',
  },
  {
    code: '4652',
    nl: 'Groothandel in elektronische en telecommunicatieapparatuur en delen daarvan',
    fr: "Commerce de gros de composants et d'équipements électroniques et de télécommunication",
    en: 'Wholesale of electronic and telecommunications equipment and parts',
  },
  {
    code: '4661',
    nl: 'Groothandel in machines, werktuigen en toebehoren voor de landbouw',
    fr: 'Commerce de gros de matériel agricole',
    en: 'Wholesale of agricultural machinery, equipment and supplies',
  },
  {
    code: '4662',
    nl: 'Groothandel in gereedschapswerktuigen',
    fr: 'Commerce de gros de machines-outils',
    en: 'Wholesale of machine tools',
  },
  {
    code: '4663',
    nl: 'Groothandel in machines voor de mijnbouw, de bouwnijverheid en de weg- en waterbouw',
    fr: "Commerce de gros de machines pour l'extraction, la construction et le génie civil",
    en: 'Wholesale of mining, construction and civil engineering machinery',
  },
  {
    code: '4664',
    nl: 'Groothandel in machines voor de textielindustrie en in naai- en breimachines',
    fr: "Commerce de gros de machines pour l'industrie textile et l'habillement",
    en: 'Wholesale of machinery for the textile industry and of sewing and knitting machines',
  },
  {
    code: '4665',
    nl: 'Groothandel in kantoormeubelen',
    fr: 'Commerce de gros de mobilier de bureau',
    en: 'Wholesale of office furniture',
  },
  {
    code: '4666',
    nl: 'Groothandel in andere kantoormachines en kantoorbenodigdheden',
    fr: "Commerce de gros d'autres machines et équipements de bureau",
    en: 'Wholesale of other office machinery and equipment',
  },
  {
    code: '4669',
    nl: 'Groothandel in andere machines en werktuigen',
    fr: "Commerce de gros d'autres machines et équipements",
    en: 'Wholesale of other machinery and equipment',
  },
  {
    code: '4671',
    nl: 'Groothandel in vaste, vloeibare en gasvormige brandstoffen en aanverwante producten',
    fr: 'Commerce de gros de combustibles solides, liquides et gazeux et de produits annexes',
    en: 'Wholesale of solid, liquid and gaseous fuels and related products',
  },
  {
    code: '4672',
    nl: 'Groothandel in metalen en metaalertsen',
    fr: 'Commerce de gros de minerais et de métaux',
    en: 'Wholesale of metals and metal ores',
  },
  {
    code: '4673',
    nl: 'Groothandel in hout, bouwmaterialen en sanitair',
    fr: "Commerce de gros de bois, de matériaux de construction et d'appareils sanitaires",
    en: 'Wholesale of wood, construction materials and sanitary equipment',
  },
  {
    code: '4674',
    nl: 'Groothandel in ijzerwaren en in installatiemateriaal voor loodgieterswerk en verwarming',
    fr: 'Commerce de gros de quincaillerie et de fournitures pour plomberie et chauffage',
    en: 'Wholesale of hardware, plumbing and heating equipment and supplies',
  },
  {
    code: '4675',
    nl: 'Groothandel in chemische producten',
    fr: 'Commerce de gros de produits chimiques',
    en: 'Wholesale of chemical products',
  },
  {
    code: '4676',
    nl: 'Groothandel in andere intermediaire producten',
    fr: "Commerce de gros d'autres produits intermédiaires",
    en: 'Wholesale of other intermediate products',
  },
  {
    code: '4677',
    nl: 'Groothandel in afval en schroot',
    fr: 'Commerce de gros de déchets et de débris',
    en: 'Wholesale of waste and scrap',
  },
  {
    code: '4690',
    nl: 'Niet-gespecialiseerde groothandel',
    fr: 'Commerce de gros non spécialisé',
    en: 'Non-specialised wholesale trade',
  },
  {
    code: '4711',
    nl: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen',
    fr: 'Commerce de détail en magasin non spécialisé à prédominance alimentaire',
    en: 'Retail sale in non-specialised stores with food, beverages or tobacco predominating',
  },
  {
    code: '4719',
    nl: 'Overige detailhandel in niet-gespecialiseerde winkels',
    fr: 'Autres commerces de détail en magasin non spécialisé',
    en: 'Other retail sale in non-specialised stores',
  },
  {
    code: '4721',
    nl: 'Detailhandel in groenten en fruit in gespecialiseerde winkels',
    fr: 'Commerce de détail de fruits et de légumes en magasin spécialisé',
    en: 'Retail sale of fruit and vegetables in specialised stores',
  },
  {
    code: '4722',
    nl: 'Detailhandel in vlees en vleesproducten in gespecialiseerde winkels',
    fr: 'Commerce de détail de viandes et de produits à base de viande en magasin spécialisé',
    en: 'Retail sale of meat and meat products in specialised stores',
  },
  {
    code: '4723',
    nl: 'Detailhandel in vis en schaal- en weekdieren in gespecialiseerde winkels',
    fr: 'Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé',
    en: 'Retail sale of fish, crustaceans and molluscs in specialised stores',
  },
  {
    code: '4724',
    nl: 'Detailhandel in brood, banketbakkerswerk en suikerwerk in gespecialiseerde winkels',
    fr: 'Commerce de détail de pain, de pâtisserie et de confiserie en magasin spécialisé',
    en: 'Retail sale of bread, cakes, flour confectionery and sugar confectionery in specialised stores',
  },
  {
    code: '4725',
    nl: 'Detailhandel in dranken in gespecialiseerde winkels',
    fr: 'Commerce de détail de boissons en magasin spécialisé',
    en: 'Retail sale of beverages in specialised stores',
  },
  {
    code: '4726',
    nl: 'Detailhandel in tabaksproducten in gespecialiseerde winkels',
    fr: 'Commerce de détail de produits à base de tabac en magasin spécialisé',
    en: 'Retail sale of tobacco products in specialised stores',
  },
  {
    code: '4729',
    nl: 'Overige detailhandel in voedingsmiddelen in gespecialiseerde winkels',
    fr: 'Autres commerces de détail alimentaires en magasin spécialisé',
    en: 'Other retail sale of food in specialised stores',
  },
  {
    code: '4730',
    nl: 'Detailhandel in motorbrandstoffen in gespecialiseerde winkels',
    fr: 'Commerce de détail de carburants automobiles en magasin spécialisé',
    en: 'Retail sale of automotive fuel in specialised stores',
  },
  {
    code: '4741',
    nl: 'Detailhandel in computers, randapparatuur en software in gespecialiseerde winkels',
    fr: "Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé",
    en: 'Retail sale of computers, peripheral units and software in specialised stores',
  },
  {
    code: '4742',
    nl: 'Detailhandel in telecommunicatieapparatuur in gespecialiseerde winkels',
    fr: 'Commerce de détail de matériels de télécommunication en magasin spécialisé',
    en: 'Retail sale of telecommunications equipment in specialised stores',
  },
  {
    code: '4743',
    nl: 'Detailhandel in audio- en videoapparatuur in gespecialiseerde winkels',
    fr: 'Commerce de détail de matériels audio-vidéo en magasin spécialisé',
    en: 'Retail sale of audio and video equipment in specialised stores',
  },
  {
    code: '4751',
    nl: 'Detailhandel in textiel in gespecialiseerde winkels',
    fr: 'Commerce de détail de textiles en magasin spécialisé',
    en: 'Retail sale of textiles in specialised stores',
  },
  {
    code: '4752',
    nl: 'Detailhandel in ijzerwaren, verf en glas in gespecialiseerde winkels',
    fr: 'Commerce de détail de quincaillerie, de peintures et de verres en magasin spécialisé',
    en: 'Retail sale of hardware, paints and glass in specialised stores',
  },
  {
    code: '4753',
    nl: 'Detailhandel in tapijten en andere vloerbedekking en wandbekleding in gespecialiseerde winkels',
    fr: 'Commerce de détail de tapis, de moquettes et de revêtements de murs et de sols en magasin spécialisé',
    en: 'Retail sale of carpets, rugs, wall and floor coverings in specialised stores',
  },
  {
    code: '4754',
    nl: 'Detailhandel in elektrische huishoudapparaten in gespecialiseerde winkels',
    fr: "Commerce de détail d'appareils électroménagers en magasin spécialisé",
    en: 'Retail sale of electrical household appliances in specialised stores',
  },
  {
    code: '4759',
    nl: 'Detailhandel in meubelen, verlichtingsbenodigdheden en andere huishoudelijke artikelen in gespecialiseerde winkels',
    fr: "Commerce de détail de meubles, d'appareils d'éclairage et d'autres articles de ménage en magasin spécialisé",
    en: 'Retail sale of furniture, lighting equipment and other household articles in specialised stores',
  },
  {
    code: '4761',
    nl: 'Detailhandel in boeken in gespecialiseerde winkels',
    fr: 'Commerce de détail de livres en magasin spécialisé',
    en: 'Retail sale of books in specialised stores',
  },
  {
    code: '4762',
    nl: 'Detailhandel in kranten en kantoorbehoeften in gespecialiseerde winkels',
    fr: 'Commerce de détail de journaux et de papeterie en magasin spécialisé',
    en: 'Retail sale of newspapers and stationery in specialised stores',
  },
  {
    code: '4763',
    nl: 'Detailhandel in audio- en video-opnamen in gespecialiseerde winkels',
    fr: "Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé",
    en: 'Retail sale of music and video recordings in specialised stores',
  },
  {
    code: '4764',
    nl: 'Detailhandel in sportartikelen in gespecialiseerde winkels',
    fr: "Commerce de détail d'articles de sport en magasin spécialisé",
    en: 'Retail sale of sporting equipment in specialised stores',
  },
  {
    code: '4765',
    nl: 'Detailhandel in spellen en speelgoed in gespecialiseerde winkels',
    fr: 'Commerce de détail de jeux et de jouets en magasin spécialisé',
    en: 'Retail sale of games and toys in specialised stores',
  },
  {
    code: '4771',
    nl: 'Detailhandel in kleding in gespecialiseerde winkels',
    fr: "Commerce de détail d'habillement en magasin spécialisé",
    en: 'Retail sale of clothing in specialised stores',
  },
  {
    code: '4772',
    nl: 'Detailhandel in schoeisel en lederwaren in gespecialiseerde winkels',
    fr: "Commerce de détail de chaussures et d'articles en cuir en magasin spécialisé",
    en: 'Retail sale of footwear and leather goods in specialised stores',
  },
  {
    code: '4773',
    nl: 'Apothekers in gespecialiseerde winkels',
    fr: 'Commerce de détail de produits pharmaceutiques en magasin spécialisé',
    en: 'Dispensing chemist in specialised stores',
  },
  {
    code: '4774',
    nl: 'Detailhandel in medische en orthopedische artikelen in gespecialiseerde winkels',
    fr: "Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé",
    en: 'Retail sale of medical and orthopaedic goods in specialised stores',
  },
  {
    code: '4775',
    nl: 'Detailhandel in cosmetica en toiletartikelen in gespecialiseerde winkels',
    fr: 'Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé',
    en: 'Retail sale of cosmetic and toilet articles in specialised stores',
  },
  {
    code: '4776',
    nl: 'Detailhandel in bloemen, planten, zaden, kunstmeststoffen, huisdieren en voedsel voor huisdieren in gespecialiseerde winkels',
    fr: "Commerce de détail de fleurs, de plantes, de graines, d'engrais, d'animaux de compagnie et d'aliments pour ces animaux en magasin spécialisé",
    en: 'Retail sale of flowers, plants, seeds, fertilisers, pet animals and pet food in specialised stores',
  },
  {
    code: '4777',
    nl: 'Detailhandel in uurwerken en sieraden in gespecialiseerde winkels',
    fr: "Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé",
    en: 'Retail sale of watches and jewellery in specialised stores',
  },
  {
    code: '4778',
    nl: 'Overige detailhandel in nieuwe artikelen in gespecialiseerde winkels',
    fr: 'Autres commerces de détail de biens neufs en magasin spécialisé',
    en: 'Other retail sale of new goods in specialised stores',
  },
  {
    code: '4779',
    nl: 'Detailhandel in antiquiteiten en tweedehandsgoederen in winkels',
    fr: "Commerce de détail d'antiquités et de biens d'occasion en magasin",
    en: 'Retail sale of second-hand goods in stores',
  },
  {
    code: '4781',
    nl: 'Markt- en straathandel in voedings- en genotmiddelen',
    fr: 'Commerce de détail alimentaire sur éventaires et marchés',
    en: 'Retail sale via stalls and markets of food, beverages and tobacco products',
  },
  {
    code: '4782',
    nl: 'Markt- en straathandel in textiel, kleding en schoeisel',
    fr: "Commerce de détail de textiles, d'habillement et de chaussures sur éventaires et marchés",
    en: 'Retail sale via stalls and markets of textiles, clothing and footwear',
  },
  {
    code: '4789',
    nl: 'Markt- en straathandel in andere artikelen',
    fr: 'Autres commerces de détail sur éventaires et marchés',
    en: 'Retail sale via stalls and markets of other goods',
  },
  {
    code: '4791',
    nl: 'Detailhandel via postorderbedrijven of via internet',
    fr: 'Vente à distance',
    en: 'Retail sale via mail order houses or via Internet',
  },
  {
    code: '4799',
    nl: 'Overige detailhandel, niet in winkels en exclusief markt- en straathandel',
    fr: 'Autres commerces de détail hors magasin, éventaires ou marchés',
    en: 'Other retail sale not in stores, stalls or markets',
  },
  {
    code: '4910',
    nl: 'Personenvervoer per spoor, m.u.v. personenvervoer per spoor binnen steden of voorsteden',
    fr: "Transport ferroviaire de voyageurs autre qu'urbain et suburbain",
    en: 'Passenger rail transport, interurban',
  },
  {
    code: '4920',
    nl: 'Goederenvervoer per spoor',
    fr: 'Transports ferroviaires de fret',
    en: 'Freight rail transport',
  },
  {
    code: '4931',
    nl: 'Personenvervoer te land binnen steden of voorsteden',
    fr: 'Transports urbains et suburbains de voyageurs',
    en: 'Urban and suburban passenger land transport',
  },
  {
    code: '4932',
    nl: "Exploitatie van taxi's",
    fr: 'Transports de voyageurs par taxis',
    en: 'Taxi operation',
  },
  {
    code: '4939',
    nl: 'Overig personenvervoer te land, n.e.g.',
    fr: 'Autres transports terrestres de voyageurs n.c.a.',
    en: 'Other passenger land transport n.e.c.',
  },
  {
    code: '4941',
    nl: 'Goederenvervoer over de weg',
    fr: 'Transports routiers de fret',
    en: 'Freight transport by road',
  },
  {
    code: '4942',
    nl: 'Verhuisbedrijven',
    fr: 'Services de déménagement',
    en: 'Removal services',
  },
  {
    code: '4950',
    nl: 'Vervoer via pijpleidingen',
    fr: 'Transports par conduites',
    en: 'Transport via pipeline',
  },
  {
    code: '5010',
    nl: 'Personenvervoer over zee- en kustwateren',
    fr: 'Transports maritimes et côtiers de passagers',
    en: 'Sea and coastal passenger water transport',
  },
  {
    code: '5020',
    nl: 'Goederenvervoer over zee- en kustwateren',
    fr: 'Transports maritimes et côtiers de fret',
    en: 'Sea and coastal freight water transport',
  },
  {
    code: '5030',
    nl: 'Personenvervoer over binnenwateren',
    fr: 'Transports fluviaux de passagers',
    en: 'Inland passenger water transport',
  },
  {
    code: '5040',
    nl: 'Goederenvervoer over binnenwateren',
    fr: 'Transports fluviaux de fret',
    en: 'Inland freight water transport',
  },
  {
    code: '5110',
    nl: 'Personenvervoer door de lucht',
    fr: 'Transports aériens de passagers',
    en: 'Passenger air transport',
  },
  {
    code: '5121',
    nl: 'Goederenvervoer door de lucht',
    fr: 'Transports aériens de fret',
    en: 'Freight air transport',
  },
  {
    code: '5122',
    nl: 'Ruimtevaart',
    fr: 'Transports spatiaux',
    en: 'Space transport',
  },
  {
    code: '5210',
    nl: 'Opslag',
    fr: 'Entreposage et stockage',
    en: 'Warehousing and storage',
  },
  {
    code: '5221',
    nl: 'Diensten in verband met vervoer te land',
    fr: 'Services auxiliaires des transports terrestres',
    en: 'Service activities incidental to land transportation',
  },
  {
    code: '5222',
    nl: 'Diensten in verband met vervoer over water',
    fr: 'Services auxiliaires des transports par eau',
    en: 'Service activities incidental to water transportation',
  },
  {
    code: '5223',
    nl: 'Diensten in verband met de luchtvaart',
    fr: 'Services auxiliaires des transports aériens',
    en: 'Service activities incidental to air transportation',
  },
  {
    code: '5224',
    nl: 'Vrachtbehandeling',
    fr: 'Manutention',
    en: 'Cargo handling',
  },
  {
    code: '5229',
    nl: 'Overige vervoerondersteunende activiteiten',
    fr: 'Autres services auxiliaires des transports',
    en: 'Other transportation support activities',
  },
  {
    code: '5310',
    nl: 'Postdiensten in het kader van de universele dienstverplichting',
    fr: "Activités de poste dans le cadre d'une obligation de service universel",
    en: 'Postal activities under universal service obligation',
  },
  {
    code: '5320',
    nl: 'Overige posterijen en koeriers',
    fr: 'Autres activités de poste et de courrier',
    en: 'Other postal and courier activities',
  },
  {
    code: '5510',
    nl: 'Hotels en dergelijke accommodatie',
    fr: 'Hôtels et hébergement similaire',
    en: 'Hotels and similar accommodation',
  },
  {
    code: '5520',
    nl: 'Vakantieverblijven en andere accommodatie voor kort verblijf',
    fr: 'Hébergement touristique et autre hébergement de courte durée',
    en: 'Holiday and other short-stay accommodation',
  },
  {
    code: '5530',
    nl: 'Kampeerterreinen en kampeerauto- en caravanterreinen',
    fr: 'Terrains de camping et parcs pour caravanes ou véhicules de loisirs',
    en: 'Camping grounds, recreational vehicle parks and trailer parks',
  },
  {
    code: '5590',
    nl: 'Overige accommodatie',
    fr: 'Autres hébergements',
    en: 'Other accommodation',
  },
  {
    code: '5610',
    nl: 'Restaurants en mobiele eetgelegenheden',
    fr: 'Restaurants et services de restauration mobile',
    en: 'Restaurants and mobile food service activities',
  },
  {
    code: '5621',
    nl: 'Catering',
    fr: 'Services des traiteurs',
    en: 'Event catering activities',
  },
  {
    code: '5629',
    nl: 'Overige eetgelegenheden',
    fr: 'Autres services de restauration',
    en: 'Other food service activities',
  },
  {
    code: '5630',
    nl: 'Drinkgelegenheden',
    fr: 'Débits de boissons',
    en: 'Beverage serving activities',
  },
  {
    code: '5811',
    nl: 'Uitgeverijen van boeken',
    fr: 'Édition de livres',
    en: 'Book publishing',
  },
  {
    code: '5812',
    nl: 'Uitgeverijen van adresboeken en mailinglijsten',
    fr: "Édition de répertoires et de fichiers d'adresses",
    en: 'Publishing of directories and mailing lists',
  },
  {
    code: '5813',
    nl: 'Uitgeverijen van kranten',
    fr: 'Édition de journaux',
    en: 'Publishing of newspapers',
  },
  {
    code: '5814',
    nl: 'Uitgeverijen van tijdschriften',
    fr: 'Édition de revues et de périodiques',
    en: 'Publishing of journals and periodicals',
  },
  {
    code: '5819',
    nl: 'Overige uitgeverijen',
    fr: "Autres activités d'édition",
    en: 'Other publishing activities',
  },
  {
    code: '5821',
    nl: 'Uitgeverijen van computerspellen',
    fr: 'Édition de jeux électroniques',
    en: 'Publishing of computer games',
  },
  {
    code: '5829',
    nl: 'Overige uitgeverijen van software',
    fr: "Édition d'autres logiciels",
    en: 'Other software publishing',
  },
  {
    code: '5911',
    nl: "Productie van films en video- en televisieprogramma's",
    fr: 'Production de films cinématographiques, de vidéo et de programmes de télévision',
    en: 'Motion picture, video and television programme production activities',
  },
  {
    code: '5912',
    nl: "Activiteiten in verband met films en video- en televisieprogramma's na de productie",
    fr: 'Post-production de films cinématographiques, de vidéo et de programmes de télévision',
    en: 'Motion picture, video and television programme post-production activities',
  },
  {
    code: '5913',
    nl: "Distributie van films en video- en televisieprogramma's",
    fr: 'Distribution de films cinématographiques, de vidéo et de programmes de télévision',
    en: 'Motion picture, video and television programme distribution activities',
  },
  {
    code: '5914',
    nl: 'Vertoning van films',
    fr: 'Projection de films cinématographiques',
    en: 'Motion picture projection activities',
  },
  {
    code: '5920',
    nl: 'Maken van geluidsopnamen en uitgeverijen van muziekopnamen',
    fr: 'Enregistrement sonore et édition musicale',
    en: 'Sound recording and music publishing activities',
  },
  {
    code: '6010',
    nl: "Uitzenden van radioprogramma's",
    fr: 'Diffusion de programmes radio',
    en: 'Radio broadcasting',
  },
  {
    code: '6020',
    nl: "Programmeren en uitzenden van televisieprogramma's",
    fr: 'Programmation de télévision et télédiffusion',
    en: 'Television programming and broadcasting activities',
  },
  {
    code: '6110',
    nl: 'Draadgebonden telecommunicatie',
    fr: 'Télécommunications filaires',
    en: 'Wired telecommunications activities',
  },
  {
    code: '6120',
    nl: 'Draadloze telecommunicatie',
    fr: 'Télécommunications sans fil',
    en: 'Wireless telecommunications activities',
  },
  {
    code: '6130',
    nl: 'Telecommunicatie via satelliet',
    fr: 'Télécommunications par satellite',
    en: 'Satellite telecommunications activities',
  },
  {
    code: '6190',
    nl: 'Overige telecommunicatie',
    fr: 'Autres activités de télécommunication',
    en: 'Other telecommunications activities',
  },
  {
    code: '6201',
    nl: "Ontwerpen en programmeren van computerprogramma's",
    fr: 'Programmation informatique',
    en: 'Computer programming activities',
  },
  {
    code: '6202',
    nl: 'Computerconsultancy-activiteiten',
    fr: 'Conseil informatique',
    en: 'Computer consultancy activities',
  },
  {
    code: '6203',
    nl: 'Beheer van computerfaciliteiten',
    fr: "Gestion d'installations informatiques",
    en: 'Computer facilities management activities',
  },
  {
    code: '6209',
    nl: 'Overige diensten op het gebied van informatietechnologie en computer',
    fr: 'Autres activités informatiques',
    en: 'Other information technology and computer service activities',
  },
  {
    code: '6311',
    nl: 'Gegevensverwerking, webhosting en aanverwante activiteiten',
    fr: 'Traitement de données, hébergement et activités connexes',
    en: 'Data processing, hosting and related activities',
  },
  {
    code: '6312',
    nl: 'Webportalen',
    fr: 'Portails Internet',
    en: 'Web portals',
  },
  {
    code: '6391',
    nl: 'Persagentschappen',
    fr: 'Activités des agences de presse',
    en: 'News agency activities',
  },
  {
    code: '6399',
    nl: 'Overige dienstverlenende activiteiten op het gebied van informatie, n.e. g.',
    fr: "Autres services d'information n.c.a.",
    en: 'Other information service activities n.e.c.',
  },
  {
    code: '6411',
    nl: 'Centrale banken',
    fr: 'Activités de banque centrale',
    en: 'Central banking',
  },
  {
    code: '6419',
    nl: 'Overige geldscheppende financiële instellingen',
    fr: 'Autres intermédiations monétaires',
    en: 'Other monetary intermediation',
  },
  {
    code: '6420',
    nl: 'Holdings',
    fr: 'Activités des sociétés holding',
    en: 'Activities of holding companies',
  },
  {
    code: '6430',
    nl: 'Beleggingstrusts en -fondsen en vergelijkbare financiële instellingen',
    fr: 'Fonds de placement et entités financières similaires',
    en: 'Trusts, funds and similar financial entities',
  },
  {
    code: '6491',
    nl: 'Financiële lease',
    fr: 'Crédit-bail',
    en: 'Financial leasing',
  },
  {
    code: '6492',
    nl: 'Overige kredietverstrekking',
    fr: 'Autre distribution de crédit',
    en: 'Other credit granting',
  },
  {
    code: '6499',
    nl: 'Overige financiële dienstverlening, exclusief verzekeringen en pensioenfondsen, n.e.g.',
    fr: 'Autres activités des services financiers, hors assurance et caisses de retraite n.c.a.',
    en: 'Other financial service activities, except insurance and pension funding n.e.c.',
  },
  {
    code: '6511',
    nl: 'Levensverzekeringen',
    fr: 'Assurance vie',
    en: 'Life insurance',
  },
  {
    code: '6512',
    nl: 'Niet-levensverzekeringen',
    fr: 'Assurance non-vie',
    en: 'Non-life insurance',
  },
  {
    code: '6520',
    nl: 'Herverzekeringen',
    fr: 'Réassurance',
    en: 'Reinsurance',
  },
  {
    code: '6530',
    nl: 'Pensioenfondsen',
    fr: 'Caisses de retraite',
    en: 'Pension funding',
  },
  {
    code: '6611',
    nl: 'Beheer van financiële markten',
    fr: 'Administration de marchés financiers',
    en: 'Administration of financial markets',
  },
  {
    code: '6612',
    nl: 'Effecten- en goederenhandel',
    fr: 'Courtage de valeurs mobilières et de marchandises',
    en: 'Security and commodity contracts brokerage',
  },
  {
    code: '6619',
    nl: 'Overige ondersteunende activiteiten in verband met financiële diensten, exclusief verzekeringen en pensioenfondsen',
    fr: 'Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite',
    en: 'Other activities auxiliary to financial services, except insurance and pension funding',
  },
  {
    code: '6621',
    nl: 'Risicoanalisten en schadetaxateurs',
    fr: 'Évaluation des risques et dommages',
    en: 'Risk and damage evaluation',
  },
  {
    code: '6622',
    nl: 'Verzekeringsagenten en -makelaars',
    fr: "Activités des agents et courtiers d'assurances",
    en: 'Activities of insurance agents and brokers',
  },
  {
    code: '6629',
    nl: 'Overige ondersteunende activiteiten in verband met verzekeringen en pensioenfondsen',
    fr: "Autres activités auxiliaires d'assurance et de caisses de retraite",
    en: 'Other activities auxiliary to insurance and pension funding',
  },
  {
    code: '6630',
    nl: 'Vermogensbeheer',
    fr: 'Gestion de fonds',
    en: 'Fund management activities',
  },
  {
    code: '6810',
    nl: 'Handel in eigen onroerend goed',
    fr: 'Activités des marchands de biens immobiliers',
    en: 'Buying and selling of own real estate',
  },
  {
    code: '6820',
    nl: 'Verhuur en exploitatie van eigen of geleasd onroerend goed',
    fr: 'Location et exploitation de biens immobiliers propres ou loués',
    en: 'Renting and operating of own or leased real estate',
  },
  {
    code: '6831',
    nl: 'Bemiddeling in onroerend goed',
    fr: 'Agences immobilières',
    en: 'Real estate agencies',
  },
  {
    code: '6832',
    nl: 'Beheer van onroerend goed voor een vast bedrag of op contractbasis',
    fr: 'Administration de biens immobiliers pour compte de tiers',
    en: 'Management of real estate on a fee or contract basis',
  },
  {
    code: '6910',
    nl: 'Rechtskundige dienstverlening',
    fr: 'Activités juridiques',
    en: 'Legal activities',
  },
  {
    code: '6920',
    nl: 'Accountants, boekhouders en belastingconsulenten',
    fr: 'Activités comptables',
    en: 'Accounting, bookkeeping and auditing activities; tax consultancy',
  },
  {
    code: '7010',
    nl: 'Activiteiten van hoofdkantoren',
    fr: 'Activités des sièges sociaux',
    en: 'Activities of head offices',
  },
  {
    code: '7021',
    nl: 'Adviesbureaus op het gebied van public relations en communicatie',
    fr: 'Conseil en relations publiques et en communication',
    en: 'Public relations and communication activities',
  },
  {
    code: '7022',
    nl: 'Overige adviesbureaus op het gebied van bedrijfsbeheer; adviesbureaus op het gebied van bedrijfsvoering',
    fr: 'Conseil pour les affaires et autres conseils de gestion',
    en: 'Business and other management consultancy activities',
  },
  {
    code: '7111',
    nl: 'Architecten',
    fr: "Activités d'architecture",
    en: 'Architectural activities',
  },
  {
    code: '7112',
    nl: 'Ingenieurs en aanverwante technische adviseurs',
    fr: "Activités d'ingénierie et de conseils techniques",
    en: 'Engineering activities and related technical consultancy',
  },
  {
    code: '7120',
    nl: 'Technische testen en toetsen',
    fr: 'Activités de contrôle et analyses techniques',
    en: 'Technical testing and analysis',
  },
  {
    code: '7211',
    nl: 'Speur- en ontwikkelingswerk op biotechnologisch gebied',
    fr: 'Recherche-développement en biotechnologie',
    en: 'Research and experimental development on biotechnology',
  },
  {
    code: '7219',
    nl: 'Overig speur- en ontwikkelingswerk op natuurwetenschappelijk gebied',
    fr: 'Recherche-développement en autres sciences physiques et naturelles',
    en: 'Other research and experimental development on natural sciences and engineering',
  },
  {
    code: '7220',
    nl: 'Speur- en ontwikkelingswerk op het gebied van de maatschappij- en geesteswetenschappen',
    fr: 'Recherche-développement en sciences humaines et sociales',
    en: 'Research and experimental development on social sciences and humanities',
  },
  {
    code: '7311',
    nl: 'Reclamebureaus',
    fr: 'Activités des agences de publicité',
    en: 'Advertising agencies',
  },
  {
    code: '7312',
    nl: 'Mediarepresentatie',
    fr: 'Régie publicitaire de médias',
    en: 'Media representation',
  },
  {
    code: '7320',
    nl: 'Markt- en opinieonderzoekbureaus',
    fr: "Études de marché et sondages d'opinion",
    en: 'Market research and public opinion polling',
  },
  {
    code: '7410',
    nl: 'Gespecialiseerde designers',
    fr: 'Activités spécialisées de design',
    en: 'Specialised design activities',
  },
  {
    code: '7420',
    nl: 'Fotografen',
    fr: 'Activités photographiques',
    en: 'Photographic activities',
  },
  {
    code: '7430',
    nl: 'Vertalers en tolken',
    fr: 'Traduction et interprétation',
    en: 'Translation and interpretation activities',
  },
  {
    code: '7490',
    nl: 'Overige gespecialiseerde wetenschappelijke en technische activiteiten, n.e.g.',
    fr: 'Autres activités spécialisées, scientifiques et techniques n.c.a.',
    en: 'Other professional, scientific and technical activities n.e.c.',
  },
  {
    code: '7500',
    nl: 'Veterinaire diensten',
    fr: 'Activités vétérinaires',
    en: 'Veterinary activities',
  },
  {
    code: '7711',
    nl: "Verhuur en lease van personenauto's en lichte bestelwagens (kleiner dan 3,5 ton)",
    fr: "Location et location-bail d'automobiles et d'autres véhicules automobiles légers (inférieur à 3,5 tonnes)",
    en: 'Renting and leasing of cars and light motor vehicles',
  },
  {
    code: '7712',
    nl: 'Verhuur en lease van vrachtwagens en overige motorvoertuigen (groter dan 3,5 ton)',
    fr: "Location et location-bail de camions et d'autres véhicules automobiles lourds (supérieur à 3,5 ton)",
    en: 'Renting and leasing of trucks',
  },
  {
    code: '7721',
    nl: 'Verhuur en lease van sport- en recreatieartikelen',
    fr: "Location et location-bail d'articles de loisirs et de sport",
    en: 'Renting and leasing of recreational and sports goods',
  },
  {
    code: '7722',
    nl: "Verhuur van videobanden, dvd's en cd's",
    fr: 'Location de vidéocassettes et de disques vidéo',
    en: 'Renting of video tapes and disks',
  },
  {
    code: '7729',
    nl: 'Verhuur en lease van andere consumentenartikelen',
    fr: "Location et location-bail d'autres biens personnels et domestiques",
    en: 'Renting and leasing of other personal and household goods',
  },
  {
    code: '7731',
    nl: 'Verhuur en lease van landbouwmachines en -werktuigen',
    fr: "Location et location-bail de machines et d'équipements agricoles",
    en: 'Renting and leasing of agricultural machinery and equipment',
  },
  {
    code: '7732',
    nl: 'Verhuur en lease van machines en installaties voor de bouwnijverheid en de weg- en waterbouw',
    fr: "Location et location-bail de machines et d'équipements pour la construction",
    en: 'Renting and leasing of construction and civil engineering machinery and equipment',
  },
  {
    code: '7733',
    nl: 'Verhuur en lease van kantoormachines, inclusief computers',
    fr: 'Location et location-bail de machines de bureau et de matériel informatique',
    en: 'Renting and leasing of office machinery and equipment (including computers)',
  },
  {
    code: '7734',
    nl: 'Verhuur en lease van schepen',
    fr: 'Location et location-bail de matériels de transport par eau',
    en: 'Renting and leasing of water transport equipment',
  },
  {
    code: '7735',
    nl: 'Verhuur en lease van luchtvaartuigen',
    fr: 'Location et location-bail de matériels de transport aérien',
    en: 'Renting and leasing of air transport equipment',
  },
  {
    code: '7739',
    nl: 'Verhuur en lease van andere machines en werktuigen en andere materiële goederen, n.e.g.',
    fr: "Location et location-bail d'autres machines, équipements et biens matériels n.c.a.",
    en: 'Renting and leasing of other machinery, equipment and tangible goods n.e.c.',
  },
  {
    code: '7740',
    nl: 'Lease van intellectuele eigendom en vergelijkbare producten, met uitzondering van werken onder auteursrecht',
    fr: "Location-bail de propriété intellectuelle et de produits similaires, à l'exception des oeuvres soumises au droit d'auteur",
    en: 'Leasing of intellectual property and similar products, except copyrighted works',
  },
  {
    code: '7810',
    nl: 'Arbeidsbemiddeling',
    fr: "Activités des agences de placement de main-d'oeuvre",
    en: 'Activities of employment placement agencies',
  },
  {
    code: '7820',
    nl: 'Uitzendbureaus',
    fr: 'Activités des agences de travail temporaire',
    en: 'Temporary employment agency activities',
  },
  {
    code: '7830',
    nl: 'Andere vormen van arbeidsbemiddeling',
    fr: 'Autre mise à disposition de ressources humaines',
    en: 'Other human resources provision',
  },
  {
    code: '7911',
    nl: 'Reisbureaus',
    fr: 'Activités des agences de voyage',
    en: 'Travel agency activities',
  },
  {
    code: '7912',
    nl: 'Reisorganisatoren',
    fr: 'Activités des voyagistes',
    en: 'Tour operator activities',
  },
  {
    code: '7990',
    nl: 'Reserveringsbureaus en aanverwante activiteiten',
    fr: 'Autres services de réservation et activités connexes',
    en: 'Other reservation service and related activities',
  },
  {
    code: '8010',
    nl: 'Particuliere beveiliging',
    fr: 'Activités de sécurité privée',
    en: 'Private security activities',
  },
  {
    code: '8020',
    nl: 'Diensten in verband met beveiligingssystemen',
    fr: 'Activités liées aux systèmes de sécurité',
    en: 'Security systems service activities',
  },
  {
    code: '8030',
    nl: 'Opsporingsdiensten',
    fr: "Activités d'enquête",
    en: 'Investigation activities',
  },
  {
    code: '8110',
    nl: 'Diverse ondersteunende activiteiten ten behoeve van voorzieningen',
    fr: 'Activités combinées de soutien lié aux bâtiments',
    en: 'Combined facilities support activities',
  },
  {
    code: '8121',
    nl: 'Algemene reiniging van gebouwen',
    fr: 'Nettoyage courant des bâtiments',
    en: 'General cleaning of buildings',
  },
  {
    code: '8122',
    nl: 'Overige reiniging van gebouwen; industriële reiniging',
    fr: 'Autres activités de nettoyage des bâtiments; nettoyage industriel',
    en: 'Other building and industrial cleaning activities',
  },
  {
    code: '8129',
    nl: 'Andere reinigingsactiviteiten',
    fr: 'Autres activités de nettoyage',
    en: 'Other cleaning activities',
  },
  {
    code: '8130',
    nl: 'Landschapsverzorging',
    fr: "Services d'aménagement paysager",
    en: 'Landscape service activities',
  },
  {
    code: '8211',
    nl: 'Diverse administratieve activiteiten ten behoeve van kantoren',
    fr: 'Services administratifs combinés de bureau',
    en: 'Combined office administrative service activities',
  },
  {
    code: '8219',
    nl: 'Fotokopiëren, documentvoorbereiding en andere gespecialiseerde ondersteunende activiteiten ten behoeve van kantoren',
    fr: 'Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau',
    en: 'Photocopying, document preparation and other specialised office support activities',
  },
  {
    code: '8220',
    nl: 'Callcenters',
    fr: "Activités des centres d'appels",
    en: 'Activities of call centres',
  },
  {
    code: '8230',
    nl: 'Organisatie van congressen en beurzen',
    fr: 'Organisation de salons professionnels et de congrès',
    en: 'Organisation of conventions and trade shows',
  },
  {
    code: '8291',
    nl: 'Incasso- en kredietbureaus',
    fr: "Activités des agences de recouvrement de factures et des sociétés d'information financière sur la clientèle",
    en: 'Activities of collection agencies and credit bureaus',
  },
  {
    code: '8292',
    nl: 'Verpakkingsbedrijven',
    fr: 'Activités de conditionnement',
    en: 'Packaging activities',
  },
  {
    code: '8299',
    nl: 'Overige zakelijke dienstverlening, n.e.g.',
    fr: 'Autres activités de soutien aux entreprises n.c.a.',
    en: 'Other business support service activities n.e.c.',
  },
  {
    code: '8411',
    nl: 'Algemeen overheidsbestuur',
    fr: 'Administration publique générale',
    en: 'General public administration activities',
  },
  {
    code: '8412',
    nl: 'Openbaar bestuur op het gebied van gezondheidszorg, onderwijs, cultuur en andere sociale dienstverlening, exclusief sociale verzekeringen',
    fr: "Administration publique (tutelle) de la santé, de la formation, de la culture et des autres services sociaux, à l'exclusion de la sécurité sociale",
    en: 'Regulation of the activities of providing health care, education, cultural services and other social services, excluding social security',
  },
  {
    code: '8413',
    nl: 'Openbaar bestuur op het gebied van het bedrijfsleven; stimuleren van het bedrijfsleven',
    fr: 'Administration publique (tutelle) des activités économiques',
    en: 'Regulation of and contribution to more efficient operation of businesses',
  },
  {
    code: '8421',
    nl: 'Buitenlandse zaken',
    fr: 'Affaires étrangères',
    en: 'Foreign affairs',
  },
  { code: '8422', nl: 'Defensie', fr: 'Défense', en: 'Defence activities' },
  {
    code: '8423',
    nl: 'Justitie',
    fr: 'Justice',
    en: 'Justice and judicial activities',
  },
  {
    code: '8424',
    nl: 'Openbare orde en civiele veiligheid',
    fr: "Activités d'ordre public et de sécurité civile",
    en: 'Public order and safety activities',
  },
  {
    code: '8425',
    nl: 'Brandweer',
    fr: 'Services du feu',
    en: 'Fire service activities',
  },
  {
    code: '8430',
    nl: 'Verplichte sociale verzekeringen',
    fr: 'Sécurité sociale obligatoire',
    en: 'Compulsory social security activities',
  },
  {
    code: '8510',
    nl: 'Kleuteronderwijs',
    fr: 'Enseignement maternel',
    en: 'Pre-primary education',
  },
  {
    code: '8520',
    nl: 'Lager onderwijs',
    fr: 'Enseignement primaire',
    en: 'Primary education',
  },
  {
    code: '8531',
    nl: 'Algemeen secundair onderwijs',
    fr: 'Enseignement secondaire général',
    en: 'General secondary education',
  },
  {
    code: '8532',
    nl: 'Technisch, beroeps- en buitengewoon secundair onderwijs',
    fr: 'Enseignement secondaire technique, professionnel et spécialisé',
    en: 'Technical and vocational secondary education',
  },
  {
    code: '8541',
    nl: 'Post-secundair niet-hoger onderwijs',
    fr: 'Enseignement post-secondaire non supérieur',
    en: 'Post-secondary non-tertiary education',
  },
  {
    code: '8542',
    nl: 'Hoger onderwijs',
    fr: 'Enseignement supérieur',
    en: 'Tertiary education',
  },
  {
    code: '8551',
    nl: 'Sport- en recreatieonderwijs',
    fr: "Enseignement de disciplines sportives et d'activités de loisirs",
    en: 'Sports and recreation education',
  },
  {
    code: '8552',
    nl: 'Cultureel onderwijs',
    fr: 'Enseignement culturel',
    en: 'Cultural education',
  },
  {
    code: '8553',
    nl: 'Autorijscholen en vlieg- en vaaronderricht',
    fr: 'Enseignement de la conduite',
    en: 'Driving school activities',
  },
  {
    code: '8559',
    nl: 'Overig onderwijs, n.e.g.',
    fr: 'Enseignements divers',
    en: 'Other education n.e.c.',
  },
  {
    code: '8560',
    nl: 'Onderwijsondersteunende activiteiten',
    fr: "Activités de soutien à l'enseignement",
    en: 'Educational support activities',
  },
  {
    code: '8610',
    nl: 'Ziekenhuizen',
    fr: 'Activités hospitalières',
    en: 'Hospital activities',
  },
  {
    code: '8621',
    nl: 'Huisartspraktijken',
    fr: 'Activités des médecins généralistes',
    en: 'General medical practice activities',
  },
  {
    code: '8622',
    nl: 'Praktijken van specialisten',
    fr: 'Activités des médecins spécialistes',
    en: 'Specialist medical practice activities',
  },
  {
    code: '8623',
    nl: 'Tandartspraktijken',
    fr: 'Pratique dentaire',
    en: 'Dental practice activities',
  },
  {
    code: '8690',
    nl: 'Overige menselijke gezondheidszorg',
    fr: 'Autres activités pour la santé humaine',
    en: 'Other human health activities',
  },
  {
    code: '8710',
    nl: 'Verpleeginstellingen met huisvesting',
    fr: 'Activités de soins infirmiers résidentiels',
    en: 'Residential nursing care activities',
  },
  {
    code: '8720',
    nl: 'Instellingen met huisvesting voor personen met een mentale handicap of psychiatrische problemen en voor drugs- en alcoholverslaafden',
    fr: 'Activités de soins résidentiels pour personnes avec un handicap mental, un problème psychiatrique ou toxicodépendantes',
    en: 'Residential care activities for mental retardation, mental health and substance abuse',
  },
  {
    code: '8730',
    nl: 'Instellingen met huisvesting voor ouderen en voor personen met een lichamelijke handicap',
    fr: 'Activités de soins résidentiels pour personnes âgées ou avec un handicap moteur',
    en: 'Residential care activities for the elderly and disabled',
  },
  {
    code: '8790',
    nl: 'Overige maatschappelijke dienstverlening met huisvesting',
    fr: 'Autres activités sociales avec hébergement',
    en: 'Other residential care activities',
  },
  {
    code: '8810',
    nl: 'Maatschappelijke dienstverlening zonder huisvesting voor ouderen en lichamelijk gehandicapten',
    fr: 'Action sociale sans hébergement pour personnes âgées et pour personnes avec un handicap moteur',
    en: 'Social work activities without accommodation for the elderly and disabled',
  },
  {
    code: '8891',
    nl: 'Kinderopvang',
    fr: 'Action sociale sans hébergement pour jeunes enfants',
    en: 'Child day-care activities',
  },
  {
    code: '8899',
    nl: 'Overige maatschappelijke dienstverlening zonder huisvesting, n.e.g.',
    fr: 'Autre action sociale sans hébergement n.c.a.',
    en: 'Other social work activities without accommodation n.e.c.',
  },
  {
    code: '9001',
    nl: 'Uitvoerende kunsten',
    fr: 'Arts du spectacle vivant',
    en: 'Performing arts',
  },
  {
    code: '9002',
    nl: 'Ondersteunende activiteiten voor uitvoerende kunsten',
    fr: 'Activités de soutien au spectacle vivant',
    en: 'Support activities to performing arts',
  },
  {
    code: '9003',
    nl: 'Scheppende kunsten',
    fr: 'Création artistique',
    en: 'Artistic creation',
  },
  {
    code: '9004',
    nl: 'Exploitatie van zalen',
    fr: 'Gestion de salles de spectacles',
    en: 'Operation of arts facilities',
  },
  {
    code: '9101',
    nl: 'Bibliotheken en archieven',
    fr: 'Gestion des bibliothèques et des archives',
    en: 'Library and archives activities',
  },
  {
    code: '9102',
    nl: 'Musea',
    fr: 'Gestion des musées',
    en: 'Museums activities',
  },
  {
    code: '9103',
    nl: 'Exploitatie van monumenten en dergelijke toeristenattracties',
    fr: 'Gestion des sites et monuments historiques et des attractions touristiques similaires',
    en: 'Operation of historical sites and buildings and similar visitor attractions',
  },
  {
    code: '9104',
    nl: 'Botanische tuinen, dierentuinen en natuurreservaten',
    fr: 'Gestion des jardins botaniques et zoologiques et des réserves naturelles',
    en: 'Botanical and zoological gardens and nature reserves activities',
  },
  {
    code: '9200',
    nl: 'Loterijen en kansspelen',
    fr: "Organisation de jeux de hasard et d'argent",
    en: 'Gambling and betting activities',
  },
  {
    code: '9311',
    nl: 'Exploitatie van sportaccommodaties',
    fr: "Gestion d'installations sportives",
    en: 'Operation of sports facilities',
  },
  {
    code: '9312',
    nl: 'Sportclubs',
    fr: 'Activités de clubs de sports',
    en: 'Activities of sport clubs',
  },
  {
    code: '9313',
    nl: 'Fitnesscentra',
    fr: 'Activités des centres de culture physique',
    en: 'Fitness facilities',
  },
  {
    code: '9319',
    nl: 'Overige sport',
    fr: 'Autres activités liées au sport',
    en: 'Other sports activities',
  },
  {
    code: '9321',
    nl: 'Kermisattracties en pret- en themaparken',
    fr: "Activités foraines, des parcs d'attractions et des parcs à thèmes",
    en: 'Activities of amusement parks and theme parks',
  },
  {
    code: '9329',
    nl: 'Overige ontspanning en recreatie',
    fr: 'Autres activités récréatives et de loisirs',
    en: 'Other amusement and recreation activities',
  },
  {
    code: '9411',
    nl: 'Bedrijfs- en werkgeversorganisaties',
    fr: 'Activités des organisations patronales et économiques',
    en: 'Activities of business and employers membership organisations',
  },
  {
    code: '9412',
    nl: 'Beroepsorganisaties',
    fr: 'Activités des organisations professionnelles',
    en: 'Activities of professional membership organisations',
  },
  {
    code: '9420',
    nl: 'Vakverenigingen',
    fr: 'Activités des syndicats de salariés',
    en: 'Activities of trade unions',
  },
  {
    code: '9491',
    nl: 'Religieuze organisaties',
    fr: 'Activités des organisations religieuses et philosophiques',
    en: 'Activities of religious organisations',
  },
  {
    code: '9492',
    nl: 'Politieke organisaties',
    fr: 'Activités des organisations politiques',
    en: 'Activities of political organisations',
  },
  {
    code: '9499',
    nl: 'Overige verenigingen, n.e.g.',
    fr: 'Activités des organisations associatives n.c.a.',
    en: 'Activities of other membership organisations n.e.c.',
  },
  {
    code: '9511',
    nl: 'Reparatie van computers en randapparatuur',
    fr: "Réparation d'ordinateurs et d'équipements périphériques",
    en: 'Repair of computers and peripheral equipment',
  },
  {
    code: '9512',
    nl: 'Reparatie van communicatieapparatuur',
    fr: "Réparation d'équipements de communication",
    en: 'Repair of communication equipment',
  },
  {
    code: '9521',
    nl: 'Reparatie van consumentenelektronica',
    fr: 'Réparation de produits électroniques grand public',
    en: 'Repair of consumer electronics',
  },
  {
    code: '9522',
    nl: 'Reparatie van huishoudapparaten en van werktuigen voor gebruik in huis en tuin',
    fr: "Réparation d'appareils électroménagers et d'équipements pour la maison et le jardin",
    en: 'Repair of household appliances and home and garden equipment',
  },
  {
    code: '9523',
    nl: 'Reparatie van schoeisel en lederwaren',
    fr: "Réparation de chaussures et d'articles en cuir",
    en: 'Repair of footwear and leather goods',
  },
  {
    code: '9524',
    nl: 'Reparatie van meubelen en stoffering',
    fr: "Réparation de meubles et d'équipements du foyer",
    en: 'Repair of furniture and home furnishings',
  },
  {
    code: '9525',
    nl: 'Reparatie van uurwerken en sieraden',
    fr: "Réparation d'articles d'horlogerie et de bijouterie",
    en: 'Repair of watches, clocks and jewellery',
  },
  {
    code: '9529',
    nl: 'Reparatie van andere consumentenartikelen',
    fr: "Réparation d'autres biens personnels et domestiques",
    en: 'Repair of other personal and household goods',
  },
  {
    code: '9601',
    nl: 'Wassen en (chemisch) reinigen van textiel en bontproducten',
    fr: 'Blanchisserie-teinturerie',
    en: 'Washing and (dry-)cleaning of textile and fur products',
  },
  {
    code: '9602',
    nl: 'Haar- en schoonheidsverzorging',
    fr: 'Coiffure et soins de beauté',
    en: 'Hairdressing and other beauty treatment',
  },
  {
    code: '9603',
    nl: 'Begrafeniswezen',
    fr: 'Services funéraires',
    en: 'Funeral and related activities',
  },
  {
    code: '9604',
    nl: "Sauna's, solaria, baden enz.",
    fr: 'Entretien corporel',
    en: 'Physical well-being activities',
  },
  {
    code: '9609',
    nl: 'Overige persoonlijke diensten, n.e.g.',
    fr: 'Autres services personnels n.c.a.',
    en: 'Other personal service activities n.e.c.',
  },
  {
    code: '9700',
    nl: 'Huishoudens als werkgever van huishoudelijk personeel',
    fr: "Activités des ménages en tant qu'employeurs de personnel domestique",
    en: 'Activities of households as employers of domestic personnel',
  },
  {
    code: '9810',
    nl: 'Niet-gedifferentieerde productie van goederen door particuliere huis- houdens voor eigen gebruik',
    fr: 'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
    en: 'Undifferentiated goods-producing activities of private households for own use',
  },
  {
    code: '9820',
    nl: 'Niet-gedifferentieerde productie van diensten door particuliere huis-houdens voor eigen gebruik',
    fr: 'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
    en: 'Undifferentiated service-producing activities of private households for own use',
  },
  {
    code: '9900',
    nl: 'Extraterritoriale organisaties en lichamen',
    fr: 'Activités des organisations et organismes extraterritoriaux',
    en: 'Activities of extraterritorial organisations and bodies',
  },

  {
    code: '01110',
    nl: 'Teelt van granen (m.u.v. rijst), peulgewassen en oliehoudende zaden',
    fr: "Culture de céréales (à l'exception du riz), de légumineuses et de graines oléagineuses",
    en: 'Teelt van granen (m.u.v. rijst), peulgewassen en oliehoudende zaden',
  },
  {
    code: '01120',
    nl: 'Teelt van rijst',
    fr: 'Culture du riz',
    en: 'Teelt van rijst',
  },
  {
    code: '01130',
    nl: 'Teelt van groenten, meloenen en wortel- en knolgewassen',
    fr: 'Culture de légumes, de melons, de racines et de tubercules',
    en: 'Teelt van groenten, meloenen en wortel- en knolgewassen',
  },
  {
    code: '01140',
    nl: 'Teelt van suikerriet',
    fr: 'Culture de la canne à sucre',
    en: 'Teelt van suikerriet',
  },
  {
    code: '01150',
    nl: 'Teelt van tabak',
    fr: 'Culture du tabac',
    en: 'Teelt van tabak',
  },
  {
    code: '01160',
    nl: 'Teelt van vezelgewassen',
    fr: 'Culture de plantes à fibres',
    en: 'Teelt van vezelgewassen',
  },
  {
    code: '01191',
    nl: 'Teelt van bloemen',
    fr: 'Culture de fleurs',
    en: 'Teelt van bloemen',
  },
  {
    code: '01199',
    nl: 'Teelt van andere eenjarige gewassen, n.e.g.',
    fr: 'Autres cultures non permanentes n.c.a.',
    en: 'Teelt van andere eenjarige gewassen, n.e.g.',
  },
  {
    code: '01210',
    nl: 'Teelt van druiven',
    fr: 'Culture de la vigne',
    en: 'Teelt van druiven',
  },
  {
    code: '01220',
    nl: 'Teelt van tropisch en subtropisch fruit',
    fr: 'Culture de fruits tropicaux et subtropicaux',
    en: 'Teelt van tropisch en subtropisch fruit',
  },
  {
    code: '01230',
    nl: 'Teelt van citrusvruchten',
    fr: "Culture d'agrumes",
    en: 'Teelt van citrusvruchten',
  },
  {
    code: '01240',
    nl: 'Teelt van pit- en steenvruchten',
    fr: 'Culture de fruits à pépins et à noyau',
    en: 'Teelt van pit- en steenvruchten',
  },
  {
    code: '01250',
    nl: 'Teelt van andere boomvruchten, kleinfruit en noten',
    fr: "Culture d'autres fruits d'arbres ou d'arbustes et de fruits à coque",
    en: 'Teelt van andere boomvruchten, kleinfruit en noten',
  },
  {
    code: '01260',
    nl: 'Teelt van oliehoudende vruchten',
    fr: 'Culture de fruits oléagineux',
    en: 'Teelt van oliehoudende vruchten',
  },
  {
    code: '01270',
    nl: 'Teelt van gewassen bestemd voor de vervaardiging van dranken',
    fr: 'Culture de plantes à boissons',
    en: 'Teelt van gewassen bestemd voor de vervaardiging van dranken',
  },
  {
    code: '01280',
    nl: 'Teelt van specerijgewassen en van aromatische en medicinale gewassen',
    fr: 'Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques',
    en: 'Teelt van specerijgewassen en van aromatische en medicinale gewassen',
  },
  {
    code: '01290',
    nl: 'Teelt van andere meerjarige gewassen',
    fr: 'Autres cultures permanentes',
    en: 'Teelt van andere meerjarige gewassen',
  },
  {
    code: '01301',
    nl: 'Boomkwekerijen, m.u.v. bosboomkwekerijen',
    fr: 'Exploitation de pépinières, sauf pépinières forestières',
    en: 'Boomkwekerijen, m.u.v. bosboomkwekerijen',
  },
  {
    code: '01309',
    nl: 'Overige plantenvermeerdering',
    fr: 'Autre reproduction de plantes',
    en: 'Overige plantenvermeerdering',
  },
  {
    code: '01410',
    nl: 'Fokken van melkvee',
    fr: 'Élevage de vaches laitières',
    en: 'Fokken van melkvee',
  },
  {
    code: '01420',
    nl: 'Fokken van andere runderen en buffels',
    fr: "Élevage d'autres bovins et de buffles",
    en: 'Fokken van andere runderen en buffels',
  },
  {
    code: '01430',
    nl: 'Fokken van paarden en andere paardachtigen',
    fr: "Élevage de chevaux et d'autres équidés",
    en: 'Fokken van paarden en andere paardachtigen',
  },
  {
    code: '01440',
    nl: 'Fokken van kamelen en andere kameelachtigen',
    fr: "Élevage de chameaux et d'autres camélidés",
    en: 'Fokken van kamelen en andere kameelachtigen',
  },
  {
    code: '01450',
    nl: 'Fokken van schapen en geiten',
    fr: "Élevage d'ovins et de caprins",
    en: 'Fokken van schapen en geiten',
  },
  {
    code: '01461',
    nl: 'Fokvarkenshouderijen',
    fr: 'Élevage de porcs reproducteurs',
    en: 'Fokvarkenshouderijen',
  },
  {
    code: '01462',
    nl: 'Varkensvetmesterijen',
    fr: "Élevage de porcs à l'engrais",
    en: 'Varkensvetmesterijen',
  },
  {
    code: '01471',
    nl: 'Kippenkwekerijen',
    fr: 'Elevage de poules',
    en: 'Kippenkwekerijen',
  },
  {
    code: '01472',
    nl: 'Productie van eieren van pluimvee',
    fr: "Production d'ufs de volailles",
    en: 'Productie van eieren van pluimvee',
  },
  {
    code: '01479',
    nl: 'Pluimveehouderijen, m.u.v. kippenkwekerijen',
    fr: 'Élevage de volailles, sauf poules',
    en: 'Pluimveehouderijen, m.u.v. kippenkwekerijen',
  },
  {
    code: '01490',
    nl: 'Fokken van andere dieren',
    fr: "Élevage d'autres animaux",
    en: 'Fokken van andere dieren',
  },
  {
    code: '01500',
    nl: 'Gemengd bedrijf',
    fr: 'Culture et élevage associés',
    en: 'Gemengd bedrijf',
  },
  {
    code: '01610',
    nl: 'Ondersteunende activiteiten in verband met de teelt van gewassen',
    fr: 'Activités de soutien aux cultures',
    en: 'Ondersteunende activiteiten in verband met de teelt van gewassen',
  },
  {
    code: '01620',
    nl: 'Ondersteunende activiteiten in verband met de veeteelt',
    fr: 'Activités de soutien à la production animale',
    en: 'Ondersteunende activiteiten in verband met de veeteelt',
  },
  {
    code: '01630',
    nl: 'Activiteiten met betrekking tot gewassen na de oogst',
    fr: 'Traitement primaire des récoltes',
    en: 'Activiteiten met betrekking tot gewassen na de oogst',
  },
  {
    code: '01640',
    nl: 'Zaadbewerking met het oog op vermeerdering',
    fr: 'Traitement des semences',
    en: 'Zaadbewerking met het oog op vermeerdering',
  },
  {
    code: '01700',
    nl: 'Jacht, zetten van vallen en diensten in verband met deze activiteiten',
    fr: 'Chasse, piégeage et services annexes',
    en: 'Jacht, zetten van vallen en diensten in verband met deze activiteiten',
  },
  {
    code: '02100',
    nl: 'Bosbouw',
    fr: 'Sylviculture et autres activités forestières',
    en: 'Bosbouw',
  },
  {
    code: '02200',
    nl: 'Exploitatie van bossen',
    fr: 'Exploitation forestière',
    en: 'Exploitatie van bossen',
  },
  {
    code: '02300',
    nl: 'Verzamelen van in het wild groeiende producten met uitzondering van hout',
    fr: "Récolte de produits forestiers non ligneux poussant à l'état sauvage",
    en: 'Verzamelen van in het wild groeiende producten met uitzondering van hout',
  },
  {
    code: '02400',
    nl: 'Ondersteunende diensten in verband met de bosbouw',
    fr: "Services de soutien à l'exploitation forestière",
    en: 'Ondersteunende diensten in verband met de bosbouw',
  },
  { code: '03110', nl: 'Zeevisserij', fr: 'Pêche en mer', en: 'Zeevisserij' },
  {
    code: '03120',
    nl: 'Binnenvisserij',
    fr: 'Pêche en eau douce',
    en: 'Binnenvisserij',
  },
  {
    code: '03210',
    nl: 'Mariene aquacultuur',
    fr: 'Aquaculture en mer',
    en: 'Mariene aquacultuur',
  },
  {
    code: '03220',
    nl: 'Aquacultuur in zoet water',
    fr: 'Aquaculture en eau douce',
    en: 'Aquacultuur in zoet water',
  },
  {
    code: '05100',
    nl: 'Winning van steenkool',
    fr: 'Extraction de houille',
    en: 'Winning van steenkool',
  },
  {
    code: '05200',
    nl: 'Winning van bruinkool',
    fr: 'Extraction de lignite',
    en: 'Winning van bruinkool',
  },
  {
    code: '06100',
    nl: 'Winning van aardolie',
    fr: 'Extraction de pétrole brut',
    en: 'Winning van aardolie',
  },
  {
    code: '06200',
    nl: 'Winning van aardgas',
    fr: 'Extraction de gaz naturel',
    en: 'Winning van aardgas',
  },
  {
    code: '07100',
    nl: 'Winning van ijzererts',
    fr: 'Extraction de minerais de fer',
    en: 'Winning van ijzererts',
  },
  {
    code: '07210',
    nl: 'Winning van uranium- en thoriumerts',
    fr: "Extraction de minerais d'uranium et de thorium",
    en: 'Winning van uranium- en thoriumerts',
  },
  {
    code: '07290',
    nl: 'Winning van andere non-ferrometaalertsen',
    fr: "Extraction d'autres minerais de métaux non ferreux",
    en: 'Winning van andere non-ferrometaalertsen',
  },
  {
    code: '08111',
    nl: 'Winning van bouw- en siersteen',
    fr: 'Extraction de pierres ornementales et de construction',
    en: 'Winning van bouw- en siersteen',
  },
  {
    code: '08112',
    nl: 'Winning van kalksteen, gips, krijt en leisteen',
    fr: "Extraction de pierres calcaires, de gypse, de craie et d'ardoise",
    en: 'Winning van kalksteen, gips, krijt en leisteen',
  },
  {
    code: '08121',
    nl: 'Winning van grind',
    fr: 'Extraction de gravier',
    en: 'Winning van grind',
  },
  {
    code: '08122',
    nl: 'Winning van zand',
    fr: 'Extraction de sable',
    en: 'Winning van zand',
  },
  {
    code: '08123',
    nl: 'Winning van klei en kaolien',
    fr: "Extraction d'argiles et de kaolin",
    en: 'Winning van klei en kaolien',
  },
  {
    code: '08910',
    nl: 'Winning van mineralen voor de chemische en de kunstmestindustrie',
    fr: "Extraction des minéraux chimiques et d'engrais minéraux",
    en: 'Winning van mineralen voor de chemische en de kunstmestindustrie',
  },
  {
    code: '08920',
    nl: 'Winning van turf',
    fr: 'Extraction de tourbe',
    en: 'Winning van turf',
  },
  {
    code: '08930',
    nl: 'Zoutwinning',
    fr: 'Production de sel',
    en: 'Zoutwinning',
  },
  {
    code: '08990',
    nl: 'Overige winning van delfstoffen, n.e.g.',
    fr: 'Autres activités extractives n.c.a.',
    en: 'Overige winning van delfstoffen, n.e.g.',
  },
  {
    code: '09100',
    nl: 'Ondersteunende activiteiten in verband met de aardolie- en aardgaswinning',
    fr: "Activités de soutien à l'extraction d'hydrocarbures",
    en: 'Ondersteunende activiteiten in verband met de aardolie- en aardgaswinning',
  },
  {
    code: '09900',
    nl: 'Ondersteunende activiteiten in verband met de overige winning van delfstoffen',
    fr: 'Activités de soutien aux autres industries extractives',
    en: 'Ondersteunende activiteiten in verband met de overige winning van delfstoffen',
  },
  {
    code: '10110',
    nl: 'Verwerking en conservering van vlees, exclusief vlees van gevogelte',
    fr: "Transformation et conservation de la viande de boucherie, à l'exclusion de la viande de volaille",
    en: 'Verwerking en conservering van vlees, exclusief vlees van gevogelte',
  },
  {
    code: '10120',
    nl: 'Verwerking en conservering van gevogelte',
    fr: 'Transformation et conservation de la viande de volaille',
    en: 'Verwerking en conservering van gevogelte',
  },
  {
    code: '10130',
    nl: 'Vervaardiging van producten van vlees of van vlees van gevogelte',
    fr: 'Préparation de produits à base de viande ou de viande de volaille',
    en: 'Vervaardiging van producten van vlees of van vlees van gevogelte',
  },
  {
    code: '10200',
    nl: 'Verwerking en conservering van vis en van schaal- en weekdieren',
    fr: 'Transformation et conservation de poisson, de crustacés et de mollusques',
    en: 'Verwerking en conservering van vis en van schaal- en weekdieren',
  },
  {
    code: '10311',
    nl: 'Verwerking en conservering van aardappelen, exclusief productie van diepgevroren aardappelbereidingen',
    fr: 'Transformation et conservation de pommes de terre, sauf fabrication de préparations surgelées à base de pommes de terre',
    en: 'Verwerking en conservering van aardappelen, exclusief productie van diepgevroren aardappelbereidingen',
  },
  {
    code: '10312',
    nl: 'Productie van diepgevroren aardappelbereidingen',
    fr: 'Fabrication de préparations surgelées à base de pommes de terre',
    en: 'Productie van diepgevroren aardappelbereidingen',
  },
  {
    code: '10320',
    nl: 'Vervaardiging van groente- en fruitsappen',
    fr: 'Préparation de jus de fruits et de légumes',
    en: 'Vervaardiging van groente- en fruitsappen',
  },
  {
    code: '10391',
    nl: 'Verwerking en conservering van groenten, exclusief productie van diepgevroren groenten',
    fr: 'Transformation et conservation de légumes, sauf fabrication de légumes surgelés',
    en: 'Verwerking en conservering van groenten, exclusief productie van diepgevroren groenten',
  },
  {
    code: '10392',
    nl: 'Verwerking en conservering van fruit, exclusief productie van diepgevroren fruit',
    fr: 'Transformation et conservation de fruits, sauf fabrication de fruits surgelés',
    en: 'Verwerking en conservering van fruit, exclusief productie van diepgevroren fruit',
  },
  {
    code: '10393',
    nl: 'Productie van diepgevroren groenten en fruit',
    fr: 'Fabrication de légumes et de fruits surgelés',
    en: 'Productie van diepgevroren groenten en fruit',
  },
  {
    code: '10410',
    nl: 'Vervaardiging van oliën en vetten',
    fr: "Fabrication d'huiles et de graisses",
    en: 'Vervaardiging van oliën en vetten',
  },
  {
    code: '10420',
    nl: 'Vervaardiging van margarine en andere spijsvetten',
    fr: 'Fabrication de margarine et de graisses comestibles similaires',
    en: 'Vervaardiging van margarine en andere spijsvetten',
  },
  {
    code: '10510',
    nl: 'Zuivelfabrieken en kaasmakerijen',
    fr: 'Exploitation de laiteries et fabrication de fromage',
    en: 'Zuivelfabrieken en kaasmakerijen',
  },
  {
    code: '10520',
    nl: 'Vervaardiging van consumptie-ijs',
    fr: 'Fabrication de glaces de consommation',
    en: 'Vervaardiging van consumptie-ijs',
  },
  {
    code: '10610',
    nl: 'Vervaardiging van maalderijproducten',
    fr: 'Travail des grains',
    en: 'Vervaardiging van maalderijproducten',
  },
  {
    code: '10620',
    nl: 'Vervaardiging van zetmeel en zetmeelproducten',
    fr: 'Fabrication de produits amylacés',
    en: 'Vervaardiging van zetmeel en zetmeelproducten',
  },
  {
    code: '10711',
    nl: 'Industriële vervaardiging van brood en van vers banketbakkerswerk',
    fr: 'Fabrication industrielle de pain et de pâtisserie fraîche',
    en: 'Industriële vervaardiging van brood en van vers banketbakkerswerk',
  },
  {
    code: '10712',
    nl: 'Ambachtelijke vervaardiging van brood en van vers banketbakkerswerk',
    fr: 'Fabrication artisanale de pain et de pâtisserie fraîche',
    en: 'Ambachtelijke vervaardiging van brood en van vers banketbakkerswerk',
  },
  {
    code: '10720',
    nl: 'Vervaardiging van beschuit en biscuit en van ander houdbaar banketbakkerswerk',
    fr: 'Fabrication de biscuits, de biscottes et de pâtisseries de conservation',
    en: 'Vervaardiging van beschuit en biscuit en van ander houdbaar banketbakkerswerk',
  },
  {
    code: '10730',
    nl: 'Vervaardiging van macaroni, noedels, koeskoes en dergelijke deegwaren',
    fr: 'Fabrication de pâtes alimentaires',
    en: 'Vervaardiging van macaroni, noedels, koeskoes en dergelijke deegwaren',
  },
  {
    code: '10810',
    nl: 'Vervaardiging van suiker',
    fr: 'Fabrication de sucre',
    en: 'Vervaardiging van suiker',
  },
  {
    code: '10820',
    nl: 'Vervaardiging van cacao, chocolade en suikerwerk',
    fr: 'Fabrication de cacao, de chocolat et de produits de confiserie',
    en: 'Vervaardiging van cacao, chocolade en suikerwerk',
  },
  {
    code: '10830',
    nl: 'Verwerking van thee en koffie',
    fr: 'Transformation du thé et du café',
    en: 'Verwerking van thee en koffie',
  },
  {
    code: '10840',
    nl: 'Vervaardiging van specerijen, sauzen en kruiderijen',
    fr: "Fabrication de condiments et d'assaisonnements",
    en: 'Vervaardiging van specerijen, sauzen en kruiderijen',
  },
  {
    code: '10850',
    nl: 'Vervaardiging van bereide maaltijden en schotels',
    fr: 'Fabrication de plats préparés',
    en: 'Vervaardiging van bereide maaltijden en schotels',
  },
  {
    code: '10860',
    nl: 'Vervaardiging van gehomogeniseerde voedingspreparaten en dieetvoeding',
    fr: "Fabrication d'aliments homogénéisés et diététiques",
    en: 'Vervaardiging van gehomogeniseerde voedingspreparaten en dieetvoeding',
  },
  {
    code: '10890',
    nl: 'Vervaardiging van andere voedingsmiddelen, n.e.g.',
    fr: "Fabrication d'autres produits alimentaires n.c.a.",
    en: 'Vervaardiging van andere voedingsmiddelen, n.e.g.',
  },
  {
    code: '10910',
    nl: 'Vervaardiging van veevoeders',
    fr: "Fabrication d'aliments pour animaux de ferme",
    en: 'Vervaardiging van veevoeders',
  },
  {
    code: '10920',
    nl: 'Vervaardiging van voeders voor huisdieren',
    fr: "Fabrication d'aliments pour animaux de compagnie",
    en: 'Vervaardiging van voeders voor huisdieren',
  },
  {
    code: '11010',
    nl: 'Vervaardiging van gedistilleerde dranken door distilleren, rectificeren en mengen',
    fr: 'Production de boissons alcooliques distillées',
    en: 'Vervaardiging van gedistilleerde dranken door distilleren, rectificeren en mengen',
  },
  {
    code: '11020',
    nl: 'Vervaardiging van wijn uit druiven',
    fr: 'Production de vin (de raisin)',
    en: 'Vervaardiging van wijn uit druiven',
  },
  {
    code: '11030',
    nl: 'Vervaardiging van cider en van andere vruchtenwijnen',
    fr: "Fabrication de cidre et de vins d'autres fruits",
    en: 'Vervaardiging van cider en van andere vruchtenwijnen',
  },
  {
    code: '11040',
    nl: 'Vervaardiging van andere niet-gedistilleerde gegiste dranken',
    fr: "Production d'autres boissons fermentées non distillées",
    en: 'Vervaardiging van andere niet-gedistilleerde gegiste dranken',
  },
  {
    code: '11050',
    nl: 'Vervaardiging van bier',
    fr: 'Fabrication de bière',
    en: 'Vervaardiging van bier',
  },
  {
    code: '11060',
    nl: 'Vervaardiging van mout',
    fr: 'Fabrication de malt',
    en: 'Vervaardiging van mout',
  },
  {
    code: '11070',
    nl: 'Vervaardiging van frisdranken; productie van mineraalwater en ander gebotteld water',
    fr: 'Industrie des eaux minérales et autres eaux embouteillées et des boissons rafraîchissantes',
    en: 'Vervaardiging van frisdranken; productie van mineraalwater en ander gebotteld water',
  },
  {
    code: '12000',
    nl: 'Vervaardiging van tabaksproducten',
    fr: 'Fabrication de produits à base de tabac',
    en: 'Vervaardiging van tabaksproducten',
  },
  {
    code: '13100',
    nl: 'Bewerken en spinnen van textielvezels',
    fr: 'Préparation de fibres textiles et filature',
    en: 'Bewerken en spinnen van textielvezels',
  },
  {
    code: '13200',
    nl: 'Weven van textiel',
    fr: 'Tissage',
    en: 'Weven van textiel',
  },
  {
    code: '13300',
    nl: 'Textielveredeling',
    fr: 'Ennoblissement textile',
    en: 'Textielveredeling',
  },
  {
    code: '13910',
    nl: 'Vervaardiging van gebreide en gehaakte stoffen',
    fr: "Fabrication d'étoffes à mailles",
    en: 'Vervaardiging van gebreide en gehaakte stoffen',
  },
  {
    code: '13921',
    nl: 'Vervaardiging van beddengoed, tafellinnen en textielwaren voor huishoudelijk gebruik',
    fr: "Fabrication de linge de lit et de table et d'articles textiles à usage domestique",
    en: 'Vervaardiging van beddengoed, tafellinnen en textielwaren voor huishoudelijk gebruik',
  },
  {
    code: '13929',
    nl: 'Vervaardiging van overige geconfectioneerde artikelen van textiel, m.u.v. kleding',
    fr: "Fabrication d'autres articles textiles confectionnés, sauf habillement",
    en: 'Vervaardiging van overige geconfectioneerde artikelen van textiel, m.u.v. kleding',
  },
  {
    code: '13930',
    nl: 'Vervaardiging van vloerkleden en tapijt',
    fr: 'Fabrication de tapis et de moquettes',
    en: 'Vervaardiging van vloerkleden en tapijt',
  },
  {
    code: '13940',
    nl: 'Vervaardiging van koord, bindgaren, touw en netten',
    fr: 'Fabrication de ficelles, de cordes et de filets',
    en: 'Vervaardiging van koord, bindgaren, touw en netten',
  },
  {
    code: '13950',
    nl: 'Vervaardiging van gebonden textielvlies en van artikelen van gebonden textielvlies, exclusief kleding',
    fr: 'Fabrication de non-tissés, sauf habillement',
    en: 'Vervaardiging van gebonden textielvlies en van artikelen van gebonden textielvlies, exclusief kleding',
  },
  {
    code: '13960',
    nl: 'Vervaardiging van ander technisch en industrieel textiel',
    fr: "Fabrication d'autres textiles techniques et industriels",
    en: 'Vervaardiging van ander technisch en industrieel textiel',
  },
  {
    code: '13990',
    nl: 'Vervaardiging van andere textielproducten, n.e.g.',
    fr: "Fabrication d'autres textiles n.c.a.",
    en: 'Vervaardiging van andere textielproducten, n.e.g.',
  },
  {
    code: '14110',
    nl: 'Vervaardiging van kleding van leer',
    fr: 'Fabrication de vêtements en cuir',
    en: 'Vervaardiging van kleding van leer',
  },
  {
    code: '14120',
    nl: 'Vervaardiging van werkkleding',
    fr: 'Fabrication de vêtements de travail',
    en: 'Vervaardiging van werkkleding',
  },
  {
    code: '14130',
    nl: 'Vervaardiging van andere bovenkleding',
    fr: "Fabrication d'autres vêtements de dessus",
    en: 'Vervaardiging van andere bovenkleding',
  },
  {
    code: '14140',
    nl: 'Vervaardiging van onderkleding',
    fr: 'Fabrication de vêtements de dessous',
    en: 'Vervaardiging van onderkleding',
  },
  {
    code: '14191',
    nl: 'Vervaardiging van hoeden en petten',
    fr: 'Fabrication de chapeaux et de bonnets',
    en: 'Vervaardiging van hoeden en petten',
  },
  {
    code: '14199',
    nl: 'Vervaardiging van andere kleding en toebehoren, n.e.g.',
    fr: "Fabrication d'autres vêtements et accessoires n.c.a.",
    en: 'Vervaardiging van andere kleding en toebehoren, n.e.g.',
  },
  {
    code: '14200',
    nl: 'Vervaardiging van artikelen van bont',
    fr: "Fabrication d'articles en fourrure",
    en: 'Vervaardiging van artikelen van bont',
  },
  {
    code: '14310',
    nl: 'Vervaardiging van gebreide en gehaakte kousen en sokken',
    fr: "Fabrication d'articles chaussants à mailles",
    en: 'Vervaardiging van gebreide en gehaakte kousen en sokken',
  },
  {
    code: '14390',
    nl: 'Vervaardiging van andere gebreide en gehaakte kleding',
    fr: "Fabrication d'autres articles à mailles",
    en: 'Vervaardiging van andere gebreide en gehaakte kleding',
  },
  {
    code: '15110',
    nl: 'Looien en bereiden van leer; bereiden en verven van bont',
    fr: 'Apprêt et tannage des cuirs; préparation et teinture des fourrures',
    en: 'Looien en bereiden van leer; bereiden en verven van bont',
  },
  {
    code: '15120',
    nl: 'Vervaardiging van koffers, tassen en dergelijke en van zadel- en tuigmakerswerk',
    fr: "Fabrication d'articles de voyage, de maroquinerie et de sellerie",
    en: 'Vervaardiging van koffers, tassen en dergelijke en van zadel- en tuigmakerswerk',
  },
  {
    code: '15200',
    nl: 'Vervaardiging van schoeisel',
    fr: 'Fabrication de chaussures',
    en: 'Vervaardiging van schoeisel',
  },
  {
    code: '16100',
    nl: 'Zagen en schaven van hout',
    fr: 'Sciage et rabotage du bois',
    en: 'Zagen en schaven van hout',
  },
  {
    code: '16210',
    nl: 'Vervaardiging van fineer en van panelen op basis van hout',
    fr: 'Fabrication de placage et de panneaux de bois',
    en: 'Vervaardiging van fineer en van panelen op basis van hout',
  },
  {
    code: '16220',
    nl: 'Vervaardiging van geassembleerde parketvloeren',
    fr: 'Fabrication de parquets assemblés',
    en: 'Vervaardiging van geassembleerde parketvloeren',
  },
  {
    code: '16230',
    nl: 'Vervaardiging van ander schrijn- en timmerwerk',
    fr: "Fabrication de charpentes et d'autres menuiseries",
    en: 'Vervaardiging van ander schrijn- en timmerwerk',
  },
  {
    code: '16240',
    nl: 'Vervaardiging van houten emballage',
    fr: "Fabrication d'emballages en bois",
    en: 'Vervaardiging van houten emballage',
  },
  {
    code: '16291',
    nl: 'Vervaardiging van andere artikelen van hout',
    fr: "Fabrication d'objets divers en bois",
    en: 'Vervaardiging van andere artikelen van hout',
  },
  {
    code: '16292',
    nl: 'Vervaardiging van artikelen van kurk, riet of vlechtwerk',
    fr: "Fabrication d'objets en liège, vannerie et sparterie",
    en: 'Vervaardiging van artikelen van kurk, riet of vlechtwerk',
  },
  {
    code: '17110',
    nl: 'Vervaardiging van papierpulp',
    fr: 'Fabrication de pâte à papier',
    en: 'Vervaardiging van papierpulp',
  },
  {
    code: '17120',
    nl: 'Vervaardiging van papier en karton',
    fr: 'Fabrication de papier et de carton',
    en: 'Vervaardiging van papier en karton',
  },
  {
    code: '17210',
    nl: 'Vervaardiging van gegolfd papier en golfkarton en van verpakkingsmateriaal van papier en karton',
    fr: "Fabrication de papier et de carton ondulés et d'emballages en papier ou en carton",
    en: 'Vervaardiging van gegolfd papier en golfkarton en van verpakkingsmateriaal van papier en karton',
  },
  {
    code: '17220',
    nl: 'Vervaardiging van huishoudelijke en sanitaire papierwaren',
    fr: "Fabrication d'articles en papier à usage sanitaire ou domestique",
    en: 'Vervaardiging van huishoudelijke en sanitaire papierwaren',
  },
  {
    code: '17230',
    nl: 'Vervaardiging van kantoorbenodigdheden van papier',
    fr: "Fabrication d'articles de papeterie",
    en: 'Vervaardiging van kantoorbenodigdheden van papier',
  },
  {
    code: '17240',
    nl: 'Vervaardiging van behangpapier',
    fr: 'Fabrication de papiers peints',
    en: 'Vervaardiging van behangpapier',
  },
  {
    code: '17290',
    nl: 'Vervaardiging van andere artikelen van papier of karton',
    fr: "Fabrication d'autres articles en papier ou en carton",
    en: 'Vervaardiging van andere artikelen van papier of karton',
  },
  {
    code: '18110',
    nl: 'Krantendrukkerijen',
    fr: 'Imprimerie de journaux',
    en: 'Krantendrukkerijen',
  },
  {
    code: '18120',
    nl: 'Overige drukkerijen',
    fr: 'Autre imprimerie (labeur)',
    en: 'Overige drukkerijen',
  },
  {
    code: '18130',
    nl: 'Prepress- en premediadiensten',
    fr: 'Activités de prépresse',
    en: 'Prepress- en premediadiensten',
  },
  {
    code: '18140',
    nl: 'Binderijen en aanverwante diensten',
    fr: 'Reliure et activités annexes',
    en: 'Binderijen en aanverwante diensten',
  },
  {
    code: '18200',
    nl: 'Reproductie van opgenomen media',
    fr: "Reproduction d'enregistrements",
    en: 'Reproductie van opgenomen media',
  },
  {
    code: '19100',
    nl: 'Vervaardiging van cokesovenproducten',
    fr: 'Cokéfaction',
    en: 'Vervaardiging van cokesovenproducten',
  },
  {
    code: '19200',
    nl: 'Vervaardiging van geraffineerde aardolieproducten',
    fr: 'Raffinage du pétrole',
    en: 'Vervaardiging van geraffineerde aardolieproducten',
  },
  {
    code: '20110',
    nl: 'Vervaardiging van industriële gassen',
    fr: 'Fabrication de gaz industriels',
    en: 'Vervaardiging van industriële gassen',
  },
  {
    code: '20120',
    nl: 'Vervaardiging van kleurstoffen en pigmenten',
    fr: 'Fabrication de colorants et de pigments',
    en: 'Vervaardiging van kleurstoffen en pigmenten',
  },
  {
    code: '20130',
    nl: 'Vervaardiging van andere anorganische chemische basisproducten',
    fr: "Fabrication d'autres produits chimiques inorganiques de base",
    en: 'Vervaardiging van andere anorganische chemische basisproducten',
  },
  {
    code: '20140',
    nl: 'Vervaardiging van andere organische chemische basisproducten',
    fr: "Fabrication d'autres produits chimiques organiques de base",
    en: 'Vervaardiging van andere organische chemische basisproducten',
  },
  {
    code: '20150',
    nl: 'Vervaardiging van kunstmeststoffen en stikstofverbindingen',
    fr: "Fabrication de produits azotés et d'engrais",
    en: 'Vervaardiging van kunstmeststoffen en stikstofverbindingen',
  },
  {
    code: '20160',
    nl: 'Vervaardiging van kunststoffen in primaire vormen',
    fr: 'Fabrication de matières plastiques de base',
    en: 'Vervaardiging van kunststoffen in primaire vormen',
  },
  {
    code: '20170',
    nl: 'Vervaardiging van synthetische rubber in primaire vormen',
    fr: 'Fabrication de caoutchouc synthétique',
    en: 'Vervaardiging van synthetische rubber in primaire vormen',
  },
  {
    code: '20200',
    nl: 'Vervaardiging van verdelgingsmiddelen en van andere chemische producten voor de landbouw',
    fr: "Fabrication de pesticides et d'autres produits agrochimiques",
    en: 'Vervaardiging van verdelgingsmiddelen en van andere chemische producten voor de landbouw',
  },
  {
    code: '20300',
    nl: 'Vervaardiging van verf, vernis e.d., drukinkt en mastiek',
    fr: "Fabrication de peintures, de vernis, d'encres et de mastics",
    en: 'Vervaardiging van verf, vernis e.d., drukinkt en mastiek',
  },
  {
    code: '20411',
    nl: 'Vervaardiging van zeep en wasmiddelen',
    fr: 'Fabrication de savons et de détergents',
    en: 'Vervaardiging van zeep en wasmiddelen',
  },
  {
    code: '20412',
    nl: 'Vervaardiging van poets- en reinigingsmiddelen',
    fr: "Fabrication de produits d'entretien",
    en: 'Vervaardiging van poets- en reinigingsmiddelen',
  },
  {
    code: '20420',
    nl: 'Vervaardiging van parfums en toiletartikelen',
    fr: 'Fabrication de parfums et de produits de toilette',
    en: 'Vervaardiging van parfums en toiletartikelen',
  },
  {
    code: '20510',
    nl: 'Vervaardiging van kruit en springstoffen',
    fr: 'Fabrication de produits explosifs',
    en: 'Vervaardiging van kruit en springstoffen',
  },
  {
    code: '20520',
    nl: 'Vervaardiging van lijm',
    fr: 'Fabrication de colles',
    en: 'Vervaardiging van lijm',
  },
  {
    code: '20530',
    nl: 'Vervaardiging van etherische oliën',
    fr: "Fabrication d'huiles essentielles",
    en: 'Vervaardiging van etherische oliën',
  },
  {
    code: '20590',
    nl: 'Vervaardiging van andere chemische producten, n.e.g.',
    fr: "Fabrication d'autres produits chimiques n.c.a.",
    en: 'Vervaardiging van andere chemische producten, n.e.g.',
  },
  {
    code: '20600',
    nl: 'Vervaardiging van synthetische en kunstmatige vezels',
    fr: 'Fabrication de fibres artificielles ou synthétiques',
    en: 'Vervaardiging van synthetische en kunstmatige vezels',
  },
  {
    code: '21100',
    nl: 'Vervaardiging van farmaceutische grondstoffen',
    fr: 'Fabrication de produits pharmaceutiques de base',
    en: 'Vervaardiging van farmaceutische grondstoffen',
  },
  {
    code: '21201',
    nl: 'Vervaardiging van geneesmiddelen',
    fr: 'Fabrication de médicaments',
    en: 'Vervaardiging van geneesmiddelen',
  },
  {
    code: '21209',
    nl: 'Vervaardiging van overige farmaceutische producten',
    fr: "Fabrication d'autres produits pharmaceutiques",
    en: 'Vervaardiging van overige farmaceutische producten',
  },
  {
    code: '22110',
    nl: 'Vervaardiging van binnen- en buitenbanden van rubber; loopvlakvernieuwing',
    fr: 'Fabrication et rechapage de pneumatiques',
    en: 'Vervaardiging van binnen- en buitenbanden van rubber; loopvlakvernieuwing',
  },
  {
    code: '22190',
    nl: 'Vervaardiging van andere producten van rubber',
    fr: "Fabrication d'autres articles en caoutchouc",
    en: 'Vervaardiging van andere producten van rubber',
  },
  {
    code: '22210',
    nl: 'Vervaardiging van platen, vellen, buizen en profielen van kunststof',
    fr: 'Fabrication de plaques, feuilles, tubes et profilés en matières plastiques',
    en: 'Vervaardiging van platen, vellen, buizen en profielen van kunststof',
  },
  {
    code: '22220',
    nl: 'Vervaardiging van verpakkingsmateriaal van kunststof',
    fr: "Fabrication d'emballages en matières plastiques",
    en: 'Vervaardiging van verpakkingsmateriaal van kunststof',
  },
  {
    code: '22230',
    nl: 'Vervaardiging van kunststofartikelen voor de bouw',
    fr: "Fabrication d'éléments en matières plastiques pour la construction",
    en: 'Vervaardiging van kunststofartikelen voor de bouw',
  },
  {
    code: '22290',
    nl: 'Vervaardiging van andere producten van kunststof',
    fr: "Fabrication d'autres articles en matières plastiques",
    en: 'Vervaardiging van andere producten van kunststof',
  },
  {
    code: '23110',
    nl: 'Vervaardiging van vlakglas',
    fr: 'Fabrication de verre plat',
    en: 'Vervaardiging van vlakglas',
  },
  {
    code: '23120',
    nl: 'Vormen en bewerken van vlakglas',
    fr: 'Façonnage et transformation du verre plat',
    en: 'Vormen en bewerken van vlakglas',
  },
  {
    code: '23130',
    nl: 'Vervaardiging van holglas',
    fr: 'Fabrication de verre creux',
    en: 'Vervaardiging van holglas',
  },
  {
    code: '23140',
    nl: 'Vervaardiging van glasvezels',
    fr: 'Fabrication de fibres de verre',
    en: 'Vervaardiging van glasvezels',
  },
  {
    code: '23190',
    nl: 'Vervaardiging en bewerking van ander glas (inclusief technisch glaswerk)',
    fr: "Fabrication et façonnage d'autres articles en verre, y compris verre technique",
    en: 'Vervaardiging en bewerking van ander glas (inclusief technisch glaswerk)',
  },
  {
    code: '23200',
    nl: 'Vervaardiging van vuurvaste producten',
    fr: 'Fabrication de produits réfractaires',
    en: 'Vervaardiging van vuurvaste producten',
  },
  {
    code: '23310',
    nl: 'Vervaardiging van keramische tegels en plavuizen',
    fr: 'Fabrication de carreaux en céramique',
    en: 'Vervaardiging van keramische tegels en plavuizen',
  },
  {
    code: '23321',
    nl: 'Vervaardiging van bakstenen',
    fr: 'Fabrication de briques',
    en: 'Vervaardiging van bakstenen',
  },
  {
    code: '23322',
    nl: 'Vervaardiging van dakpannen, tegels en andere producten voor de bouw van gebakken klei',
    fr: "Fabrication de tuiles, de carrelages et d'autres produits de construction en terre cuite",
    en: 'Vervaardiging van dakpannen, tegels en andere producten voor de bouw van gebakken klei',
  },
  {
    code: '23410',
    nl: 'Vervaardiging van huishoudelijk en sieraardewerk',
    fr: "Fabrication d'articles céramiques à usage domestique ou ornemental",
    en: 'Vervaardiging van huishoudelijk en sieraardewerk',
  },
  {
    code: '23420',
    nl: 'Vervaardiging van sanitair aardewerk',
    fr: "Fabrication d'appareils sanitaires en céramique",
    en: 'Vervaardiging van sanitair aardewerk',
  },
  {
    code: '23430',
    nl: 'Vervaardiging van isolatoren en isolatiemateriaal, van keramische stoffen',
    fr: "Fabrication d'isolateurs et de pièces isolantes en céramique",
    en: 'Vervaardiging van isolatoren en isolatiemateriaal, van keramische stoffen',
  },
  {
    code: '23440',
    nl: 'Vervaardiging van ander technisch aardewerk',
    fr: "Fabrication d'autres produits céramiques à usage technique",
    en: 'Vervaardiging van ander technisch aardewerk',
  },
  {
    code: '23490',
    nl: 'Vervaardiging van andere keramische producten',
    fr: "Fabrication d'autres produits céramiques",
    en: 'Vervaardiging van andere keramische producten',
  },
  {
    code: '23510',
    nl: 'Vervaardiging van cement',
    fr: 'Fabrication de ciment',
    en: 'Vervaardiging van cement',
  },
  {
    code: '23520',
    nl: 'Vervaardiging van kalk en gips',
    fr: 'Fabrication de chaux et de plâtre',
    en: 'Vervaardiging van kalk en gips',
  },
  {
    code: '23610',
    nl: 'Vervaardiging van artikelen van beton voor de bouw',
    fr: "Fabrication d'éléments en béton pour la construction",
    en: 'Vervaardiging van artikelen van beton voor de bouw',
  },
  {
    code: '23620',
    nl: 'Vervaardiging van artikelen van gips voor de bouw',
    fr: "Fabrication d'éléments en plâtre pour la construction",
    en: 'Vervaardiging van artikelen van gips voor de bouw',
  },
  {
    code: '23630',
    nl: 'Vervaardiging van stortklare beton',
    fr: "Fabrication de béton prêt à l'emploi",
    en: 'Vervaardiging van stortklare beton',
  },
  {
    code: '23640',
    nl: 'Vervaardiging van mortel',
    fr: 'Fabrication de mortiers et de bétons secs',
    en: 'Vervaardiging van mortel',
  },
  {
    code: '23650',
    nl: 'Vervaardiging van producten van vezelcement',
    fr: "Fabrication d'ouvrages en fibre-ciment",
    en: 'Vervaardiging van producten van vezelcement',
  },
  {
    code: '23690',
    nl: 'Vervaardiging van andere artikelen van beton, gips en cement',
    fr: "Fabrication d'autres ouvrages en béton, en ciment ou en plâtre",
    en: 'Vervaardiging van andere artikelen van beton, gips en cement',
  },
  {
    code: '23700',
    nl: 'Houwen, bewerken en afwerken van natuursteen',
    fr: 'Taille, façonnage et finissage de pierres',
    en: 'Houwen, bewerken en afwerken van natuursteen',
  },
  {
    code: '23910',
    nl: 'Vervaardiging van schuur-, slijp- en polijstmiddelen',
    fr: 'Fabrication de produits abrasifs',
    en: 'Vervaardiging van schuur-, slijp- en polijstmiddelen',
  },
  {
    code: '23990',
    nl: 'Vervaardiging van andere niet-metaalhoudende minerale producten, n.e.g.',
    fr: "Fabrication d'autres produits minéraux non métalliques n.c.a.",
    en: 'Vervaardiging van andere niet-metaalhoudende minerale producten, n.e.g.',
  },
  {
    code: '24100',
    nl: 'Vervaardiging van ijzer en staal en van ferrolegeringen',
    fr: 'Sidérurgie',
    en: 'Vervaardiging van ijzer en staal en van ferrolegeringen',
  },
  {
    code: '24200',
    nl: 'Vervaardiging van buizen, pijpen, holle profielen en fittings daarvoor, van staal',
    fr: "Fabrication de tubes, de tuyaux, de profilés creux et d'accessoires correspondants en acier",
    en: 'Vervaardiging van buizen, pijpen, holle profielen en fittings daarvoor, van staal',
  },
  {
    code: '24310',
    nl: 'Koudtrekken van staven',
    fr: 'Étirage à froid de barres',
    en: 'Koudtrekken van staven',
  },
  {
    code: '24320',
    nl: 'Koudwalsen van bandstaal',
    fr: 'Laminage à froid de feuillards',
    en: 'Koudwalsen van bandstaal',
  },
  {
    code: '24330',
    nl: 'Koudvervormen of koudfelsen',
    fr: 'Profilage à froid par formage ou pliage',
    en: 'Koudvervormen of koudfelsen',
  },
  {
    code: '24340',
    nl: 'Koudtrekken van draad',
    fr: 'Tréfilage à froid',
    en: 'Koudtrekken van draad',
  },
  {
    code: '24410',
    nl: 'Productie van edelmetalen',
    fr: 'Production de métaux précieux',
    en: 'Productie van edelmetalen',
  },
  {
    code: '24420',
    nl: 'Productie van aluminium',
    fr: "Métallurgie de l'aluminium",
    en: 'Productie van aluminium',
  },
  {
    code: '24430',
    nl: 'Productie van lood, zink en tin',
    fr: "Métallurgie du plomb, du zinc ou de l'étain",
    en: 'Productie van lood, zink en tin',
  },
  {
    code: '24440',
    nl: 'Productie van koper',
    fr: 'Métallurgie du cuivre',
    en: 'Productie van koper',
  },
  {
    code: '24450',
    nl: 'Productie van andere non-ferrometalen',
    fr: 'Métallurgie des autres métaux non ferreux',
    en: 'Productie van andere non-ferrometalen',
  },
  {
    code: '24460',
    nl: 'Bewerking van splijt- en kweekstoffen',
    fr: 'Élaboration et transformation de matières nucléaires',
    en: 'Bewerking van splijt- en kweekstoffen',
  },
  {
    code: '24510',
    nl: 'Gieten van ijzer',
    fr: 'Fonderie de fonte',
    en: 'Gieten van ijzer',
  },
  {
    code: '24520',
    nl: 'Gieten van staal',
    fr: "Fonderie d'acier",
    en: 'Gieten van staal',
  },
  {
    code: '24530',
    nl: 'Gieten van lichte metalen',
    fr: 'Fonderie de métaux légers',
    en: 'Gieten van lichte metalen',
  },
  {
    code: '24540',
    nl: 'Gieten van andere non-ferrometalen',
    fr: "Fonderie d'autres métaux non ferreux",
    en: 'Gieten van andere non-ferrometalen',
  },
  {
    code: '25110',
    nl: 'Vervaardiging van metalen constructiewerken en delen daarvan',
    fr: 'Fabrication de structures métalliques et de parties de structures',
    en: 'Vervaardiging van metalen constructiewerken en delen daarvan',
  },
  {
    code: '25120',
    nl: 'Vervaardiging van metalen deuren en vensters',
    fr: 'Fabrication de portes et de fenêtres en métal',
    en: 'Vervaardiging van metalen deuren en vensters',
  },
  {
    code: '25210',
    nl: 'Vervaardiging van radiatoren en ketels voor centrale verwarming',
    fr: 'Fabrication de radiateurs et de chaudières pour le chauffage central',
    en: 'Vervaardiging van radiatoren en ketels voor centrale verwarming',
  },
  {
    code: '25290',
    nl: 'Vervaardiging van andere tanks, reservoirs en bergingsmiddelen, van metaal',
    fr: "Fabrication d'autres réservoirs, citernes et conteneurs métalliques",
    en: 'Vervaardiging van andere tanks, reservoirs en bergingsmiddelen, van metaal',
  },
  {
    code: '25300',
    nl: 'Vervaardiging van stoomketels, exclusief warmwaterketels voor centrale verwarming',
    fr: "Fabrication de générateurs de vapeur, à l'exception des chaudières pour le chauffage central",
    en: 'Vervaardiging van stoomketels, exclusief warmwaterketels voor centrale verwarming',
  },
  {
    code: '25400',
    nl: 'Vervaardiging van wapens en munitie',
    fr: "Fabrication d'armes et de munitions",
    en: 'Vervaardiging van wapens en munitie',
  },
  {
    code: '25501',
    nl: 'Smeden van metaal',
    fr: 'Forge',
    en: 'Smeden van metaal',
  },
  {
    code: '25502',
    nl: 'Persen, stampen en profielwalsen van metaal; poedermetallurgie',
    fr: 'Emboutissage, estampage et profilage des métaux; métallurgie des poudres',
    en: 'Persen, stampen en profielwalsen van metaal; poedermetallurgie',
  },
  {
    code: '25610',
    nl: 'Oppervlaktebehandeling van metalen',
    fr: 'Traitement et revêtement des métaux',
    en: 'Oppervlaktebehandeling van metalen',
  },
  {
    code: '25620',
    nl: 'Verspanend bewerken van metalen',
    fr: 'Usinage',
    en: 'Verspanend bewerken van metalen',
  },
  {
    code: '25710',
    nl: 'Vervaardiging van scharen, messen, bestekken, enz.',
    fr: 'Fabrication de coutellerie',
    en: 'Vervaardiging van scharen, messen, bestekken, enz.',
  },
  {
    code: '25720',
    nl: 'Vervaardiging van hang- en sluitwerk',
    fr: 'Fabrication de serrures et de ferrures',
    en: 'Vervaardiging van hang- en sluitwerk',
  },
  {
    code: '25731',
    nl: 'Vervaardiging van vormkasten en gietvormen',
    fr: 'Fabrication de moules et modèles',
    en: 'Vervaardiging van vormkasten en gietvormen',
  },
  {
    code: '25739',
    nl: 'Vervaardiging van gereedschap, m.u.v. vormkasten en gietvormen',
    fr: "Fabrication d'outillage, à l'exclusion des moules et des modèles",
    en: 'Vervaardiging van gereedschap, m.u.v. vormkasten en gietvormen',
  },
  {
    code: '25910',
    nl: 'Vervaardiging van stalen vaten en dergelijke',
    fr: "Fabrication de fûts et d'emballages métalliques similaires",
    en: 'Vervaardiging van stalen vaten en dergelijke',
  },
  {
    code: '25920',
    nl: 'Vervaardiging van verpakkingsmiddelen van licht metaal',
    fr: "Fabrication d'emballages métalliques légers",
    en: 'Vervaardiging van verpakkingsmiddelen van licht metaal',
  },
  {
    code: '25930',
    nl: 'Vervaardiging van artikelen van draad en van kettingen en veren',
    fr: "Fabrication d'articles en fils métalliques, de chaînes et de ressorts",
    en: 'Vervaardiging van artikelen van draad en van kettingen en veren',
  },
  {
    code: '25940',
    nl: 'Vervaardiging van bouten, schroeven en moeren',
    fr: 'Fabrication de vis et de boulons',
    en: 'Vervaardiging van bouten, schroeven en moeren',
  },
  {
    code: '25991',
    nl: 'Vervaardiging van huishoudelijke en sanitaire artikelen van metaal',
    fr: "Fabrication d'articles métalliques à usage ménager et sanitaire",
    en: 'Vervaardiging van huishoudelijke en sanitaire artikelen van metaal',
  },
  {
    code: '25999',
    nl: 'Vervaardiging van overige artikelen van metaal, n.e.g.',
    fr: "Fabrication d'autres articles métalliques n.c.a.",
    en: 'Vervaardiging van overige artikelen van metaal, n.e.g.',
  },
  {
    code: '26110',
    nl: 'Vervaardiging van elektronische onderdelen',
    fr: 'Fabrication de composants électroniques',
    en: 'Vervaardiging van elektronische onderdelen',
  },
  {
    code: '26120',
    nl: 'Vervaardiging van elektronische printplaten',
    fr: 'Fabrication de cartes électroniques assemblées',
    en: 'Vervaardiging van elektronische printplaten',
  },
  {
    code: '26200',
    nl: 'Vervaardiging van computers en randapparatuur',
    fr: "Fabrication d'ordinateurs et d'équipements périphériques",
    en: 'Vervaardiging van computers en randapparatuur',
  },
  {
    code: '26300',
    nl: 'Vervaardiging van communicatieapparatuur',
    fr: "Fabrication d'équipements de communication",
    en: 'Vervaardiging van communicatieapparatuur',
  },
  {
    code: '26400',
    nl: 'Vervaardiging van consumentenelektronica',
    fr: 'Fabrication de produits électroniques grand public',
    en: 'Vervaardiging van consumentenelektronica',
  },
  {
    code: '26510',
    nl: 'Vervaardiging van meet-, controle- en navigatie-instrumenten en -apparatuur',
    fr: "Fabrication d'instruments et d'appareils de mesure, d'essai et de navigation",
    en: 'Vervaardiging van meet-, controle- en navigatie-instrumenten en -apparatuur',
  },
  {
    code: '26520',
    nl: 'Vervaardiging van uurwerken',
    fr: 'Horlogerie',
    en: 'Vervaardiging van uurwerken',
  },
  {
    code: '26600',
    nl: 'Vervaardiging van bestralingsapparatuur en van elektromedische en elektrotherapeutische apparatuur',
    fr: "Fabrication d'équipements d'irradiation médicale, d'équipements électromédicaux et électrothérapeutiques",
    en: 'Vervaardiging van bestralingsapparatuur en van elektromedische en elektrotherapeutische apparatuur',
  },
  {
    code: '26700',
    nl: 'Vervaardiging van optische instrumenten en van foto- en filmapparatuur',
    fr: 'Fabrication de matériels optiques et photographiques',
    en: 'Vervaardiging van optische instrumenten en van foto- en filmapparatuur',
  },
  {
    code: '26800',
    nl: 'Vervaardiging van magnetische en optische media',
    fr: 'Fabrication de supports magnétiques et optiques',
    en: 'Vervaardiging van magnetische en optische media',
  },
  {
    code: '27110',
    nl: 'Vervaardiging van elektromotoren en van elektrische generatoren en transformatoren',
    fr: 'Fabrication de moteurs, de génératrices et de transformateurs électriques',
    en: 'Vervaardiging van elektromotoren en van elektrische generatoren en transformatoren',
  },
  {
    code: '27120',
    nl: 'Vervaardiging van schakel- en verdeelinrichtingen',
    fr: 'Fabrication de matériel de distribution et de commande électrique',
    en: 'Vervaardiging van schakel- en verdeelinrichtingen',
  },
  {
    code: '27200',
    nl: 'Vervaardiging van batterijen en accumulatoren',
    fr: "Fabrication de piles et d'accumulateurs électriques",
    en: 'Vervaardiging van batterijen en accumulatoren',
  },
  {
    code: '27310',
    nl: 'Vervaardiging van kabels van optische vezels',
    fr: 'Fabrication de câbles de fibres optiques',
    en: 'Vervaardiging van kabels van optische vezels',
  },
  {
    code: '27320',
    nl: 'Vervaardiging van andere elektrische en elektronische kabels',
    fr: "Fabrication d'autres fils et de câbles électroniques ou électriques",
    en: 'Vervaardiging van andere elektrische en elektronische kabels',
  },
  {
    code: '27330',
    nl: 'Vervaardiging van schakelaars, stekkers, stopcontacten e.d.',
    fr: "Fabrication de matériel d'installation électrique",
    en: 'Vervaardiging van schakelaars, stekkers, stopcontacten e.d.',
  },
  {
    code: '27401',
    nl: 'Vervaardiging van lampen',
    fr: 'Fabrication de lampes',
    en: 'Vervaardiging van lampen',
  },
  {
    code: '27402',
    nl: 'Vervaardiging van verlichtingsapparaten',
    fr: "Fabrication d'appareils d'éclairage électrique",
    en: 'Vervaardiging van verlichtingsapparaten',
  },
  {
    code: '27510',
    nl: 'Vervaardiging van elektrische huishoudapparaten',
    fr: "Fabrication d'appareils électroménagers",
    en: 'Vervaardiging van elektrische huishoudapparaten',
  },
  {
    code: '27520',
    nl: 'Vervaardiging van niet-elektrische huishoudapparaten',
    fr: "Fabrication d'appareils ménagers non électriques",
    en: 'Vervaardiging van niet-elektrische huishoudapparaten',
  },
  {
    code: '27900',
    nl: 'Vervaardiging van andere elektrische apparatuur',
    fr: "Fabrication d'autres matériels électriques",
    en: 'Vervaardiging van andere elektrische apparatuur',
  },
  {
    code: '28110',
    nl: 'Vervaardiging van motoren en turbines, exclusief motoren voor luchtvaartuigen, motorvoertuigen en bromfietsen',
    fr: "Fabrication de moteurs et de turbines, à l'exception des moteurs d'avions, de véhicules automobiles et de motocycles",
    en: 'Vervaardiging van motoren en turbines, exclusief motoren voor luchtvaartuigen, motorvoertuigen en bromfietsen',
  },
  {
    code: '28120',
    nl: 'Vervaardiging van hydraulische apparatuur',
    fr: "Fabrication d'équipements hydrauliques et pneumatiques",
    en: 'Vervaardiging van hydraulische apparatuur',
  },
  {
    code: '28130',
    nl: 'Vervaardiging van andere pompen en compressoren',
    fr: "Fabrication d'autres pompes et de compresseurs",
    en: 'Vervaardiging van andere pompen en compressoren',
  },
  {
    code: '28140',
    nl: 'Vervaardiging van andere kranen en dergelijke artikelen',
    fr: "Fabrication d'autres articles de robinetterie",
    en: 'Vervaardiging van andere kranen en dergelijke artikelen',
  },
  {
    code: '28150',
    nl: 'Vervaardiging van tandwielen, lagers en andere drijfwerkelementen',
    fr: "Fabrication d'engrenages et d'organes mécaniques de transmission",
    en: 'Vervaardiging van tandwielen, lagers en andere drijfwerkelementen',
  },
  {
    code: '28210',
    nl: 'Vervaardiging van ovens en branders',
    fr: 'Fabrication de fours et de brûleurs',
    en: 'Vervaardiging van ovens en branders',
  },
  {
    code: '28220',
    nl: 'Vervaardiging van hijs-, hef- en transportwerktuigen',
    fr: 'Fabrication de matériel de levage et de manutention',
    en: 'Vervaardiging van hijs-, hef- en transportwerktuigen',
  },
  {
    code: '28230',
    nl: 'Vervaardiging van kantoormachines en -uitrusting (exclusief computers en randapparatuur)',
    fr: "Fabrication de machines et d'équipements de bureau (à l'exception des ordinateurs et des équipements périphériques)",
    en: 'Vervaardiging van kantoormachines en -uitrusting (exclusief computers en randapparatuur)',
  },
  {
    code: '28240',
    nl: 'Vervaardiging van elektrisch handgereedschap',
    fr: "Fabrication d'outillage portatif à moteur incorporé",
    en: 'Vervaardiging van elektrisch handgereedschap',
  },
  {
    code: '28250',
    nl: 'Vervaardiging van machines en apparaten voor de koeltechniek en de klimaatregeling, voor niet-huishoudelijk gebruik',
    fr: "Fabrication d'équipements aérauliques et frigorifiques industriels",
    en: 'Vervaardiging van machines en apparaten voor de koeltechniek en de klimaatregeling, voor niet-huishoudelijk gebruik',
  },
  {
    code: '28291',
    nl: 'Vervaardiging van verpakkingsmachines',
    fr: 'Fabrication de machines à emballer',
    en: 'Vervaardiging van verpakkingsmachines',
  },
  {
    code: '28292',
    nl: 'Vervaardiging van weegtoestellen',
    fr: "Fabrication d'appareils de pesage",
    en: 'Vervaardiging van weegtoestellen',
  },
  {
    code: '28293',
    nl: 'Vervaardiging van toestellen voor het spuiten van vloeistoffen of poeder',
    fr: "Fabrication d'appareils de projection de matières liquides ou en poudre",
    en: 'Vervaardiging van toestellen voor het spuiten van vloeistoffen of poeder',
  },
  {
    code: '28294',
    nl: 'Vervaardiging van verkoopautomaten',
    fr: 'Fabrication de machines automatiques de vente de produits',
    en: 'Vervaardiging van verkoopautomaten',
  },
  {
    code: '28295',
    nl: 'Vervaardiging van filtreertoestellen',
    fr: "Fabrication d'appareils de filtrage",
    en: 'Vervaardiging van filtreertoestellen',
  },
  {
    code: '28296',
    nl: 'Vervaardiging van hogedrukreinigers, zandstraalapparaten en dergelijk reinigingsmateriaal',
    fr: 'Fabrication de nettoyeurs à haute pression, de matériel industriel de nettoyage au sable et similaires',
    en: 'Vervaardiging van hogedrukreinigers, zandstraalapparaten en dergelijk reinigingsmateriaal',
  },
  {
    code: '28299',
    nl: 'Vervaardiging van andere machines en apparaten voor algemeen gebruik, n.e.g.',
    fr: "Fabrication d'autres machines d'usage général n.c.a.",
    en: 'Vervaardiging van andere machines en apparaten voor algemeen gebruik, n.e.g.',
  },
  {
    code: '28300',
    nl: 'Vervaardiging van machines en werktuigen voor de landbouw en de bosbouw',
    fr: 'Fabrication de machines agricoles et forestières',
    en: 'Vervaardiging van machines en werktuigen voor de landbouw en de bosbouw',
  },
  {
    code: '28410',
    nl: 'Vervaardiging van machines voor de metaalbewerking',
    fr: 'Fabrication de machines de formage des métaux',
    en: 'Vervaardiging van machines voor de metaalbewerking',
  },
  {
    code: '28490',
    nl: 'Vervaardiging van andere gereedschapswerktuigen',
    fr: "Fabrication d'autres machines-outils",
    en: 'Vervaardiging van andere gereedschapswerktuigen',
  },
  {
    code: '28910',
    nl: 'Vervaardiging van machines voor de metallurgie',
    fr: 'Fabrication de machines pour la métallurgie',
    en: 'Vervaardiging van machines voor de metallurgie',
  },
  {
    code: '28920',
    nl: 'Vervaardiging van machines voor de winning van delfstoffen en voor de bouw',
    fr: "Fabrication de machines pour l'extraction ou la construction",
    en: 'Vervaardiging van machines voor de winning van delfstoffen en voor de bouw',
  },
  {
    code: '28930',
    nl: 'Vervaardiging van machines voor de productie van voedings- en genotmiddelen',
    fr: "Fabrication de machines pour l'industrie agro-alimentaire",
    en: 'Vervaardiging van machines voor de productie van voedings- en genotmiddelen',
  },
  {
    code: '28940',
    nl: 'Vervaardiging van machines voor de productie van textiel, kleding en leer',
    fr: 'Fabrication de machines pour les industries textiles',
    en: 'Vervaardiging van machines voor de productie van textiel, kleding en leer',
  },
  {
    code: '28950',
    nl: 'Vervaardiging van machines voor de productie van papier en karton',
    fr: 'Fabrication de machines pour les industries du papier et du carton',
    en: 'Vervaardiging van machines voor de productie van papier en karton',
  },
  {
    code: '28960',
    nl: 'Vervaardiging van machines voor de kunststof- en rubberindustrie',
    fr: 'Fabrication de machines pour le travail du caoutchouc ou des plastiques',
    en: 'Vervaardiging van machines voor de kunststof- en rubberindustrie',
  },
  {
    code: '28990',
    nl: 'Vervaardiging van andere machines, apparaten en werktuigen voor specifieke doeleinden, n.e.g.',
    fr: "Fabrication d'autres machines d'usage spécifique n.c.a.",
    en: 'Vervaardiging van andere machines, apparaten en werktuigen voor specifieke doeleinden, n.e.g.',
  },
  {
    code: '29100',
    nl: 'Vervaardiging en assemblage van motorvoertuigen',
    fr: 'Construction et assemblage de véhicules automobiles',
    en: 'Vervaardiging en assemblage van motorvoertuigen',
  },
  {
    code: '29201',
    nl: 'Vervaardiging van carrosserieën voor motorvoertuigen',
    fr: 'Fabrication de carrosseries de véhicules automobiles',
    en: 'Vervaardiging van carrosserieën voor motorvoertuigen',
  },
  {
    code: '29202',
    nl: 'Vervaardiging van aanhangwagens, caravans en opleggers',
    fr: 'Fabrication de remorques, de semi-remorques et de caravanes',
    en: 'Vervaardiging van aanhangwagens, caravans en opleggers',
  },
  {
    code: '29310',
    nl: 'Vervaardiging van elektrische en elektronische benodigdheden voor motorvoertuigen',
    fr: "Fabrication d'équipements électriques et électroniques pour véhicules automobiles",
    en: 'Vervaardiging van elektrische en elektronische benodigdheden voor motorvoertuigen',
  },
  {
    code: '29320',
    nl: 'Vervaardiging van andere delen en toebehoren van motorvoertuigen',
    fr: "Fabrication d'autres équipements pour véhicules automobiles",
    en: 'Vervaardiging van andere delen en toebehoren van motorvoertuigen',
  },
  {
    code: '30110',
    nl: 'Bouw van schepen en drijvend materieel',
    fr: 'Construction de navires et de structures flottantes',
    en: 'Bouw van schepen en drijvend materieel',
  },
  {
    code: '30120',
    nl: 'Bouw van plezier- en sportvaartuigen',
    fr: 'Construction de bateaux de plaisance',
    en: 'Bouw van plezier- en sportvaartuigen',
  },
  {
    code: '30200',
    nl: 'Vervaardiging van rollend materieel voor spoorwegen',
    fr: "Construction de locomotives et d'autre matériel ferroviaire roulant",
    en: 'Vervaardiging van rollend materieel voor spoorwegen',
  },
  {
    code: '30300',
    nl: 'Vervaardiging van lucht- en ruimtevaartuigen en van toestellen in verband daarmee',
    fr: 'Construction aéronautique et spatiale',
    en: 'Vervaardiging van lucht- en ruimtevaartuigen en van toestellen in verband daarmee',
  },
  {
    code: '30400',
    nl: 'Vervaardiging van militaire gevechtsvoertuigen',
    fr: 'Construction de véhicules militaires de combat',
    en: 'Vervaardiging van militaire gevechtsvoertuigen',
  },
  {
    code: '30910',
    nl: 'Vervaardiging van motorfietsen',
    fr: 'Fabrication de motocycles',
    en: 'Vervaardiging van motorfietsen',
  },
  {
    code: '30920',
    nl: 'Vervaardiging van fietsen en invalidenwagens',
    fr: 'Fabrication de bicyclettes et de véhicules pour invalides',
    en: 'Vervaardiging van fietsen en invalidenwagens',
  },
  {
    code: '30990',
    nl: 'Vervaardiging van andere transportmiddelen, n.e.g.',
    fr: "Fabrication d'autres équipements de transport n.c.a.",
    en: 'Vervaardiging van andere transportmiddelen, n.e.g.',
  },
  {
    code: '31010',
    nl: 'Vervaardiging van kantoor- en winkelmeubelen',
    fr: 'Fabrication de meubles de bureau et de magasin',
    en: 'Vervaardiging van kantoor- en winkelmeubelen',
  },
  {
    code: '31020',
    nl: 'Vervaardiging van keukenmeubelen',
    fr: 'Fabrication de meubles de cuisine',
    en: 'Vervaardiging van keukenmeubelen',
  },
  {
    code: '31030',
    nl: 'Vervaardiging van matrassen',
    fr: 'Fabrication de matelas',
    en: 'Vervaardiging van matrassen',
  },
  {
    code: '31091',
    nl: 'Vervaardiging van eetkamer-, zitkamer-, slaapkamer- en badkamermeubelen',
    fr: 'Fabrication de salles à manger, de salons, de chambres à coucher et de salles de bain',
    en: 'Vervaardiging van eetkamer-, zitkamer-, slaapkamer- en badkamermeubelen',
  },
  {
    code: '31092',
    nl: 'Vervaardiging van tuin- en terrasmeubelen',
    fr: "Fabrication de meubles de jardin et d'extérieur",
    en: 'Vervaardiging van tuin- en terrasmeubelen',
  },
  {
    code: '31099',
    nl: 'Vervaardiging van andere meubelen, n.e.g.',
    fr: "Fabrication d'autres meubles n.c.a.",
    en: 'Vervaardiging van andere meubelen, n.e.g.',
  },
  {
    code: '32110',
    nl: 'Slaan van munten',
    fr: 'Frappe de monnaie',
    en: 'Slaan van munten',
  },
  {
    code: '32121',
    nl: 'Bewerken van diamant',
    fr: 'Travail du diamant',
    en: 'Bewerken van diamant',
  },
  {
    code: '32122',
    nl: 'Bewerken van edelstenen (m.u.v. diamant) en van halfedelstenen',
    fr: 'Travail des pierres précieuses (sauf le diamant) et des pierres semi-précieuses',
    en: 'Bewerken van edelstenen (m.u.v. diamant) en van halfedelstenen',
  },
  {
    code: '32123',
    nl: 'Vervaardiging van sieraden',
    fr: "Fabrication d'articles de joaillerie et de bijouterie",
    en: 'Vervaardiging van sieraden',
  },
  {
    code: '32124',
    nl: 'Vervaardiging van edelsmeedwerk',
    fr: "Fabrication d'articles d'orfèvrerie",
    en: 'Vervaardiging van edelsmeedwerk',
  },
  {
    code: '32129',
    nl: 'Vervaardiging van overige artikelen van edele metalen',
    fr: "Fabrication d'autres articles en métaux précieux",
    en: 'Vervaardiging van overige artikelen van edele metalen',
  },
  {
    code: '32130',
    nl: 'Vervaardiging van imitatiesieraden en dergelijke artikelen',
    fr: "Fabrication d'articles de bijouterie de fantaisie et d'articles similaires",
    en: 'Vervaardiging van imitatiesieraden en dergelijke artikelen',
  },
  {
    code: '32200',
    nl: 'Vervaardiging van muziekinstrumenten',
    fr: "Fabrication d'instruments de musique",
    en: 'Vervaardiging van muziekinstrumenten',
  },
  {
    code: '32300',
    nl: 'Vervaardiging van sportartikelen',
    fr: "Fabrication d'articles de sport",
    en: 'Vervaardiging van sportartikelen',
  },
  {
    code: '32400',
    nl: 'Vervaardiging van spellen en speelgoed',
    fr: 'Fabrication de jeux et de jouets',
    en: 'Vervaardiging van spellen en speelgoed',
  },
  {
    code: '32500',
    nl: 'Vervaardiging van medische en tandheelkundige instrumenten en benodigdheden',
    fr: "Fabrication d'instruments et de fournitures à usage médical et dentaire",
    en: 'Vervaardiging van medische en tandheelkundige instrumenten en benodigdheden',
  },
  {
    code: '32910',
    nl: 'Vervaardiging van borstelwaren',
    fr: "Fabrication d'articles de brosserie",
    en: 'Vervaardiging van borstelwaren',
  },
  {
    code: '32990',
    nl: 'Overige industrie, n.e.g.',
    fr: 'Autres activités manufacturières n.c.a.',
    en: 'Overige industrie, n.e.g.',
  },
  {
    code: '33110',
    nl: 'Reparatie van producten van metaal',
    fr: "Réparation d'ouvrages en métaux",
    en: 'Reparatie van producten van metaal',
  },
  {
    code: '33120',
    nl: 'Reparatie van machines',
    fr: 'Réparation de machines',
    en: 'Reparatie van machines',
  },
  {
    code: '33130',
    nl: 'Reparatie van elektronische en optische apparatuur',
    fr: 'Réparation de matériels électroniques et optiques',
    en: 'Reparatie van elektronische en optische apparatuur',
  },
  {
    code: '33140',
    nl: 'Reparatie van elektrische apparatuur',
    fr: "Réparation d'équipements électriques",
    en: 'Reparatie van elektrische apparatuur',
  },
  {
    code: '33150',
    nl: 'Reparatie en onderhoud van schepen',
    fr: 'Réparation et maintenance navale',
    en: 'Reparatie en onderhoud van schepen',
  },
  {
    code: '33160',
    nl: 'Reparatie en onderhoud van lucht- en ruimtevaartuigen',
    fr: "Réparation et maintenance d'aéronefs et d'engins spatiaux",
    en: 'Reparatie en onderhoud van lucht- en ruimtevaartuigen',
  },
  {
    code: '33170',
    nl: 'Reparatie en onderhoud van andere transportmiddelen',
    fr: "Réparation et maintenance d'autres équipements de transport",
    en: 'Reparatie en onderhoud van andere transportmiddelen',
  },
  {
    code: '33190',
    nl: 'Reparatie van andere apparatuur',
    fr: "Réparation d'autres équipements",
    en: 'Reparatie van andere apparatuur',
  },
  {
    code: '33200',
    nl: 'Installatie van industriële machines, toestellen en werktuigen',
    fr: "Installation de machines et d'équipements industriels",
    en: 'Installatie van industriële machines, toestellen en werktuigen',
  },
  {
    code: '35110',
    nl: 'Productie van elektriciteit',
    fr: "Production d'électricité",
    en: 'Productie van elektriciteit',
  },
  {
    code: '35120',
    nl: 'Transmissie van elektriciteit',
    fr: "Transport d'électricité",
    en: 'Transmissie van elektriciteit',
  },
  {
    code: '35130',
    nl: 'Distributie van elektriciteit',
    fr: "Distribution d'électricité",
    en: 'Distributie van elektriciteit',
  },
  {
    code: '35140',
    nl: 'Handel in elektriciteit',
    fr: "Commerce d'électricité",
    en: 'Handel in elektriciteit',
  },
  {
    code: '35210',
    nl: 'Productie van gas',
    fr: 'Production de combustibles gazeux',
    en: 'Productie van gas',
  },
  {
    code: '35220',
    nl: 'Distributie van gasvormige brandstoffen via leidingen',
    fr: 'Distribution de combustibles gazeux par conduites',
    en: 'Distributie van gasvormige brandstoffen via leidingen',
  },
  {
    code: '35230',
    nl: 'Handel in gas via leidingen',
    fr: 'Commerce de combustibles gazeux par conduites',
    en: 'Handel in gas via leidingen',
  },
  {
    code: '35300',
    nl: 'Productie en distributie van stoom en gekoelde lucht',
    fr: "Production et distribution de vapeur et d'air conditionné",
    en: 'Productie en distributie van stoom en gekoelde lucht',
  },
  {
    code: '36000',
    nl: 'Winning, behandeling en distributie van water',
    fr: "Captage, traitement et distribution d'eau",
    en: 'Winning, behandeling en distributie van water',
  },
  {
    code: '37000',
    nl: 'Afvalwaterafvoer',
    fr: 'Collecte et traitement des eaux usées',
    en: 'Afvalwaterafvoer',
  },
  {
    code: '38110',
    nl: 'Inzameling van ongevaarlijk afval',
    fr: 'Collecte des déchets non dangereux',
    en: 'Inzameling van ongevaarlijk afval',
  },
  {
    code: '38120',
    nl: 'Inzameling van gevaarlijk afval',
    fr: 'Collecte des déchets dangereux',
    en: 'Inzameling van gevaarlijk afval',
  },
  {
    code: '38211',
    nl: 'Voorbehandeling van ongevaarlijk afval met het oog op verwijdering',
    fr: 'Prétraitement avant élimination des déchets non dangereux',
    en: 'Voorbehandeling van ongevaarlijk afval met het oog op verwijdering',
  },
  {
    code: '38212',
    nl: 'Fysicochemische verwerking van slib en vloeibare afvalstoffen',
    fr: 'Traitement physico-chimique des boues et des déchets liquides',
    en: 'Fysicochemische verwerking van slib en vloeibare afvalstoffen',
  },
  {
    code: '38213',
    nl: 'Behandeling en verwijdering van ongevaarlijk afval, m.u.v. slib en vloeibare afvalstoffen',
    fr: 'Traitement et élimination des déchets non dangereux, sauf boues et déchets liquides',
    en: 'Behandeling en verwijdering van ongevaarlijk afval, m.u.v. slib en vloeibare afvalstoffen',
  },
  {
    code: '38219',
    nl: 'Overige verwerking en verwijdering van ongevaarlijk afval',
    fr: 'Autre traitement et élimination des déchets non dangereux',
    en: 'Overige verwerking en verwijdering van ongevaarlijk afval',
  },
  {
    code: '38221',
    nl: 'Voorbehandeling van gevaarlijk afval met het oog op verwijdering',
    fr: 'Prétraitement avant élimination des déchets dangereux',
    en: 'Voorbehandeling van gevaarlijk afval met het oog op verwijdering',
  },
  {
    code: '38222',
    nl: 'Behandeling en verwijdering van gevaarlijk afval',
    fr: 'Traitement et élimination des déchets dangereux',
    en: 'Behandeling en verwijdering van gevaarlijk afval',
  },
  {
    code: '38310',
    nl: 'Sloop van wrakken',
    fr: "Démantèlement d'épaves",
    en: 'Sloop van wrakken',
  },
  {
    code: '38321',
    nl: 'Sorteren van ongevaarlijk afval',
    fr: 'Tri de matériaux récupérables',
    en: 'Sorteren van ongevaarlijk afval',
  },
  {
    code: '38322',
    nl: 'Terugwinning van metaalafval',
    fr: 'Récupération de déchets métalliques',
    en: 'Terugwinning van metaalafval',
  },
  {
    code: '38323',
    nl: 'Terugwinning van inerte afvalstoffen',
    fr: 'Récupération de déchets inertes',
    en: 'Terugwinning van inerte afvalstoffen',
  },
  {
    code: '38329',
    nl: 'Terugwinning van overig gesorteerd afval',
    fr: "Récupération d'autres déchets triés",
    en: 'Terugwinning van overig gesorteerd afval',
  },
  {
    code: '39000',
    nl: 'Sanering en ander afvalbeheer',
    fr: 'Dépollution et autres services de gestion des déchets',
    en: 'Sanering en ander afvalbeheer',
  },
  {
    code: '41101',
    nl: 'Ontwikkeling van residentiële bouwprojecten',
    fr: 'Promotion immobilière résidentielle',
    en: 'Ontwikkeling van residentiële bouwprojecten',
  },
  {
    code: '41102',
    nl: 'Ontwikkeling van niet-residentiële bouwprojecten',
    fr: 'Promotion immobilière non résidentielle',
    en: 'Ontwikkeling van niet-residentiële bouwprojecten',
  },
  {
    code: '41201',
    nl: 'Algemene bouw van residentiële gebouwen',
    fr: 'Construction générale de bâtiments résidentiels',
    en: 'Algemene bouw van residentiële gebouwen',
  },
  {
    code: '41202',
    nl: 'Algemene bouw van kantoorgebouwen',
    fr: "Construction générale d'immeubles de bureaux",
    en: 'Algemene bouw van kantoorgebouwen',
  },
  {
    code: '41203',
    nl: 'Algemene bouw van andere niet-residentiële gebouwen',
    fr: "Construction générale d'autres bâtiments non résidentiels",
    en: 'Algemene bouw van andere niet-residentiële gebouwen',
  },
  {
    code: '42110',
    nl: 'Bouw van autowegen en andere wegen',
    fr: "Construction de routes et d'autoroutes",
    en: 'Bouw van autowegen en andere wegen',
  },
  {
    code: '42120',
    nl: 'Bouw van boven- en ondergrondse spoorwegen',
    fr: 'Construction de voies ferrées de surface et souterraines',
    en: 'Bouw van boven- en ondergrondse spoorwegen',
  },
  {
    code: '42130',
    nl: 'Bouw van bruggen en tunnels',
    fr: 'Construction de ponts et de tunnels',
    en: 'Bouw van bruggen en tunnels',
  },
  {
    code: '42211',
    nl: 'Bouw van water- en gasdistributienetten',
    fr: "Construction de réseaux de distribution d'eau et de gaz",
    en: 'Bouw van water- en gasdistributienetten',
  },
  {
    code: '42212',
    nl: 'Bouw van rioleringen',
    fr: "Construction de réseaux d'évacuation des eaux usées",
    en: 'Bouw van rioleringen',
  },
  {
    code: '42219',
    nl: 'Bouw van civieltechnische werken voor vloeistoffen, n.e.g.',
    fr: 'Construction de réseaux pour fluides n.c.a.',
    en: 'Bouw van civieltechnische werken voor vloeistoffen, n.e.g.',
  },
  {
    code: '42220',
    nl: 'Bouw van civieltechnische werken voor elektriciteit en telecommunicatie',
    fr: 'Construction de réseaux électriques et de télécommunications',
    en: 'Bouw van civieltechnische werken voor elektriciteit en telecommunicatie',
  },
  {
    code: '42911',
    nl: 'Baggerwerken',
    fr: 'Travaux de dragage',
    en: 'Baggerwerken',
  },
  {
    code: '42919',
    nl: 'Waterbouw, m.u.v. baggerwerken',
    fr: "Construction d'ouvrages maritimes et fluviaux, sauf travaux de dragage",
    en: 'Waterbouw, m.u.v. baggerwerken',
  },
  {
    code: '42990',
    nl: 'Bouw van andere civieltechnische werken, n.e.g.',
    fr: "Construction d'autres ouvrages de génie civil n.c.a.",
    en: 'Bouw van andere civieltechnische werken, n.e.g.',
  },
  { code: '43110', nl: 'Slopen', fr: 'Travaux de démolition', en: 'Slopen' },
  {
    code: '43120',
    nl: 'Bouwrijp maken van terreinen',
    fr: 'Travaux de préparation des sites',
    en: 'Bouwrijp maken van terreinen',
  },
  {
    code: '43130',
    nl: 'Proefboren en boren',
    fr: "Forages d'essai et sondages",
    en: 'Proefboren en boren',
  },
  {
    code: '43211',
    nl: 'Elektrotechnische installatiewerken aan gebouwen',
    fr: "Travaux d'installation électrotechnique de bâtiment",
    en: 'Elektrotechnische installatiewerken aan gebouwen',
  },
  {
    code: '43212',
    nl: 'Elektrotechnische installatiewerken, uitgezonderd aan gebouwen',
    fr: "Travaux d'installation électrotechnique autres que de bâtiment",
    en: 'Elektrotechnische installatiewerken, uitgezonderd aan gebouwen',
  },
  {
    code: '43221',
    nl: 'Loodgieterswerk',
    fr: 'Travaux de plomberie',
    en: 'Loodgieterswerk',
  },
  {
    code: '43222',
    nl: 'Installatie van verwarming, klimaatregeling en ventilatie',
    fr: "Installation de chauffage, de ventilation et de conditionnement d'air",
    en: 'Installatie van verwarming, klimaatregeling en ventilatie',
  },
  {
    code: '43291',
    nl: 'Isolatiewerkzaamheden',
    fr: "Travaux d'isolation",
    en: 'Isolatiewerkzaamheden',
  },
  {
    code: '43299',
    nl: 'Overige bouwinstallatie, n.e.g.',
    fr: "Autres travaux d'installation n.c.a.",
    en: 'Overige bouwinstallatie, n.e.g.',
  },
  {
    code: '43310',
    nl: 'Stukadoorswerk',
    fr: 'Travaux de plâtrerie',
    en: 'Stukadoorswerk',
  },
  {
    code: '43320',
    nl: 'Schrijnwerk',
    fr: 'Travaux de menuiserie',
    en: 'Schrijnwerk',
  },
  {
    code: '43331',
    nl: 'Plaatsen van vloer- en wandtegels',
    fr: 'Pose de carrelages de sols et de murs',
    en: 'Plaatsen van vloer- en wandtegels',
  },
  {
    code: '43332',
    nl: 'Plaatsen van vloerbedekking en wandbekleding van hout',
    fr: 'Pose de revêtements en bois de sols et de murs',
    en: 'Plaatsen van vloerbedekking en wandbekleding van hout',
  },
  {
    code: '43333',
    nl: 'Plaatsen van behang en vloerbedekking en wandbekleding van andere materialen',
    fr: "Pose de papiers peints et de revêtements de murs et de sols en d'autres matériaux",
    en: 'Plaatsen van behang en vloerbedekking en wandbekleding van andere materialen',
  },
  {
    code: '43341',
    nl: 'Schilderen van gebouwen',
    fr: 'Peinture de bâtiments',
    en: 'Schilderen van gebouwen',
  },
  {
    code: '43342',
    nl: 'Schilderen van civieltechnische werken',
    fr: 'Peinture de travaux de génie civil',
    en: 'Schilderen van civieltechnische werken',
  },
  { code: '43343', nl: 'Glaszetten', fr: 'Vitrerie', en: 'Glaszetten' },
  {
    code: '43390',
    nl: 'Overige werkzaamheden in verband met de afwerking van gebouwen',
    fr: 'Autres travaux de finition',
    en: 'Overige werkzaamheden in verband met de afwerking van gebouwen',
  },
  {
    code: '43910',
    nl: 'Dakwerkzaamheden',
    fr: 'Travaux de couverture',
    en: 'Dakwerkzaamheden',
  },
  {
    code: '43991',
    nl: 'Waterdichtingswerken van muren',
    fr: "Travaux d'étanchéification des murs",
    en: 'Waterdichtingswerken van muren',
  },
  {
    code: '43992',
    nl: 'Gevelreiniging',
    fr: 'Ravalement des façades',
    en: 'Gevelreiniging',
  },
  {
    code: '43993',
    nl: 'Bouw van sierschouwen en open haarden',
    fr: 'Construction de cheminées décoratives et de feux ouverts',
    en: 'Bouw van sierschouwen en open haarden',
  },
  {
    code: '43994',
    nl: 'Uitvoeren van metsel- en voegwerken',
    fr: 'Travaux de maçonnerie et de rejointoiement',
    en: 'Uitvoeren van metsel- en voegwerken',
  },
  {
    code: '43995',
    nl: 'Restaureren van bouwwerken',
    fr: 'Travaux de restauration des bâtiments',
    en: 'Restaureren van bouwwerken',
  },
  { code: '43996', nl: 'Chapewerken', fr: 'Pose de chapes', en: 'Chapewerken' },
  {
    code: '43999',
    nl: 'Overige gespecialiseerde bouwwerkzaamheden',
    fr: 'Autres activités de construction spécialisées',
    en: 'Overige gespecialiseerde bouwwerkzaamheden',
  },
  {
    code: '45111',
    nl: "Groothandel in auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
    fr: "Commerce de gros d'automobiles et d'autres véhicules automobiles légers (inférieur ou égal à 3,5 tonnes )",
    en: "Groothandel in auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
  },
  {
    code: '45112',
    nl: "Handelsbemiddeling in auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
    fr: 'Intermédiaires du commerce en automobiles et autres véhicules automobiles légers (inférieur ou égal à 3,5 tonnes)',
    en: "Handelsbemiddeling in auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
  },
  {
    code: '45113',
    nl: "Detailhandel in auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
    fr: "Commerce de détail d'automobiles et d'autres véhicules automobiles légers (inférieur ou égal à 3,5 tonnes)",
    en: "Detailhandel in auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
  },
  {
    code: '45191',
    nl: 'Groothandel in andere motorvoertuigen (groter dan 3,5 ton)',
    fr: "Commerce de gros d'autres véhicules automobiles (supérieur à 3,5 tonnes)",
    en: 'Groothandel in andere motorvoertuigen (groter dan 3,5 ton)',
  },
  {
    code: '45192',
    nl: 'Handelsbemiddeling in andere motorvoertuigen (groter dan 3,5 ton)',
    fr: 'Intermédiaires du commerce en autres véhicules automobiles (supérieur à 3,5 tonnes)',
    en: 'Handelsbemiddeling in andere motorvoertuigen (groter dan 3,5 ton)',
  },
  {
    code: '45193',
    nl: 'Detailhandel in andere motorvoertuigen (groter dan 3,5 ton)',
    fr: "Commerce de détail d'autres véhicules automobiles (supérieur à 3,5 tonnes)",
    en: 'Detailhandel in andere motorvoertuigen (groter dan 3,5 ton)',
  },
  {
    code: '45194',
    nl: 'Handel in aanhangwagens, opleggers en caravans',
    fr: 'Commerce de remorques, de semi-remorques et de caravanes',
    en: 'Handel in aanhangwagens, opleggers en caravans',
  },
  {
    code: '45201',
    nl: "Algemeen onderhoud en reparatie van auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
    fr: "Entretien et réparation général d'automobiles et d'autres véhicules automobiles légers (inférieur ou égal à 3,5 tonnes)",
    en: "Algemeen onderhoud en reparatie van auto's en lichte bestelwagens (kleiner of gelijk aan 3,5 ton)",
  },
  {
    code: '45202',
    nl: 'Algemeen onderhoud en reparatie van overige motorvoertuigen (groter dan 3,5 ton)',
    fr: "Entretien et réparation général d'autres véhicules automobiles (supérieur à 3,5 tonnes )",
    en: 'Algemeen onderhoud en reparatie van overige motorvoertuigen (groter dan 3,5 ton)',
  },
  {
    code: '45203',
    nl: 'Reparatie en montage van specifieke auto-onderdelen',
    fr: 'Réparation de parties spécifiques de véhicules automobiles',
    en: 'Reparatie en montage van specifieke auto-onderdelen',
  },
  {
    code: '45204',
    nl: 'Carrosserieherstelling',
    fr: 'Réparations de carrosseries',
    en: 'Carrosserieherstelling',
  },
  {
    code: '45205',
    nl: 'Bandenservicebedrijven',
    fr: 'Services spécialisés relatifs au pneu',
    en: 'Bandenservicebedrijven',
  },
  {
    code: '45206',
    nl: 'Wassen en poetsen van motorvoertuigen',
    fr: 'Lavage de véhicules automobiles',
    en: 'Wassen en poetsen van motorvoertuigen',
  },
  {
    code: '45209',
    nl: 'Onderhoud en reparatie van motorvoertuigen, n.e.g.',
    fr: 'Entretien et réparation de véhicules automobiles n.c.a.',
    en: 'Onderhoud en reparatie van motorvoertuigen, n.e.g.',
  },
  {
    code: '45310',
    nl: 'Handelsbemiddeling en groothandel in onderdelen en accessoires van motorvoertuigen',
    fr: "Intermédiaires du commerce et commerce de gros d'équipements de véhicules automobiles",
    en: 'Handelsbemiddeling en groothandel in onderdelen en accessoires van motorvoertuigen',
  },
  {
    code: '45320',
    nl: 'Detailhandel in onderdelen en accessoires van motorvoertuigen',
    fr: "Commerce de détail d'équipements de véhicules automobiles",
    en: 'Detailhandel in onderdelen en accessoires van motorvoertuigen',
  },
  {
    code: '45401',
    nl: 'Handelsbemiddeling en groothandel in motorfietsen en delen en toebehoren van motorfietsen',
    fr: 'Intermédiaires du commerce et commerce de gros de motocycles, y compris les pièces et accessoires',
    en: 'Handelsbemiddeling en groothandel in motorfietsen en delen en toebehoren van motorfietsen',
  },
  {
    code: '45402',
    nl: 'Detailhandel in en onderhoud en reparatie van motorfietsen en delen en toebehoren van motorfietsen',
    fr: 'Entretien, réparation et commerce de détail de motocycles, y compris les pièces et accessoires',
    en: 'Detailhandel in en onderhoud en reparatie van motorfietsen en delen en toebehoren van motorfietsen',
  },
  {
    code: '46110',
    nl: 'Handelsbemiddeling in landbouwproducten, levende dieren en textielgrondstoffen en halffabrikaten',
    fr: 'Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis',
    en: 'Handelsbemiddeling in landbouwproducten, levende dieren en textielgrondstoffen en halffabrikaten',
  },
  {
    code: '46120',
    nl: 'Handelsbemiddeling in brandstoffen, ertsen, metalen en chemische producten',
    fr: 'Intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques',
    en: 'Handelsbemiddeling in brandstoffen, ertsen, metalen en chemische producten',
  },
  {
    code: '46130',
    nl: 'Handelsbemiddeling in hout en bouwmaterialen',
    fr: 'Intermédiaires du commerce en bois et matériaux de construction',
    en: 'Handelsbemiddeling in hout en bouwmaterialen',
  },
  {
    code: '46140',
    nl: 'Handelsbemiddeling in machines, apparaten en werktuigen voor de industrie en in schepen en luchtvaartuigen',
    fr: 'Intermédiaires du commerce en machines, équipements industriels, navires et avions',
    en: 'Handelsbemiddeling in machines, apparaten en werktuigen voor de industrie en in schepen en luchtvaartuigen',
  },
  {
    code: '46150',
    nl: 'Handelsbemiddeling in meubelen, huishoudelijke artikelen en ijzerwaren',
    fr: 'Intermédiaires du commerce en meubles, articles de ménage et quincaillerie',
    en: 'Handelsbemiddeling in meubelen, huishoudelijke artikelen en ijzerwaren',
  },
  {
    code: '46160',
    nl: 'Handelsbemiddeling in textiel, kleding, bont, schoeisel en lederwaren',
    fr: 'Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir',
    en: 'Handelsbemiddeling in textiel, kleding, bont, schoeisel en lederwaren',
  },
  {
    code: '46170',
    nl: 'Handelsbemiddeling in voedings- en genotmiddelen',
    fr: 'Intermédiaires du commerce en denrées, boissons et tabac',
    en: 'Handelsbemiddeling in voedings- en genotmiddelen',
  },
  {
    code: '46180',
    nl: 'Handelsbemiddeling gespecialiseerd in andere goederen',
    fr: "Intermédiaires spécialisés dans le commerce d'autres produits spécifiques",
    en: 'Handelsbemiddeling gespecialiseerd in andere goederen',
  },
  {
    code: '46190',
    nl: 'Handelsbemiddeling in goederen, algemeen assortiment',
    fr: 'Intermédiaires du commerce en produits divers',
    en: 'Handelsbemiddeling in goederen, algemeen assortiment',
  },
  {
    code: '46211',
    nl: 'Groothandel in granen en zaden',
    fr: 'Commerce de gros de céréales et de semences',
    en: 'Groothandel in granen en zaden',
  },
  {
    code: '46212',
    nl: 'Groothandel in veevoeders',
    fr: "Commerce de gros d'aliments pour le bétail",
    en: 'Groothandel in veevoeders',
  },
  {
    code: '46213',
    nl: 'Groothandel in ruwe plantaardige en dierlijke oliën en vetten',
    fr: "Commerce de gros d'huiles et de graisses brutes d'origine végétale ou animale",
    en: 'Groothandel in ruwe plantaardige en dierlijke oliën en vetten',
  },
  {
    code: '46214',
    nl: 'Groothandel in andere akkerbouwproducten',
    fr: "Commerce de gros d'autres produits agricoles",
    en: 'Groothandel in andere akkerbouwproducten',
  },
  {
    code: '46215',
    nl: 'Groothandel in ruwe tabak',
    fr: 'Commerce de gros de tabac non manufacturé',
    en: 'Groothandel in ruwe tabak',
  },
  {
    code: '46216',
    nl: 'Groothandel in akkerbouwproducten en veevoeders, algemeen assortiment',
    fr: "Commerce de gros d'aliments pour le bétail et de produits agricoles, assortiment général",
    en: 'Groothandel in akkerbouwproducten en veevoeders, algemeen assortiment',
  },
  {
    code: '46220',
    nl: 'Groothandel in bloemen en planten',
    fr: 'Commerce de gros de fleurs et de plantes',
    en: 'Groothandel in bloemen en planten',
  },
  {
    code: '46231',
    nl: 'Groothandel in levend vee',
    fr: 'Commerce de gros de bétail',
    en: 'Groothandel in levend vee',
  },
  {
    code: '46232',
    nl: 'Groothandel in levende dieren, m.u.v. levend vee',
    fr: "Commerce de gros d'animaux vivants, sauf bétail",
    en: 'Groothandel in levende dieren, m.u.v. levend vee',
  },
  {
    code: '46240',
    nl: 'Groothandel in huiden, vellen en leer',
    fr: 'Commerce de gros de cuirs et de peaux',
    en: 'Groothandel in huiden, vellen en leer',
  },
  {
    code: '46311',
    nl: 'Groothandel in consumptieaardappelen',
    fr: 'Commerce de gros de pommes de terre de consommation',
    en: 'Groothandel in consumptieaardappelen',
  },
  {
    code: '46319',
    nl: 'Groothandel in groenten en fruit, m.u.v. consumptieaardappelen',
    fr: 'Commerce de gros de fruits et de légumes, sauf pommes de terre de consommation',
    en: 'Groothandel in groenten en fruit, m.u.v. consumptieaardappelen',
  },
  {
    code: '46321',
    nl: 'Groothandel in vlees en vleesproducten, uitgezonderd vlees van wild en van gevogelte',
    fr: 'Commerce de gros de viandes et de produits à base de viande, sauf viande de volaille et de gibier',
    en: 'Groothandel in vlees en vleesproducten, uitgezonderd vlees van wild en van gevogelte',
  },
  {
    code: '46322',
    nl: 'Groothandel in vlees van wild en van gevogelte',
    fr: 'Commerce de gros de viande de volaille et de gibier',
    en: 'Groothandel in vlees van wild en van gevogelte',
  },
  {
    code: '46331',
    nl: 'Groothandel in zuivelproducten en eieren',
    fr: "Commerce de gros de produits laitiers et d'oeufs",
    en: 'Groothandel in zuivelproducten en eieren',
  },
  {
    code: '46332',
    nl: 'Groothandel in spijsoliën en -vetten',
    fr: "Commerce de gros d'huiles et de matières grasses comestibles",
    en: 'Groothandel in spijsoliën en -vetten',
  },
  {
    code: '46341',
    nl: 'Groothandel in wijnen en geestrijke dranken',
    fr: 'Commerce de gros de vin et de spiritueux',
    en: 'Groothandel in wijnen en geestrijke dranken',
  },
  {
    code: '46349',
    nl: 'Groothandel in dranken, algemeen assortiment',
    fr: 'Commerce de gros de boissons, assortiment général',
    en: 'Groothandel in dranken, algemeen assortiment',
  },
  {
    code: '46350',
    nl: 'Groothandel in tabaksproducten',
    fr: 'Commerce de gros de produits à base de tabac',
    en: 'Groothandel in tabaksproducten',
  },
  {
    code: '46360',
    nl: 'Groothandel in suiker, chocolade en suikerwerk',
    fr: 'Commerce de gros de sucre, de chocolat et de confiserie',
    en: 'Groothandel in suiker, chocolade en suikerwerk',
  },
  {
    code: '46370',
    nl: 'Groothandel in koffie, thee, cacao en specerijen',
    fr: "Commerce de gros de café, de thé, de cacao et d'épices",
    en: 'Groothandel in koffie, thee, cacao en specerijen',
  },
  {
    code: '46381',
    nl: 'Groothandel in vis en schaal- en weekdieren',
    fr: 'Commerce de gros de poissons, crustacés et mollusques',
    en: 'Groothandel in vis en schaal- en weekdieren',
  },
  {
    code: '46382',
    nl: 'Groothandel in aardappelproducten',
    fr: 'Commerce de gros de produits à base de pommes de terre',
    en: 'Groothandel in aardappelproducten',
  },
  {
    code: '46383',
    nl: 'Groothandel in voedsel voor huisdieren',
    fr: "Commerce de gros d'aliments pour animaux de compagnie",
    en: 'Groothandel in voedsel voor huisdieren',
  },
  {
    code: '46389',
    nl: 'Groothandel in andere voedingsmiddelen, n.e.g.',
    fr: "Commerce de gros d'autres produits alimentaires n.c.a.",
    en: 'Groothandel in andere voedingsmiddelen, n.e.g.',
  },
  {
    code: '46391',
    nl: 'Niet-gespecialiseerde groothandel in diepgevroren voedingsmiddelen',
    fr: 'Commerce de gros non spécialisé de denrées surgelées',
    en: 'Niet-gespecialiseerde groothandel in diepgevroren voedingsmiddelen',
  },
  {
    code: '46392',
    nl: 'Niet-gespecialiseerde groothandel in niet-diepgevroren voedingsmiddelen, dranken en genotmiddelen',
    fr: 'Commerce de gros non spécialisé de denrées non-surgelées, boissons et tabac',
    en: 'Niet-gespecialiseerde groothandel in niet-diepgevroren voedingsmiddelen, dranken en genotmiddelen',
  },
  {
    code: '46411',
    nl: 'Groothandel in weefsels, stoffen en fournituren',
    fr: "Commerce de gros de tissus, d'étoffes et d'articles de mercerie",
    en: 'Groothandel in weefsels, stoffen en fournituren',
  },
  {
    code: '46412',
    nl: 'Groothandel in huishoudtextiel en beddengoed',
    fr: 'Commerce de gros de linge de maison et de literie',
    en: 'Groothandel in huishoudtextiel en beddengoed',
  },
  {
    code: '46419',
    nl: 'Groothandel in overig textiel',
    fr: "Commerce de gros d'autres textiles",
    en: 'Groothandel in overig textiel',
  },
  {
    code: '46421',
    nl: 'Groothandel in werkkleding',
    fr: 'Commerce de gros de vêtements de travail',
    en: 'Groothandel in werkkleding',
  },
  {
    code: '46422',
    nl: 'Groothandel in onderkleding',
    fr: 'Commerce de gros de sous-vêtements',
    en: 'Groothandel in onderkleding',
  },
  {
    code: '46423',
    nl: 'Groothandel in kleding, met uitzondering van werk- en onderkleding',
    fr: 'Commerce de gros de vêtements, autres que vêtements de travail et sous-vêtements',
    en: 'Groothandel in kleding, met uitzondering van werk- en onderkleding',
  },
  {
    code: '46424',
    nl: 'Groothandel in kledingaccessoires',
    fr: "Commerce de gros d'accessoires du vêtement",
    en: 'Groothandel in kledingaccessoires',
  },
  {
    code: '46425',
    nl: 'Groothandel in schoeisel',
    fr: 'Commerce de gros de chaussures',
    en: 'Groothandel in schoeisel',
  },
  {
    code: '46431',
    nl: 'Groothandel in elektrische huishoudelijke apparaten en audio- en videoapparatuur',
    fr: "Commerce de gros d'appareils électroménagers et audio-vidéo",
    en: 'Groothandel in elektrische huishoudelijke apparaten en audio- en videoapparatuur',
  },
  {
    code: '46432',
    nl: 'Groothandel in opgenomen beeld- en geluidsdragers',
    fr: "Commerce de gros de supports enregistrés d'images et de sons",
    en: 'Groothandel in opgenomen beeld- en geluidsdragers',
  },
  {
    code: '46433',
    nl: 'Groothandel in foto- en filmapparatuur en in andere optische artikelen',
    fr: "Commerce de gros d'appareils photographiques et cinématographiques et d'autres articles d'optique",
    en: 'Groothandel in foto- en filmapparatuur en in andere optische artikelen',
  },
  {
    code: '46441',
    nl: 'Groothandel in porselein en glaswerk',
    fr: 'Commerce de gros de porcelaine et de verrerie',
    en: 'Groothandel in porselein en glaswerk',
  },
  {
    code: '46442',
    nl: 'Groothandel in reinigingsmiddelen',
    fr: "Commerce de gros de produits d'entretien",
    en: 'Groothandel in reinigingsmiddelen',
  },
  {
    code: '46450',
    nl: 'Groothandel in parfumerieën en cosmetica',
    fr: 'Commerce de gros de parfumerie et de produits de beauté',
    en: 'Groothandel in parfumerieën en cosmetica',
  },
  {
    code: '46460',
    nl: 'Groothandel in farmaceutische producten',
    fr: 'Commerce de gros de produits pharmaceutiques',
    en: 'Groothandel in farmaceutische producten',
  },
  {
    code: '46471',
    nl: 'Groothandel in huismeubilair',
    fr: 'Commerce de gros de mobilier domestique',
    en: 'Groothandel in huismeubilair',
  },
  {
    code: '46472',
    nl: 'Groothandel in tapijten',
    fr: 'Commerce de gros de tapis',
    en: 'Groothandel in tapijten',
  },
  {
    code: '46473',
    nl: 'Groothandel in verlichtingsapparatuur',
    fr: "Commerce de gros d'appareils d'éclairage",
    en: 'Groothandel in verlichtingsapparatuur',
  },
  {
    code: '46480',
    nl: 'Groothandel in uurwerken en sieraden',
    fr: "Commerce de gros d'articles d'horlogerie et de bijouterie",
    en: 'Groothandel in uurwerken en sieraden',
  },
  {
    code: '46491',
    nl: 'Groothandel in kranten, boeken en tijdschriften',
    fr: 'Commerce de gros de journaux, de livres et de périodiques',
    en: 'Groothandel in kranten, boeken en tijdschriften',
  },
  {
    code: '46492',
    nl: 'Groothandel in kantoor- en schoolbenodigdheden',
    fr: 'Commerce de gros de fournitures scolaires et de bureau',
    en: 'Groothandel in kantoor- en schoolbenodigdheden',
  },
  {
    code: '46493',
    nl: 'Groothandel in papier- en kartonwaren',
    fr: "Commerce de gros d'articles en papier ou en carton",
    en: 'Groothandel in papier- en kartonwaren',
  },
  {
    code: '46494',
    nl: 'Groothandel in niet-elektrische huishoudelijke artikelen',
    fr: "Commerce de gros d'articles ménagers non électriques",
    en: 'Groothandel in niet-elektrische huishoudelijke artikelen',
  },
  {
    code: '46495',
    nl: 'Groothandel in fietsen',
    fr: 'Commerce de gros de cycles',
    en: 'Groothandel in fietsen',
  },
  {
    code: '46496',
    nl: 'Groothandel in sport- en kampeerartikelen, met uitzondering van fietsen',
    fr: "Commerce de gros d'articles de sport et de camping, sauf cycles",
    en: 'Groothandel in sport- en kampeerartikelen, met uitzondering van fietsen',
  },
  {
    code: '46497',
    nl: 'Groothandel in spellen en speelgoed',
    fr: 'Commerce de gros de jeux et de jouets',
    en: 'Groothandel in spellen en speelgoed',
  },
  {
    code: '46498',
    nl: 'Groothandel in lederwaren en reisartikelen',
    fr: "Commerce de gros de maroquinerie et d'articles de voyage",
    en: 'Groothandel in lederwaren en reisartikelen',
  },
  {
    code: '46499',
    nl: 'Groothandel in andere consumentenartikelen, n.e.g.',
    fr: "Commerce de gros d'autres biens domestiques n.c.a.",
    en: 'Groothandel in andere consumentenartikelen, n.e.g.',
  },
  {
    code: '46510',
    nl: 'Groothandel in computers, randapparatuur en software',
    fr: "Commerce de gros d'ordinateurs, d'équipements informatiques périphériques et de logiciels",
    en: 'Groothandel in computers, randapparatuur en software',
  },
  {
    code: '46520',
    nl: 'Groothandel in elektronische en telecommunicatieapparatuur en delen daarvan',
    fr: "Commerce de gros de composants et d'équipements électroniques et de télécommunication",
    en: 'Groothandel in elektronische en telecommunicatieapparatuur en delen daarvan',
  },
  {
    code: '46610',
    nl: 'Groothandel in machines, werktuigen en toebehoren voor de landbouw',
    fr: 'Commerce de gros de matériel agricole',
    en: 'Groothandel in machines, werktuigen en toebehoren voor de landbouw',
  },
  {
    code: '46620',
    nl: 'Groothandel in gereedschapswerktuigen',
    fr: 'Commerce de gros de machines-outils',
    en: 'Groothandel in gereedschapswerktuigen',
  },
  {
    code: '46630',
    nl: 'Groothandel in machines voor de mijnbouw, de bouwnijverheid en de weg- en waterbouw',
    fr: "Commerce de gros de machines pour l'extraction, la construction et le génie civil",
    en: 'Groothandel in machines voor de mijnbouw, de bouwnijverheid en de weg- en waterbouw',
  },
  {
    code: '46640',
    nl: 'Groothandel in machines voor de textielindustrie en in naai- en breimachines',
    fr: "Commerce de gros de machines pour l'industrie textile et l'habillement",
    en: 'Groothandel in machines voor de textielindustrie en in naai- en breimachines',
  },
  {
    code: '46650',
    nl: 'Groothandel in kantoormeubelen',
    fr: 'Commerce de gros de mobilier de bureau',
    en: 'Groothandel in kantoormeubelen',
  },
  {
    code: '46660',
    nl: 'Groothandel in andere kantoormachines en kantoorbenodigdheden, met uitzondering van computers en randapparatuur',
    fr: "Commerce de gros d'autres machines et équipements de bureau",
    en: 'Groothandel in andere kantoormachines en kantoorbenodigdheden, met uitzondering van computers en randapparatuur',
  },
  {
    code: '46691',
    nl: 'Groothandel in machines voor de productie van voedings- en genotmiddelen',
    fr: "Commerce de gros de machines pour la production d'aliments, de boissons et de tabac",
    en: 'Groothandel in machines voor de productie van voedings- en genotmiddelen',
  },
  {
    code: '46692',
    nl: 'Groothandel in verpakkingsmachines en weegtoestellen',
    fr: "Commerce de gros de machines d'emballage et d'appareils de pesage",
    en: 'Groothandel in verpakkingsmachines en weegtoestellen',
  },
  {
    code: '46693',
    nl: 'Groothandel in elektrisch materiaal, inclusief installatiemateriaal',
    fr: "Commerce de gros de matériel électrique, y compris le matériel d'installation",
    en: 'Groothandel in elektrisch materiaal, inclusief installatiemateriaal',
  },
  {
    code: '46694',
    nl: 'Groothandel in hijs-, hef- en transportwerktuigen',
    fr: 'Commerce de gros de matériel de levage et de manutention',
    en: 'Groothandel in hijs-, hef- en transportwerktuigen',
  },
  {
    code: '46695',
    nl: 'Groothandel in pompen en compressoren',
    fr: 'Commerce de gros de pompes et de compresseurs',
    en: 'Groothandel in pompen en compressoren',
  },
  {
    code: '46696',
    nl: 'Groothandel in meet-, controle- en navigatieinstrumenten',
    fr: "Commerce de gros d'instruments de mesure, de contrôle et de navigation",
    en: 'Groothandel in meet-, controle- en navigatieinstrumenten',
  },
  {
    code: '46697',
    nl: 'Groothandel in machines en apparaten voor de warmte-, koel- en vriestechniek voor industrieel gebruik',
    fr: "Commerce de gros de machines et d'appareils de chauffage et de refroidissement à usage industriel",
    en: 'Groothandel in machines en apparaten voor de warmte-, koel- en vriestechniek voor industrieel gebruik',
  },
  {
    code: '46699',
    nl: 'Groothandel in andere machines en werktuigen, n.e.g.',
    fr: "Commerce de gros d'autres machines et équipements n.c.a.",
    en: 'Groothandel in andere machines en werktuigen, n.e.g.',
  },
  {
    code: '46710',
    nl: 'Groothandel in vaste, vloeibare en gasvormige brandstoffen en aanverwante producten',
    fr: 'Commerce de gros de combustibles solides, liquides et gazeux et de produits annexes',
    en: 'Groothandel in vaste, vloeibare en gasvormige brandstoffen en aanverwante producten',
  },
  {
    code: '46720',
    nl: 'Groothandel in metalen en metaalertsen',
    fr: 'Commerce de gros de minerais et de métaux',
    en: 'Groothandel in metalen en metaalertsen',
  },
  {
    code: '46731',
    nl: 'Groothandel in bouwmaterialen, algemeen assortiment',
    fr: 'Commerce de gros de matériaux de construction, assortiment général',
    en: 'Groothandel in bouwmaterialen, algemeen assortiment',
  },
  {
    code: '46732',
    nl: 'Groothandel in hout',
    fr: 'Commerce de gros de bois',
    en: 'Groothandel in hout',
  },
  {
    code: '46733',
    nl: 'Groothandel in behang, verf en woningtextiel',
    fr: "Commerce de gros de papiers peints, de peintures et de tissus d'ameublement",
    en: 'Groothandel in behang, verf en woningtextiel',
  },
  {
    code: '46734',
    nl: 'Groothandel in vlakglas',
    fr: 'Commerce de gros de verre plat',
    en: 'Groothandel in vlakglas',
  },
  {
    code: '46735',
    nl: 'Groothandel in vloer- en wandtegels',
    fr: 'Commerce de gros de carrelages',
    en: 'Groothandel in vloer- en wandtegels',
  },
  {
    code: '46736',
    nl: 'Groothandel in sanitair',
    fr: "Commerce de gros d'équipements sanitaires",
    en: 'Groothandel in sanitair',
  },
  {
    code: '46739',
    nl: 'Groothandel in overige bouwmaterialen',
    fr: "Commerce de gros d'autres matériaux de construction",
    en: 'Groothandel in overige bouwmaterialen',
  },
  {
    code: '46741',
    nl: 'Groothandel in ijzerwaren',
    fr: 'Commerce de gros de quincaillerie',
    en: 'Groothandel in ijzerwaren',
  },
  {
    code: '46742',
    nl: 'Groothandel in installatiemateriaal voor loodgieterswerk en verwarming',
    fr: 'Commerce de gros de fournitures pour plomberie et chauffage',
    en: 'Groothandel in installatiemateriaal voor loodgieterswerk en verwarming',
  },
  {
    code: '46751',
    nl: 'Groothandel in chemische producten voor industrieel gebruik',
    fr: 'Commerce de gros de produits chimiques industriels',
    en: 'Groothandel in chemische producten voor industrieel gebruik',
  },
  {
    code: '46752',
    nl: 'Groothandel in kunstmeststoffen en andere agrochemische producten',
    fr: "Commerce de gros d'engrais et de produits phytosanitaires",
    en: 'Groothandel in kunstmeststoffen en andere agrochemische producten',
  },
  {
    code: '46761',
    nl: 'Groothandel in diamant en andere edelstenen',
    fr: "Commerce de gros de diamants et d'autres pierres précieuses",
    en: 'Groothandel in diamant en andere edelstenen',
  },
  {
    code: '46769',
    nl: 'Groothandel in andere intermediaire producten, n.e.g.',
    fr: "Commerce de gros d'autres produits intermédiaires n.c.a.",
    en: 'Groothandel in andere intermediaire producten, n.e.g.',
  },
  {
    code: '46771',
    nl: 'Groothandel in autosloopmateriaal',
    fr: "Commerce de gros d'épaves de véhicules automobiles et de pièces réutilisables",
    en: 'Groothandel in autosloopmateriaal',
  },
  {
    code: '46772',
    nl: 'Groothandel in ijzer- en staalschroot en in oude non-ferrometalen',
    fr: 'Commerce de gros de déchets et de débris métalliques et non-métalliques',
    en: 'Groothandel in ijzer- en staalschroot en in oude non-ferrometalen',
  },
  {
    code: '46779',
    nl: 'Groothandel in afval en schroot, n.e.g.',
    fr: 'Commerce de gros de déchets et débris n.c.a.',
    en: 'Groothandel in afval en schroot, n.e.g.',
  },
  {
    code: '46900',
    nl: 'Niet-gespecialiseerde groothandel',
    fr: 'Commerce de gros non spécialisé',
    en: 'Niet-gespecialiseerde groothandel',
  },
  {
    code: '47111',
    nl: 'Detailhandel in niet-gespecialiseerde winkels in diepvriesproducten',
    fr: 'Commerce de détail en magasin non spécialisé de produits surgelés',
    en: 'Detailhandel in niet-gespecialiseerde winkels in diepvriesproducten',
  },
  {
    code: '47112',
    nl: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen (verkoopsoppervlakte van minder dan 100 m²)',
    fr: 'Commerce de détail en magasin non spécialisé à prédominance alimentaire (surface de vente inférieure à 100m²)',
    en: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen (verkoopsoppervlakte van minder dan 100 m²)',
  },
  {
    code: '47113',
    nl: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen (verkoopsoppervlakte tussen 100 m² en minder dan 400 m²)',
    fr: 'Commerce de détail en magasin non spécialisé à prédominance alimentaire (surface de vente comprise entre 100m² et moins de 400m²)',
    en: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen (verkoopsoppervlakte tussen 100 m² en minder dan 400 m²)',
  },
  {
    code: '47114',
    nl: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen (verkoopsoppervlakte tussen 400 m² en minder dan 2500 m²)',
    fr: 'Commerce de détail en magasin non spécialisé à prédominance alimentaire (surface de vente comprise entre 400m² et moins de 2500m²)',
    en: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen (verkoopsoppervlakte tussen 400 m² en minder dan 2500 m²)',
  },
  {
    code: '47115',
    nl: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen (verkoopsoppervlakte vanaf 2500 m²)',
    fr: 'Commerce de détail en magasin non spécialisé à prédominance alimentaire (surface de vente supérieure ou égale à 2500m²)',
    en: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen overheersen (verkoopsoppervlakte vanaf 2500 m²)',
  },
  {
    code: '47191',
    nl: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen niet overheersen (verkoopoppervlakte van minder dan 2500 m²)',
    fr: 'Commerce de détail en magasin non spécialisé sans prédominance alimentaire (surface de vente inférieure à 2500m²)',
    en: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen niet overheersen (verkoopoppervlakte van minder dan 2500 m²)',
  },
  {
    code: '47192',
    nl: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen niet overheersen (verkoopoppervlakte vanaf 2500 m²)',
    fr: 'Commerce de détail en magasin non spécialisé sans prédominance alimentaire (surface de vente supérieure ou égale à 2500m²)',
    en: 'Detailhandel in niet-gespecialiseerde winkels waarbij voedings- en genotmiddelen niet overheersen (verkoopoppervlakte vanaf 2500 m²)',
  },
  {
    code: '47210',
    nl: 'Detailhandel in groenten en fruit in gespecialiseerde winkels',
    fr: 'Commerce de détail de fruits et de légumes en magasin spécialisé',
    en: 'Detailhandel in groenten en fruit in gespecialiseerde winkels',
  },
  {
    code: '47221',
    nl: 'Detailhandel in vlees en vleesproducten in gespecialiseerde winkels, m.u.v. vlees van wild en van gevogelte',
    fr: 'Commerce de détail de viandes et de produits à base de viande en magasin spécialisé, sauf viande de gibier et de volaille',
    en: 'Detailhandel in vlees en vleesproducten in gespecialiseerde winkels, m.u.v. vlees van wild en van gevogelte',
  },
  {
    code: '47222',
    nl: 'Detailhandel in vlees van wild en van gevogelte in gespecialiseerde winkels',
    fr: 'Commerce de détail de viande de gibier et de volaille en magasin spécialisé',
    en: 'Detailhandel in vlees van wild en van gevogelte in gespecialiseerde winkels',
  },
  {
    code: '47230',
    nl: 'Detailhandel in vis en schaal- en weekdieren in gespecialiseerde winkels',
    fr: 'Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé',
    en: 'Detailhandel in vis en schaal- en weekdieren in gespecialiseerde winkels',
  },
  {
    code: '47241',
    nl: 'Detailhandel in brood en banketbakkerswerk in gespecialiseerde winkels (koude bakkers)',
    fr: 'Commerce de détail de pain et de pâtisserie en magasin spécialisé (dépôt)',
    en: 'Detailhandel in brood en banketbakkerswerk in gespecialiseerde winkels (koude bakkers)',
  },
  {
    code: '47242',
    nl: 'Detailhandel in chocolade en suikerwerk in gespecialiseerde winkels',
    fr: 'Commerce de détail de chocolat et de confiserie en magasin spécialisé',
    en: 'Detailhandel in chocolade en suikerwerk in gespecialiseerde winkels',
  },
  {
    code: '47251',
    nl: 'Detailhandel in wijnen en geestrijke dranken in gespecialiseerde winkels',
    fr: 'Commerce de détail de vins et de spiritueux en magasin spécialisé',
    en: 'Detailhandel in wijnen en geestrijke dranken in gespecialiseerde winkels',
  },
  {
    code: '47252',
    nl: 'Detailhandel in dranken in gespecialiseerde winkels, algemeen assortiment',
    fr: 'Commerce de détail de boissons en magasin spécialisé, assortiment général',
    en: 'Detailhandel in dranken in gespecialiseerde winkels, algemeen assortiment',
  },
  {
    code: '47260',
    nl: 'Detailhandel in tabaksproducten in gespecialiseerde winkels',
    fr: 'Commerce de détail de produits à base de tabac en magasin spécialisé',
    en: 'Detailhandel in tabaksproducten in gespecialiseerde winkels',
  },
  {
    code: '47291',
    nl: 'Detailhandel in zuivelproducten en eieren in gespecialiseerde winkels',
    fr: "Commerce de détail de produits laitiers et d'ufs en magasin spécialisé",
    en: 'Detailhandel in zuivelproducten en eieren in gespecialiseerde winkels',
  },
  {
    code: '47299',
    nl: 'Overige detailhandel in voedingsmiddelen in gespecialiseerde winkels, n.e.g.',
    fr: 'Autres commerces de détail alimentaires en magasin spécialisé n.c.a.',
    en: 'Overige detailhandel in voedingsmiddelen in gespecialiseerde winkels, n.e.g.',
  },
  {
    code: '47300',
    nl: 'Detailhandel in motorbrandstoffen in gespecialiseerde winkels',
    fr: 'Commerce de détail de carburants automobiles en magasin spécialisé',
    en: 'Detailhandel in motorbrandstoffen in gespecialiseerde winkels',
  },
  {
    code: '47410',
    nl: 'Detailhandel in computers, randapparatuur en software in gespecialiseerde winkels',
    fr: "Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé",
    en: 'Detailhandel in computers, randapparatuur en software in gespecialiseerde winkels',
  },
  {
    code: '47420',
    nl: 'Detailhandel in telecommunicatieapparatuur in gespecialiseerde winkels',
    fr: 'Commerce de détail de matériels de télécommunication en magasin spécialisé',
    en: 'Detailhandel in telecommunicatieapparatuur in gespecialiseerde winkels',
  },
  {
    code: '47430',
    nl: 'Detailhandel in audio- en videoapparatuur in gespecialiseerde winkels',
    fr: 'Commerce de détail de matériels audio-vidéo en magasin spécialisé',
    en: 'Detailhandel in audio- en videoapparatuur in gespecialiseerde winkels',
  },
  {
    code: '47511',
    nl: 'Detailhandel in kledingstoffen in gespecialiseerde winkels',
    fr: "Commerce de détail de tissus d'habillement en magasin spécialisé",
    en: 'Detailhandel in kledingstoffen in gespecialiseerde winkels',
  },
  {
    code: '47512',
    nl: 'Detailhandel in huishoudtextiel en beddengoed in gespecialiseerde winkels',
    fr: 'Commerce de détail de linge de maison en magasin spécialisé',
    en: 'Detailhandel in huishoudtextiel en beddengoed in gespecialiseerde winkels',
  },
  {
    code: '47513',
    nl: 'Detailhandel in breigarens, handwerken en fournituren in gespecialiseerde winkels',
    fr: "Commerce de détail de fils à tricoter et d'articles de mercerie en magasin spécialisé",
    en: 'Detailhandel in breigarens, handwerken en fournituren in gespecialiseerde winkels',
  },
  {
    code: '47519',
    nl: 'Detailhandel in overig textiel in gespecialiseerde winkels',
    fr: "Commerce de détail d'autres textiles en magasin spécialisé",
    en: 'Detailhandel in overig textiel in gespecialiseerde winkels',
  },
  {
    code: '47521',
    nl: 'Bouwmarkten en andere doe-het-zelfzaken in bouwmaterialen, algemeen assortiment',
    fr: 'Commerce de détail de matériaux de construction en magasin spécialisé, assortiment général',
    en: 'Bouwmarkten en andere doe-het-zelfzaken in bouwmaterialen, algemeen assortiment',
  },
  {
    code: '47522',
    nl: 'Detailhandel in houten bouw- en tuinmaterialen in gespecialiseerde winkels',
    fr: 'Commerce de détail de matériaux de construction et de matériaux de jardin en bois en magasin spécialisé',
    en: 'Detailhandel in houten bouw- en tuinmaterialen in gespecialiseerde winkels',
  },
  {
    code: '47523',
    nl: 'Detailhandel in wand- en vloertegels in gespecialiseerde winkels',
    fr: 'Commerce de détail de carrelages de sols et de murs en magasin spécialisé',
    en: 'Detailhandel in wand- en vloertegels in gespecialiseerde winkels',
  },
  {
    code: '47524',
    nl: 'Detailhandel in parket-, laminaat- en kurkvloeren in gespecialiseerde winkels',
    fr: 'Commerce de détail de parquet, de laminés et de revêtement en liège en magasin spécialisé',
    en: 'Detailhandel in parket-, laminaat- en kurkvloeren in gespecialiseerde winkels',
  },
  {
    code: '47525',
    nl: 'Detailhandel in ijzerwaren en gereedschappen in gespecialiseerde winkels',
    fr: "Commerce de détail de quincaillerie et d'outils en magasin spécialisé",
    en: 'Detailhandel in ijzerwaren en gereedschappen in gespecialiseerde winkels',
  },
  {
    code: '47526',
    nl: 'Detailhandel in verf en verfwaren in gespecialiseerde winkels',
    fr: 'Commerce de détail de peinture et de vernis en magasin spécialisé',
    en: 'Detailhandel in verf en verfwaren in gespecialiseerde winkels',
  },
  {
    code: '47527',
    nl: 'Detailhandel in sanitaire artikelen en sanitair installatiemateriaal in gespecialiseerde winkels',
    fr: "Commerce de détail d'articles et de matériels d'installations sanitaires en magasin spécialisé",
    en: 'Detailhandel in sanitaire artikelen en sanitair installatiemateriaal in gespecialiseerde winkels',
  },
  {
    code: '47529',
    nl: 'Detailhandel in overige bouwmaterialen in gespecialiseerde winkels',
    fr: "Commerce de détail d'autres matériaux de construction en magasin spécialisé",
    en: 'Detailhandel in overige bouwmaterialen in gespecialiseerde winkels',
  },
  {
    code: '47530',
    nl: 'Detailhandel in tapijten en andere vloerbedekking en wandbekleding in gespecialiseerde winkels',
    fr: 'Commerce de détail de tapis, de moquettes et de revêtements de murs et de sols en magasin spécialisé',
    en: 'Detailhandel in tapijten en andere vloerbedekking en wandbekleding in gespecialiseerde winkels',
  },
  {
    code: '47540',
    nl: 'Detailhandel in elektrische huishoudapparaten in gespecialiseerde winkels',
    fr: "Commerce de détail d'appareils électroménagers en magasin spécialisé",
    en: 'Detailhandel in elektrische huishoudapparaten in gespecialiseerde winkels',
  },
  {
    code: '47591',
    nl: 'Detailhandel in huismeubilair in gespecialiseerde winkels',
    fr: 'Commerce de détail de mobilier de maison en magasin spécialisé',
    en: 'Detailhandel in huismeubilair in gespecialiseerde winkels',
  },
  {
    code: '47592',
    nl: 'Detailhandel in verlichtingsartikelen in gespecialiseerde winkels',
    fr: "Commerce de détail d'appareils d'éclairage en magasin spécialisé",
    en: 'Detailhandel in verlichtingsartikelen in gespecialiseerde winkels',
  },
  {
    code: '47593',
    nl: 'Detailhandel in glas-, porselein- en aardewerk en in niet-elektrische huishoudelijke artikelen in gespecialiseerde winkels',
    fr: "Commerce de détail d'appareils ménagers non électriques, de vaisselle, de verrerie, de porcelaine et de poterie en magasin spécialisé",
    en: 'Detailhandel in glas-, porselein- en aardewerk en in niet-elektrische huishoudelijke artikelen in gespecialiseerde winkels',
  },
  {
    code: '47594',
    nl: 'Detailhandel in muziekinstrumenten in gespecialiseerde winkels',
    fr: "Commerce de détail d'instruments de musique en magasin spécialisé",
    en: 'Detailhandel in muziekinstrumenten in gespecialiseerde winkels',
  },
  {
    code: '47599',
    nl: 'Detailhandel in andere huishoudelijke artikelen in gespecialiseerde winkels, n.e.g.',
    fr: "Commerce de détail d'autres articles de ménage en magasin spécialisé n.c.a.",
    en: 'Detailhandel in andere huishoudelijke artikelen in gespecialiseerde winkels, n.e.g.',
  },
  {
    code: '47610',
    nl: 'Detailhandel in boeken in gespecialiseerde winkels',
    fr: 'Commerce de détail de livres en magasin spécialisé',
    en: 'Detailhandel in boeken in gespecialiseerde winkels',
  },
  {
    code: '47620',
    nl: 'Detailhandel in kranten en kantoorbehoeften in gespecialiseerde winkels',
    fr: 'Commerce de détail de journaux et de papeterie en magasin spécialisé',
    en: 'Detailhandel in kranten en kantoorbehoeften in gespecialiseerde winkels',
  },
  {
    code: '47630',
    nl: 'Detailhandel in audio- en video-opnamen in gespecialiseerde winkels',
    fr: "Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé",
    en: 'Detailhandel in audio- en video-opnamen in gespecialiseerde winkels',
  },
  {
    code: '47640',
    nl: 'Detailhandel in sport- en kampeerartikelen in gespecialiseerde winkels',
    fr: "Commerce de détail d'articles de sport en magasin spécialisé",
    en: 'Detailhandel in sport- en kampeerartikelen in gespecialiseerde winkels',
  },
  {
    code: '47650',
    nl: 'Detailhandel in spellen en speelgoed in gespecialiseerde winkels',
    fr: 'Commerce de détail de jeux et de jouets en magasin spécialisé',
    en: 'Detailhandel in spellen en speelgoed in gespecialiseerde winkels',
  },
  {
    code: '47711',
    nl: 'Detailhandel in damesbovenkleding in gespecialiseerde winkels',
    fr: 'Commerce de détail de vêtements pour dame en magasin spécialisé',
    en: 'Detailhandel in damesbovenkleding in gespecialiseerde winkels',
  },
  {
    code: '47712',
    nl: 'Detailhandel in herenbovenkleding in gespecialiseerde winkels',
    fr: 'Commerce de détail de vêtements pour homme en magasin spécialisé',
    en: 'Detailhandel in herenbovenkleding in gespecialiseerde winkels',
  },
  {
    code: '47713',
    nl: 'Detailhandel in baby- en kinderbovenkleding in gespecialiseerde winkels',
    fr: 'Commerce de détail de vêtements pour bébé et enfant en magasin spécialisé',
    en: 'Detailhandel in baby- en kinderbovenkleding in gespecialiseerde winkels',
  },
  {
    code: '47714',
    nl: 'Detailhandel in onderkleding, lingerie en strand- en badkleding in gespecialiseerde winkels',
    fr: 'Commerce de détail de sous-vêtements, de lingerie et de vêtements de bain en magasin spécialisé',
    en: 'Detailhandel in onderkleding, lingerie en strand- en badkleding in gespecialiseerde winkels',
  },
  {
    code: '47715',
    nl: 'Detailhandel in kledingaccessoires in gespecialiseerde winkels',
    fr: "Commerce de détail d'accessoires du vêtement en magasin spécialisé",
    en: 'Detailhandel in kledingaccessoires in gespecialiseerde winkels',
  },
  {
    code: '47716',
    nl: 'Detailhandel in dames-, heren-, baby- en kinderboven- en onderkleding en kledingaccessoires in gespecialiseerde winkels (algemeen assortiment)',
    fr: "Commerce de détail de vêtements, de sous-vêtements et d'accessoires pour dame, homme, enfant et bébé en magasin spécialisé, assortiment général",
    en: 'Detailhandel in dames-, heren-, baby- en kinderboven- en onderkleding en kledingaccessoires in gespecialiseerde winkels (algemeen assortiment)',
  },
  {
    code: '47721',
    nl: 'Detailhandel in schoeisel in gespecialiseerde winkels',
    fr: 'Commerce de détail de chaussures en magasin spécialisé',
    en: 'Detailhandel in schoeisel in gespecialiseerde winkels',
  },
  {
    code: '47722',
    nl: 'Detailhandel in lederwaren en reisartikelen in gespecialiseerde winkels',
    fr: "Commerce de détail de maroquinerie et d'articles de voyage en magasin spécialisé",
    en: 'Detailhandel in lederwaren en reisartikelen in gespecialiseerde winkels',
  },
  {
    code: '47730',
    nl: 'Apotheken',
    fr: 'Commerce de détail de produits pharmaceutiques en magasin spécialisé',
    en: 'Apotheken',
  },
  {
    code: '47740',
    nl: 'Detailhandel in medische en orthopedische artikelen in gespecialiseerde winkels',
    fr: "Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé",
    en: 'Detailhandel in medische en orthopedische artikelen in gespecialiseerde winkels',
  },
  {
    code: '47750',
    nl: 'Detailhandel in cosmetica en toiletartikelen in gespecialiseerde winkels',
    fr: 'Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé',
    en: 'Detailhandel in cosmetica en toiletartikelen in gespecialiseerde winkels',
  },
  {
    code: '47761',
    nl: 'Detailhandel in bloemen, planten, zaden en kunstmeststoffen in gespecialiseerde winkels',
    fr: "Commerce de détail de fleurs, de plantes, de graines et d'engrais en magasin spécialisé",
    en: 'Detailhandel in bloemen, planten, zaden en kunstmeststoffen in gespecialiseerde winkels',
  },
  {
    code: '47762',
    nl: 'Detailhandel in huisdieren, voedsel voor huisdieren en benodigdheden daarvoor in gespecialiseerde winkels',
    fr: "Commerce de détail d'animaux de compagnie, d'aliments et d'accessoires pour ces animaux en magasin spécialisé",
    en: 'Detailhandel in huisdieren, voedsel voor huisdieren en benodigdheden daarvoor in gespecialiseerde winkels',
  },
  {
    code: '47770',
    nl: 'Detailhandel in uurwerken en sieraden in gespecialiseerde winkels',
    fr: "Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé",
    en: 'Detailhandel in uurwerken en sieraden in gespecialiseerde winkels',
  },
  {
    code: '47781',
    nl: 'Detailhandel in vaste, vloeibare en gasvormige brandstoffen in gespecialiseerde winkels, m.u.v. motorbrandstoffen',
    fr: "Commerce de détail de combustibles en magasin spécialisé, à l'exclusion des carburants automobiles",
    en: 'Detailhandel in vaste, vloeibare en gasvormige brandstoffen in gespecialiseerde winkels, m.u.v. motorbrandstoffen',
  },
  {
    code: '47782',
    nl: 'Detailhandel in fotografische en optische artikelen en in precisieinstrumenten in gespecialiseerde winkels',
    fr: "Commerce de détail de matériel photographique, d'optique et de précision en magasin spécialisé",
    en: 'Detailhandel in fotografische en optische artikelen en in precisieinstrumenten in gespecialiseerde winkels',
  },
  {
    code: '47783',
    nl: 'Detailhandel in wapens en munitie in gespecialiseerde winkels',
    fr: "Commerce de détail d'armes et de munitions en magasin spécialisé",
    en: 'Detailhandel in wapens en munitie in gespecialiseerde winkels',
  },
  {
    code: '47784',
    nl: 'Detailhandel in drogisterijartikelen en onderhoudsproducten in gespecialiseerde winkels',
    fr: "Commerce de détail d'articles de droguerie et de produits d'entretien en magasin spécialisé",
    en: 'Detailhandel in drogisterijartikelen en onderhoudsproducten in gespecialiseerde winkels',
  },
  {
    code: '47785',
    nl: 'Detailhandel in fietsen in gespecialiseerde winkels',
    fr: 'Commerce de détail de cycles en magasin spécialisé',
    en: 'Detailhandel in fietsen in gespecialiseerde winkels',
  },
  {
    code: '47786',
    nl: 'Detailhandel in souvenirs en religieuze artikelen in gespecialiseerde winkels',
    fr: "Commerce de détail de souvenirs et d'articles religieux en magasin spécialisé",
    en: 'Detailhandel in souvenirs en religieuze artikelen in gespecialiseerde winkels',
  },
  {
    code: '47787',
    nl: 'Detailhandel in nieuwe kunstvoorwerpen in gespecialiseerde winkels',
    fr: "Commerce de détail d'objets d'art neufs en magasin spécialisé",
    en: 'Detailhandel in nieuwe kunstvoorwerpen in gespecialiseerde winkels',
  },
  {
    code: '47788',
    nl: 'Detailhandel in babyartikelen (algemeen assortiment)',
    fr: "Commerce de détail d'articles de puériculture en magasin spécialisé, assortiment général",
    en: 'Detailhandel in babyartikelen (algemeen assortiment)',
  },
  {
    code: '47789',
    nl: 'Overige detailhandel in nieuwe artikelen in gespecialiseerde winkels, n.e.g.',
    fr: 'Autre commerce de détail de biens neufs en magasin spécialisé n.c.a.',
    en: 'Overige detailhandel in nieuwe artikelen in gespecialiseerde winkels, n.e.g.',
  },
  {
    code: '47791',
    nl: 'Detailhandel in antiquiteiten in winkels',
    fr: "Commerce de détail d'antiquités en magasin",
    en: 'Detailhandel in antiquiteiten in winkels',
  },
  {
    code: '47792',
    nl: 'Detailhandel in tweedehandskleding in winkels',
    fr: "Commerce de détail de vêtements d'occasion en magasin",
    en: 'Detailhandel in tweedehandskleding in winkels',
  },
  {
    code: '47793',
    nl: 'Detailhandel in andere tweedehandsgoederen in winkels, m.u.v. tweedehandskleding',
    fr: "Commerce de détail de biens d'occasion en magasin, sauf vêtements d'occasion",
    en: 'Detailhandel in andere tweedehandsgoederen in winkels, m.u.v. tweedehandskleding',
  },
  {
    code: '47810',
    nl: 'Markt- en straathandel in voedings- en genotmiddelen',
    fr: 'Commerce de détail alimentaire sur éventaires et marchés',
    en: 'Markt- en straathandel in voedings- en genotmiddelen',
  },
  {
    code: '47820',
    nl: 'Markt- en straathandel in textiel, kleding en schoeisel',
    fr: "Commerce de détail de textiles, d'habillement et de chaussures sur éventaires et marchés",
    en: 'Markt- en straathandel in textiel, kleding en schoeisel',
  },
  {
    code: '47890',
    nl: 'Markt- en straathandel in andere artikelen',
    fr: 'Autres commerces de détail sur éventaires et marchés',
    en: 'Markt- en straathandel in andere artikelen',
  },
  {
    code: '47910',
    nl: 'Detailhandel via postorderbedrijven of via internet',
    fr: 'Commerce de détail par correspondance ou par Internet',
    en: 'Detailhandel via postorderbedrijven of via internet',
  },
  {
    code: '47990',
    nl: 'Overige detailhandel, niet in winkels en exclusief markt- en straathandel',
    fr: 'Autres commerces de détail hors magasin, éventaires ou marchés',
    en: 'Overige detailhandel, niet in winkels en exclusief markt- en straathandel',
  },
  {
    code: '49100',
    nl: 'Personenvervoer per spoor, m.u.v. personenvervoer per spoor binnen steden of voorsteden',
    fr: "Transport ferroviaire de voyageurs autre qu'urbain et suburbain",
    en: 'Personenvervoer per spoor, m.u.v. personenvervoer per spoor binnen steden of voorsteden',
  },
  {
    code: '49200',
    nl: 'Goederenvervoer per spoor',
    fr: 'Transports ferroviaires de fret',
    en: 'Goederenvervoer per spoor',
  },
  {
    code: '49310',
    nl: 'Personenvervoer te land binnen steden of voorsteden',
    fr: 'Transports urbains et suburbains de voyageurs',
    en: 'Personenvervoer te land binnen steden of voorsteden',
  },
  {
    code: '49320',
    nl: "Exploitatie van taxi's",
    fr: 'Transports de voyageurs par taxis',
    en: "Exploitatie van taxi's",
  },
  {
    code: '49390',
    nl: 'Overig personenvervoer te land, n.e.g.',
    fr: 'Autres transports terrestres de voyageurs n.c.a.',
    en: 'Overig personenvervoer te land, n.e.g.',
  },
  {
    code: '49410',
    nl: 'Goederenvervoer over de weg, m.u.v. verhuisbedrijven',
    fr: 'Transports routiers de fret, sauf services de déménagement',
    en: 'Goederenvervoer over de weg, m.u.v. verhuisbedrijven',
  },
  {
    code: '49420',
    nl: 'Verhuisbedrijven',
    fr: 'Services de déménagement',
    en: 'Verhuisbedrijven',
  },
  {
    code: '49500',
    nl: 'Vervoer via pijpleidingen',
    fr: 'Transports par conduites',
    en: 'Vervoer via pijpleidingen',
  },
  {
    code: '50100',
    nl: 'Personenvervoer over zee- en kustwateren',
    fr: 'Transports maritimes et côtiers de passagers',
    en: 'Personenvervoer over zee- en kustwateren',
  },
  {
    code: '50200',
    nl: 'Goederenvervoer over zee- en kustwateren',
    fr: 'Transports maritimes et côtiers de fret',
    en: 'Goederenvervoer over zee- en kustwateren',
  },
  {
    code: '50300',
    nl: 'Personenvervoer over binnenwateren',
    fr: 'Transports fluviaux de passagers',
    en: 'Personenvervoer over binnenwateren',
  },
  {
    code: '50400',
    nl: 'Goederenvervoer over binnenwateren',
    fr: 'Transports fluviaux de fret',
    en: 'Goederenvervoer over binnenwateren',
  },
  {
    code: '51100',
    nl: 'Personenvervoer door de lucht',
    fr: 'Transports aériens de passagers',
    en: 'Personenvervoer door de lucht',
  },
  {
    code: '51210',
    nl: 'Goederenvervoer door de lucht',
    fr: 'Transports aériens de fret',
    en: 'Goederenvervoer door de lucht',
  },
  {
    code: '51220',
    nl: 'Ruimtevaart',
    fr: 'Transports spatiaux',
    en: 'Ruimtevaart',
  },
  {
    code: '52100',
    nl: 'Opslag in koelpakhuizen en overige opslag',
    fr: 'Entreposage et stockage, y compris frigorifique',
    en: 'Opslag in koelpakhuizen en overige opslag',
  },
  {
    code: '52210',
    nl: 'Diensten in verband met vervoer te land',
    fr: 'Services auxiliaires des transports terrestres',
    en: 'Diensten in verband met vervoer te land',
  },
  {
    code: '52220',
    nl: 'Diensten in verband met vervoer over water',
    fr: 'Services auxiliaires des transports par eau',
    en: 'Diensten in verband met vervoer over water',
  },
  {
    code: '52230',
    nl: 'Diensten in verband met de luchtvaart',
    fr: 'Services auxiliaires des transports aériens',
    en: 'Diensten in verband met de luchtvaart',
  },
  {
    code: '52241',
    nl: 'Vrachtbehandeling in zeehavens',
    fr: 'Manutention portuaire',
    en: 'Vrachtbehandeling in zeehavens',
  },
  {
    code: '52249',
    nl: 'Overige vrachtbehandeling, exclusief in zeehavens',
    fr: 'Manutention autre que portuaire',
    en: 'Overige vrachtbehandeling, exclusief in zeehavens',
  },
  {
    code: '52290',
    nl: 'Overige vervoerondersteunende activiteiten',
    fr: 'Autres services auxiliaires des transports',
    en: 'Overige vervoerondersteunende activiteiten',
  },
  {
    code: '53100',
    nl: 'Postdiensten in het kader van de universele dienstverplichting',
    fr: "Activités de poste dans le cadre d'une obligation de service universel",
    en: 'Postdiensten in het kader van de universele dienstverplichting',
  },
  {
    code: '53200',
    nl: 'Overige posterijen en koeriers',
    fr: 'Autres activités de poste et de courrier',
    en: 'Overige posterijen en koeriers',
  },
  {
    code: '55100',
    nl: 'Hotels en dergelijke accommodatie',
    fr: 'Hôtels et hébergement similaire',
    en: 'Hotels en dergelijke accommodatie',
  },
  {
    code: '55201',
    nl: 'Jeugdherbergen en jeugdverblijfcentra',
    fr: 'Auberges pour jeunes',
    en: 'Jeugdherbergen en jeugdverblijfcentra',
  },
  {
    code: '55202',
    nl: 'Vakantieparken',
    fr: 'Centres et villages de vacances',
    en: 'Vakantieparken',
  },
  {
    code: '55203',
    nl: 'Gites, vakantiewoningen en -appartementen',
    fr: 'Gîtes de vacances, appartements et meublés de vacances',
    en: 'Gites, vakantiewoningen en -appartementen',
  },
  {
    code: '55204',
    nl: 'Gastenkamers',
    fr: "Chambres d'hôtes",
    en: 'Gastenkamers',
  },
  {
    code: '55209',
    nl: 'Vakantieverblijven en andere accommodatie voor kort verblijf, n.e.g.',
    fr: 'Hébergement touristique et autre hébergement de courte durée n.c.a.',
    en: 'Vakantieverblijven en andere accommodatie voor kort verblijf, n.e.g.',
  },
  {
    code: '55300',
    nl: 'Kampeerterreinen en kampeerauto- en caravanterreinen',
    fr: 'Terrains de camping et parcs pour caravanes ou véhicules de loisirs',
    en: 'Kampeerterreinen en kampeerauto- en caravanterreinen',
  },
  {
    code: '55900',
    nl: 'Overige accommodatie',
    fr: 'Autres hébergements',
    en: 'Overige accommodatie',
  },
  {
    code: '56101',
    nl: 'Eetgelegenheden met volledige bediening',
    fr: 'Restauration à service complet',
    en: 'Eetgelegenheden met volledige bediening',
  },
  {
    code: '56102',
    nl: 'Eetgelegenheden met beperkte bediening',
    fr: 'Restauration à service restreint',
    en: 'Eetgelegenheden met beperkte bediening',
  },
  {
    code: '56210',
    nl: 'Catering',
    fr: 'Services des traiteurs',
    en: 'Catering',
  },
  {
    code: '56290',
    nl: 'Overige eetgelegenheden',
    fr: 'Autres services de restauration',
    en: 'Overige eetgelegenheden',
  },
  {
    code: '56301',
    nl: 'Cafés en bars',
    fr: 'Cafés et bars',
    en: 'Cafés en bars',
  },
  {
    code: '56302',
    nl: 'Discotheken, dancings en dergelijke',
    fr: 'Discothèques, dancings et similaires',
    en: 'Discotheken, dancings en dergelijke',
  },
  {
    code: '56309',
    nl: 'Andere drinkgelegenheden',
    fr: 'Autres débits de boissons',
    en: 'Andere drinkgelegenheden',
  },
  {
    code: '58110',
    nl: 'Uitgeverijen van boeken',
    fr: 'Édition de livres',
    en: 'Uitgeverijen van boeken',
  },
  {
    code: '58120',
    nl: 'Uitgeverijen van adresboeken en mailinglijsten',
    fr: "Édition de répertoires et de fichiers d'adresses",
    en: 'Uitgeverijen van adresboeken en mailinglijsten',
  },
  {
    code: '58130',
    nl: 'Uitgeverijen van kranten',
    fr: 'Édition de journaux',
    en: 'Uitgeverijen van kranten',
  },
  {
    code: '58140',
    nl: 'Uitgeverijen van tijdschriften',
    fr: 'Édition de revues et de périodiques',
    en: 'Uitgeverijen van tijdschriften',
  },
  {
    code: '58190',
    nl: 'Overige uitgeverijen',
    fr: "Autres activités d'édition",
    en: 'Overige uitgeverijen',
  },
  {
    code: '58210',
    nl: 'Uitgeverijen van computerspellen',
    fr: 'Édition de jeux électroniques',
    en: 'Uitgeverijen van computerspellen',
  },
  {
    code: '58290',
    nl: 'Overige uitgeverijen van software',
    fr: "Édition d'autres logiciels",
    en: 'Overige uitgeverijen van software',
  },
  {
    code: '59111',
    nl: 'Productie van bioscoopfilms',
    fr: 'Production de films cinématographiques',
    en: 'Productie van bioscoopfilms',
  },
  {
    code: '59112',
    nl: 'Productie van televisiefilms',
    fr: 'Production de films pour la télévision',
    en: 'Productie van televisiefilms',
  },
  {
    code: '59113',
    nl: 'Productie van films, m.u.v. bioscoop- en televisiefilms',
    fr: 'Production de films autres que cinématographiques et pour la télévision',
    en: 'Productie van films, m.u.v. bioscoop- en televisiefilms',
  },
  {
    code: '59114',
    nl: "Productie van televisieprogramma's",
    fr: 'Production de programmes pour la télévision',
    en: "Productie van televisieprogramma's",
  },
  {
    code: '59120',
    nl: "Activiteiten in verband met films en video- en televisieprogramma's na de productie",
    fr: 'Post-production de films cinématographiques, de vidéo et de programmes de télévision',
    en: "Activiteiten in verband met films en video- en televisieprogramma's na de productie",
  },
  {
    code: '59130',
    nl: "Distributie van films en video- en televisieprogramma's",
    fr: 'Distribution de films cinématographiques, de vidéo et de programmes de télévision',
    en: "Distributie van films en video- en televisieprogramma's",
  },
  {
    code: '59140',
    nl: 'Vertoning van films',
    fr: 'Projection de films cinématographiques',
    en: 'Vertoning van films',
  },
  {
    code: '59201',
    nl: 'Maken van geluidsopnamen',
    fr: "Production d'enregistrements sonores",
    en: 'Maken van geluidsopnamen',
  },
  {
    code: '59202',
    nl: "Geluidsopnamestudio's",
    fr: "Studios d'enregistrements sonores",
    en: "Geluidsopnamestudio's",
  },
  {
    code: '59203',
    nl: 'Uitgeverijen van muziekopnamen',
    fr: 'Edition musicale',
    en: 'Uitgeverijen van muziekopnamen',
  },
  {
    code: '59209',
    nl: 'Overige diensten in verband met het maken van geluidsopnamen',
    fr: "Autres services d'enregistrements sonores",
    en: 'Overige diensten in verband met het maken van geluidsopnamen',
  },
  {
    code: '60100',
    nl: "Uitzenden van radioprogramma's",
    fr: 'Diffusion de programmes radio',
    en: "Uitzenden van radioprogramma's",
  },
  {
    code: '60200',
    nl: "Programmeren en uitzenden van televisieprogramma's",
    fr: 'Programmation de télévision et télédiffusion',
    en: "Programmeren en uitzenden van televisieprogramma's",
  },
  {
    code: '61100',
    nl: 'Draadgebonden telecommunicatie',
    fr: 'Télécommunications filaires',
    en: 'Draadgebonden telecommunicatie',
  },
  {
    code: '61200',
    nl: 'Draadloze telecommunicatie',
    fr: 'Télécommunications sans fil',
    en: 'Draadloze telecommunicatie',
  },
  {
    code: '61300',
    nl: 'Telecommunicatie via satelliet',
    fr: 'Télécommunications par satellite',
    en: 'Telecommunicatie via satelliet',
  },
  {
    code: '61900',
    nl: 'Overige telecommunicatie',
    fr: 'Autres activités de télécommunication',
    en: 'Overige telecommunicatie',
  },
  {
    code: '62010',
    nl: "Ontwerpen en programmeren van computerprogramma's",
    fr: 'Programmation informatique',
    en: "Ontwerpen en programmeren van computerprogramma's",
  },
  {
    code: '62020',
    nl: 'Computerconsultancy-activiteiten',
    fr: 'Conseil informatique',
    en: 'Computerconsultancy-activiteiten',
  },
  {
    code: '62030',
    nl: 'Beheer van computerfaciliteiten',
    fr: "Gestion d'installations informatiques",
    en: 'Beheer van computerfaciliteiten',
  },
  {
    code: '62090',
    nl: 'Overige diensten op het gebied van informatietechnologie en computer',
    fr: 'Autres activités informatiques',
    en: 'Overige diensten op het gebied van informatietechnologie en computer',
  },
  {
    code: '63110',
    nl: 'Gegevensverwerking, webhosting en aanverwante activiteiten',
    fr: 'Traitement de données, hébergement et activités connexes',
    en: 'Gegevensverwerking, webhosting en aanverwante activiteiten',
  },
  {
    code: '63120',
    nl: 'Webportalen',
    fr: 'Portails Internet',
    en: 'Webportalen',
  },
  {
    code: '63910',
    nl: 'Persagentschappen',
    fr: 'Activités des agences de presse',
    en: 'Persagentschappen',
  },
  {
    code: '63990',
    nl: 'Overige dienstverlenende activiteiten op het gebied van informatie, n.e. g.',
    fr: "Autres services d'information n.c.a.",
    en: 'Overige dienstverlenende activiteiten op het gebied van informatie, n.e. g.',
  },
  {
    code: '64110',
    nl: 'Centrale banken',
    fr: 'Activités de banque centrale',
    en: 'Centrale banken',
  },
  {
    code: '64190',
    nl: 'Overige geldscheppende financiële instellingen',
    fr: 'Autres intermédiations monétaires',
    en: 'Overige geldscheppende financiële instellingen',
  },
  {
    code: '64200',
    nl: 'Holdings',
    fr: 'Activités des sociétés holding',
    en: 'Holdings',
  },
  {
    code: '64300',
    nl: 'Beleggingstrusts en -fondsen en vergelijkbare financiële instellingen',
    fr: 'Fonds de placement et entités financières similaires',
    en: 'Beleggingstrusts en -fondsen en vergelijkbare financiële instellingen',
  },
  {
    code: '64910',
    nl: 'Financiële lease',
    fr: 'Crédit-bail',
    en: 'Financiële lease',
  },
  {
    code: '64921',
    nl: 'Verstrekken van verbruikskrediet',
    fr: 'Octroi de crédit à la consommation',
    en: 'Verstrekken van verbruikskrediet',
  },
  {
    code: '64922',
    nl: 'Verstrekken van hypothecair krediet',
    fr: 'Octroi de crédit hypothécaire',
    en: 'Verstrekken van hypothecair krediet',
  },
  {
    code: '64929',
    nl: 'Overige kredietvertsrekking, n.e.g.',
    fr: 'Autre distribution de crédit n.c.a.',
    en: 'Overige kredietvertsrekking, n.e.g.',
  },
  {
    code: '64991',
    nl: 'Factoring',
    fr: "Activités d'affacturage (Factoring)",
    en: 'Factoring',
  },
  {
    code: '64992',
    nl: 'Activiteiten van beursvennootschappen',
    fr: 'Activités des sociétés de bourse',
    en: 'Activiteiten van beursvennootschappen',
  },
  {
    code: '64999',
    nl: 'Overige financiële dienstverlening',
    fr: 'Autres activités des services financiers',
    en: 'Overige financiële dienstverlening',
  },
  {
    code: '65111',
    nl: 'Rechtstreekse verzekeringsverrichtingen leven',
    fr: "Opérations directes d'assurance vie",
    en: 'Rechtstreekse verzekeringsverrichtingen leven',
  },
  {
    code: '65112',
    nl: 'Activiteiten van gemengde verzekeringsondernemingen, overwegend leven',
    fr: "Activités des entreprises d'assurances multibranches à prédominance vie",
    en: 'Activiteiten van gemengde verzekeringsondernemingen, overwegend leven',
  },
  {
    code: '65121',
    nl: 'Rechtstreekse verzekeringsverrichtingen niet-leven',
    fr: "Opérations directes d'assurance non-vie",
    en: 'Rechtstreekse verzekeringsverrichtingen niet-leven',
  },
  {
    code: '65122',
    nl: 'Activiteiten van gemengde verzekeringsondernemingen, overwegend niet-leven',
    fr: "Activités des entreprises d'assurances multibranches à prédominance non-vie",
    en: 'Activiteiten van gemengde verzekeringsondernemingen, overwegend niet-leven',
  },
  {
    code: '65200',
    nl: 'Herverzekeringen',
    fr: 'Réassurance',
    en: 'Herverzekeringen',
  },
  {
    code: '65300',
    nl: 'Pensioenfondsen',
    fr: 'Caisses de retraite',
    en: 'Pensioenfondsen',
  },
  {
    code: '66110',
    nl: 'Beheer van financiële markten',
    fr: 'Administration de marchés financiers',
    en: 'Beheer van financiële markten',
  },
  {
    code: '66120',
    nl: 'Effecten- en goederenhandel',
    fr: 'Courtage de valeurs mobilières et de marchandises',
    en: 'Effecten- en goederenhandel',
  },
  {
    code: '66191',
    nl: 'Agenten en makelaars in bankdiensten',
    fr: 'Activités des agents et courtiers en services bancaires',
    en: 'Agenten en makelaars in bankdiensten',
  },
  {
    code: '66199',
    nl: 'Overige ondersteunende activiteiten in verband met financiële diensten, exclusief verzekeringen en pensioenfondsen, n.e.g.',
    fr: 'Autres activités auxiliaires de services financiers n.c.a., hors assurance et caisses de retraite',
    en: 'Overige ondersteunende activiteiten in verband met financiële diensten, exclusief verzekeringen en pensioenfondsen, n.e.g.',
  },
  {
    code: '66210',
    nl: 'Risicoanalisten en schadetaxateurs',
    fr: 'Évaluation des risques et dommages',
    en: 'Risicoanalisten en schadetaxateurs',
  },
  {
    code: '66220',
    nl: 'Verzekeringsagenten en -makelaars',
    fr: "Activités des agents et courtiers d'assurances",
    en: 'Verzekeringsagenten en -makelaars',
  },
  {
    code: '66290',
    nl: 'Overige ondersteunende activiteiten in verband met verzekeringen en pensioenfondsen',
    fr: "Autres activités auxiliaires d'assurance et de caisses de retraite",
    en: 'Overige ondersteunende activiteiten in verband met verzekeringen en pensioenfondsen',
  },
  {
    code: '66300',
    nl: 'Vermogensbeheer',
    fr: 'Gestion de fonds',
    en: 'Vermogensbeheer',
  },
  {
    code: '68100',
    nl: 'Handel in eigen onroerend goed',
    fr: 'Activités des marchands de biens immobiliers',
    en: 'Handel in eigen onroerend goed',
  },
  {
    code: '68201',
    nl: 'Verhuur en exploitatie van eigen of geleasd residentieel onroerend goed, exclusief sociale woningen',
    fr: 'Location et exploitation de biens immobiliers résidentiels propres ou loués, sauf logements sociaux',
    en: 'Verhuur en exploitatie van eigen of geleasd residentieel onroerend goed, exclusief sociale woningen',
  },
  {
    code: '68202',
    nl: 'Verhuur en exploitatie van sociale woningen',
    fr: 'Location et exploitation de logements sociaux',
    en: 'Verhuur en exploitatie van sociale woningen',
  },
  {
    code: '68203',
    nl: 'Verhuur en exploitatie van eigen of geleasd niet-residentieel onroerend goed, exclusief terreinen',
    fr: 'Location et exploitation de biens immobiliers non résidentiels propres ou loués, sauf terrains',
    en: 'Verhuur en exploitatie van eigen of geleasd niet-residentieel onroerend goed, exclusief terreinen',
  },
  {
    code: '68204',
    nl: 'Verhuur en exploitatie van terreinen',
    fr: 'Location et exploitation de terrains',
    en: 'Verhuur en exploitatie van terreinen',
  },
  {
    code: '68311',
    nl: 'Bemiddeling bij de aankoop, verkoop en verhuur van onroerend goed voor een vast bedrag of op contractbasis',
    fr: 'Intermédiation en achat, vente et location de biens immobiliers pour compte de tiers',
    en: 'Bemiddeling bij de aankoop, verkoop en verhuur van onroerend goed voor een vast bedrag of op contractbasis',
  },
  {
    code: '68312',
    nl: 'Schatten en evalueren van onroerend goed voor een vast bedrag of op contractbasis',
    fr: 'Estimation et évaluation de biens immobiliers pour compte de tiers',
    en: 'Schatten en evalueren van onroerend goed voor een vast bedrag of op contractbasis',
  },
  {
    code: '68321',
    nl: 'Beheer van residentieel onroerend goed voor een vast bedrag of op contractbasis',
    fr: 'Administration de biens immobiliers résidentiels pour compte de tiers',
    en: 'Beheer van residentieel onroerend goed voor een vast bedrag of op contractbasis',
  },
  {
    code: '68322',
    nl: 'Beheer van niet-residentieel onroerend goed voor een vast bedrag of op contractbasis',
    fr: 'Administration de biens immobiliers non résidentiels pour compte de tiers',
    en: 'Beheer van niet-residentieel onroerend goed voor een vast bedrag of op contractbasis',
  },
  {
    code: '69101',
    nl: 'Activiteiten van advocaten',
    fr: 'Activités des avocats',
    en: 'Activiteiten van advocaten',
  },
  {
    code: '69102',
    nl: 'Activiteiten van notarissen',
    fr: 'Activités des notaires',
    en: 'Activiteiten van notarissen',
  },
  {
    code: '69103',
    nl: 'Activiteiten van deurwaarders',
    fr: 'Activités des huissiers de justice',
    en: 'Activiteiten van deurwaarders',
  },
  {
    code: '69109',
    nl: 'Overige rechtskundige dienstverlening',
    fr: 'Autres activités juridiques',
    en: 'Overige rechtskundige dienstverlening',
  },
  {
    code: '69201',
    nl: 'Accountants en belastingconsulenten',
    fr: 'Activités des experts-comptables et des conseils fiscaux',
    en: 'Accountants en belastingconsulenten',
  },
  {
    code: '69202',
    nl: 'Boekhouders en boekhouders-fiscalisten',
    fr: 'Activités des comptables et des comptables-fiscalistes',
    en: 'Boekhouders en boekhouders-fiscalisten',
  },
  {
    code: '69203',
    nl: 'Bedrijfsrevisoren',
    fr: "Activités des réviseurs d'entreprises",
    en: 'Bedrijfsrevisoren',
  },
  {
    code: '70100',
    nl: 'Activiteiten van hoofdkantoren',
    fr: 'Activités des sièges sociaux',
    en: 'Activiteiten van hoofdkantoren',
  },
  {
    code: '70210',
    nl: 'Adviesbureaus op het gebied van public relations en communicatie',
    fr: 'Conseil en relations publiques et en communication',
    en: 'Adviesbureaus op het gebied van public relations en communicatie',
  },
  {
    code: '70220',
    nl: 'Overige adviesbureaus op het gebied van bedrijfsbeheer; adviesbureaus op het gebied van bedrijfsvoering',
    fr: 'Conseil pour les affaires et autres conseils de gestion',
    en: 'Overige adviesbureaus op het gebied van bedrijfsbeheer; adviesbureaus op het gebied van bedrijfsvoering',
  },
  {
    code: '71111',
    nl: 'Bouwarchitecten',
    fr: "Activités d'architecture de construction",
    en: 'Bouwarchitecten',
  },
  {
    code: '71112',
    nl: 'Interieurarchitecten',
    fr: "Activités d'architecture d'intérieur",
    en: 'Interieurarchitecten',
  },
  {
    code: '71113',
    nl: 'Stedebouwkundige en tuin- en landschapsarchitecten',
    fr: "Activités d'architecture d'urbanisme, de paysage et de jardin",
    en: 'Stedebouwkundige en tuin- en landschapsarchitecten',
  },
  {
    code: '71121',
    nl: 'Ingenieurs en aanverwante technische adviseurs, exclusief landmeters',
    fr: "Activités d'ingénierie et de conseils techniques, sauf activités des géomètres",
    en: 'Ingenieurs en aanverwante technische adviseurs, exclusief landmeters',
  },
  {
    code: '71122',
    nl: 'Landmeters',
    fr: 'Activités des géomètres',
    en: 'Landmeters',
  },
  {
    code: '71201',
    nl: 'Technische controle van motorvoertuigen',
    fr: 'Contrôle technique des véhicules automobiles',
    en: 'Technische controle van motorvoertuigen',
  },
  {
    code: '71209',
    nl: 'Overige technische testen en toetsen',
    fr: 'Autres activités de contrôle et analyses techniques',
    en: 'Overige technische testen en toetsen',
  },
  {
    code: '72110',
    nl: 'Speur- en ontwikkelingswerk op biotechnologisch gebied',
    fr: 'Recherche-développement en biotechnologie',
    en: 'Speur- en ontwikkelingswerk op biotechnologisch gebied',
  },
  {
    code: '72190',
    nl: 'Overig speur- en ontwikkelingswerk op natuurwetenschappelijk gebied',
    fr: 'Recherche-développement en autres sciences physiques et naturelles',
    en: 'Overig speur- en ontwikkelingswerk op natuurwetenschappelijk gebied',
  },
  {
    code: '72200',
    nl: 'Speur- en ontwikkelingswerk op het gebied van de maatschappij- en geesteswetenschappen',
    fr: 'Recherche-développement en sciences humaines et sociales',
    en: 'Speur- en ontwikkelingswerk op het gebied van de maatschappij- en geesteswetenschappen',
  },
  {
    code: '73110',
    nl: 'Reclamebureaus',
    fr: 'Activités des agences de publicité',
    en: 'Reclamebureaus',
  },
  {
    code: '73120',
    nl: 'Mediarepresentatie',
    fr: 'Régie publicitaire de médias',
    en: 'Mediarepresentatie',
  },
  {
    code: '73200',
    nl: 'Markt- en opinieonderzoekbureaus',
    fr: "Études de marché et sondages d'opinion",
    en: 'Markt- en opinieonderzoekbureaus',
  },
  {
    code: '74101',
    nl: 'Ontwerpen van textielpatronen, kleding, juwelen, meubels en decoratieartikelen',
    fr: 'Création de modèles pour les biens personnels et domestiques',
    en: 'Ontwerpen van textielpatronen, kleding, juwelen, meubels en decoratieartikelen',
  },
  {
    code: '74102',
    nl: 'Activiteiten van industriële designers',
    fr: 'Activités de design industriel',
    en: 'Activiteiten van industriële designers',
  },
  {
    code: '74103',
    nl: 'Activiteiten van grafische designers',
    fr: 'Activités de design graphique',
    en: 'Activiteiten van grafische designers',
  },
  {
    code: '74104',
    nl: 'Activiteiten van interieurdecorateurs',
    fr: "Décoration d'intérieur",
    en: 'Activiteiten van interieurdecorateurs',
  },
  {
    code: '74105',
    nl: 'Activiteiten van decorateur-etalagisten',
    fr: "Décoration d'étalage",
    en: 'Activiteiten van decorateur-etalagisten',
  },
  {
    code: '74109',
    nl: 'Overige activiteiten van gespecialiseerde designers',
    fr: 'Autres activités spécialisées de design',
    en: 'Overige activiteiten van gespecialiseerde designers',
  },
  {
    code: '74201',
    nl: 'Activiteiten van fotografen, met uitzondering van persfotografen',
    fr: 'Production photographique, sauf activités des photographes de presse',
    en: 'Activiteiten van fotografen, met uitzondering van persfotografen',
  },
  {
    code: '74202',
    nl: 'Activiteiten van persfotografen',
    fr: 'Activités des photographes de presse',
    en: 'Activiteiten van persfotografen',
  },
  {
    code: '74209',
    nl: 'Overige fotografische activiteiten',
    fr: 'Autres activités photographiques',
    en: 'Overige fotografische activiteiten',
  },
  {
    code: '74300',
    nl: 'Vertalers en tolken',
    fr: 'Traduction et interprétation',
    en: 'Vertalers en tolken',
  },
  {
    code: '74901',
    nl: 'Activiteiten van managers van artiesten, sportlui en overige bekende pesonaliteiten',
    fr: "Activités des agents et représentants d'artistes, de sportifs et d'autres personnalités publiques",
    en: 'Activiteiten van managers van artiesten, sportlui en overige bekende pesonaliteiten',
  },
  {
    code: '74909',
    nl: 'Overige gespecialiseerde wetenschappelijke en technische activiteiten',
    fr: 'Autres activités spécialisées, scientifiques et techniques',
    en: 'Overige gespecialiseerde wetenschappelijke en technische activiteiten',
  },
  {
    code: '75000',
    nl: 'Veterinaire diensten',
    fr: 'Activités vétérinaires',
    en: 'Veterinaire diensten',
  },
  {
    code: '77110',
    nl: "Verhuur en lease van personenauto's en lichte bestelwagens (kleiner dan 3,5 ton)",
    fr: "Location et location-bail d'automobiles et d'autres véhicules automobiles légers (inférieur à 3,5 tonnes)",
    en: "Verhuur en lease van personenauto's en lichte bestelwagens (kleiner dan 3,5 ton)",
  },
  {
    code: '77120',
    nl: 'Verhuur en lease van vrachtwagens en overige motorvoertuigen (groter dan 3,5 ton)',
    fr: "Location et location-bail de camions et d'autres véhicules automobiles lourds (supérieur à 3,5 ton)",
    en: 'Verhuur en lease van vrachtwagens en overige motorvoertuigen (groter dan 3,5 ton)',
  },
  {
    code: '77210',
    nl: 'Verhuur en lease van sport- en recreatieartikelen',
    fr: "Location et location-bail d'articles de loisirs et de sport",
    en: 'Verhuur en lease van sport- en recreatieartikelen',
  },
  {
    code: '77220',
    nl: "Verhuur van videobanden, dvd's en cd's",
    fr: 'Location de vidéocassettes et de disques vidéo',
    en: "Verhuur van videobanden, dvd's en cd's",
  },
  {
    code: '77291',
    nl: 'Verhuur en lease van machines, apparatuur en handgereedschap voor doe-het-zelvers',
    fr: "Location et location-bail de machines-outils, de matériel et d'outils à main pour le bricolage",
    en: 'Verhuur en lease van machines, apparatuur en handgereedschap voor doe-het-zelvers',
  },
  {
    code: '77292',
    nl: 'Verhuur en lease van televisietoestellen en andere audio- en videoapparatuur',
    fr: "Location et location-bail de téléviseurs et d'autres appareils audiovisuels",
    en: 'Verhuur en lease van televisietoestellen en andere audio- en videoapparatuur',
  },
  {
    code: '77293',
    nl: 'Verhuur en lease van vaat- en glaswerk, keuken- en tafelgerei, elektrische huishoudapparaten en andere huishoudelijke benodigdheden',
    fr: 'Location et location-bail de vaisselle, couverts, verrerie, articles pour la cuisine, appareils électriques et électroménagers',
    en: 'Verhuur en lease van vaat- en glaswerk, keuken- en tafelgerei, elektrische huishoudapparaten en andere huishoudelijke benodigdheden',
  },
  {
    code: '77294',
    nl: 'Verhuur en lease van textiel, kleding, sieraden en schoeisel',
    fr: "Location et location-bail de textiles, d'habillement, de bijoux et de chaussures",
    en: 'Verhuur en lease van textiel, kleding, sieraden en schoeisel',
  },
  {
    code: '77295',
    nl: 'Verhuur en lease van medisch en paramedisch materieel',
    fr: 'Location et location-bail de matériel médical et paramédical',
    en: 'Verhuur en lease van medisch en paramedisch materieel',
  },
  {
    code: '77296',
    nl: 'Verhuur en lease van bloemen en planten',
    fr: 'Location et location-bail de fleurs et de plantes',
    en: 'Verhuur en lease van bloemen en planten',
  },
  {
    code: '77299',
    nl: 'Verhuur en lease van andere consumentenartikelen, n.e.g.',
    fr: "Location et location-bail d'autres biens personnels et domestiques n.c.a.",
    en: 'Verhuur en lease van andere consumentenartikelen, n.e.g.',
  },
  {
    code: '77310',
    nl: 'Verhuur en lease van landbouwmachines en -werktuigen',
    fr: "Location et location-bail de machines et d'équipements agricoles",
    en: 'Verhuur en lease van landbouwmachines en -werktuigen',
  },
  {
    code: '77320',
    nl: 'Verhuur en lease van machines en installaties voor de bouwnijverheid en de weg- en waterbouw',
    fr: "Location et location-bail de machines et d'équipements pour la construction",
    en: 'Verhuur en lease van machines en installaties voor de bouwnijverheid en de weg- en waterbouw',
  },
  {
    code: '77330',
    nl: 'Verhuur en lease van kantoormachines, inclusief computers',
    fr: 'Location et location-bail de machines de bureau et de matériel informatique',
    en: 'Verhuur en lease van kantoormachines, inclusief computers',
  },
  {
    code: '77340',
    nl: 'Verhuur en lease van schepen',
    fr: 'Location et location-bail de matériels de transport par eau',
    en: 'Verhuur en lease van schepen',
  },
  {
    code: '77350',
    nl: 'Verhuur en lease van luchtvaartuigen',
    fr: 'Location et location-bail de matériels de transport aérien',
    en: 'Verhuur en lease van luchtvaartuigen',
  },
  {
    code: '77391',
    nl: 'Verhuur en lease van speel-, amusement-, en verkoopautomaten',
    fr: 'Location et location-bail de machines à sous, de machines de jeux et de machines automatiques de vente de produits',
    en: 'Verhuur en lease van speel-, amusement-, en verkoopautomaten',
  },
  {
    code: '77392',
    nl: 'Verhuur en lease van tenten',
    fr: 'Location et location-bail de tentes',
    en: 'Verhuur en lease van tenten',
  },
  {
    code: '77393',
    nl: 'Verhuur en lease van caravans en motorhomes',
    fr: 'Location et location-bail de caravanes et de motorhomes',
    en: 'Verhuur en lease van caravans en motorhomes',
  },
  {
    code: '77394',
    nl: 'Verhuur en lease van woon- en bureelcontainers en dergelijke accommodatie',
    fr: "Location et location-bail de conteneurs à usage d'habitation, de bureau et similaires",
    en: 'Verhuur en lease van woon- en bureelcontainers en dergelijke accommodatie',
  },
  {
    code: '77399',
    nl: 'Verhuur en lease van andere machines en werktuigen en andere materiële goederen',
    fr: "Location et location-bail d'autres machines, équipements et biens matériels",
    en: 'Verhuur en lease van andere machines en werktuigen en andere materiële goederen',
  },
  {
    code: '77400',
    nl: 'Lease van intellectuele eigendom en vergelijkbare producten, met uitzondering van werken onder auteursrecht',
    fr: "Location-bail de propriété intellectuelle et de produits similaires, à l'exception des oeuvres soumises au droit d'auteur",
    en: 'Lease van intellectuele eigendom en vergelijkbare producten, met uitzondering van werken onder auteursrecht',
  },
  {
    code: '78100',
    nl: 'Arbeidsbemiddeling',
    fr: "Activités des agences de placement de main-d'oeuvre",
    en: 'Arbeidsbemiddeling',
  },
  {
    code: '78200',
    nl: 'Uitzendbureaus',
    fr: 'Activités des agences de travail temporaire',
    en: 'Uitzendbureaus',
  },
  {
    code: '78300',
    nl: 'Andere vormen van arbeidsbemiddeling',
    fr: 'Autre mise à disposition de ressources humaines',
    en: 'Andere vormen van arbeidsbemiddeling',
  },
  {
    code: '79110',
    nl: 'Reisbureaus',
    fr: 'Activités des agences de voyage',
    en: 'Reisbureaus',
  },
  {
    code: '79120',
    nl: 'Reisorganisatoren',
    fr: 'Activités des voyagistes',
    en: 'Reisorganisatoren',
  },
  {
    code: '79901',
    nl: 'Toeristische informatiediensten',
    fr: "Services d'information touristique",
    en: 'Toeristische informatiediensten',
  },
  {
    code: '79909',
    nl: 'Overige reserveringsactiviteiten',
    fr: 'Autres services de réservation',
    en: 'Overige reserveringsactiviteiten',
  },
  {
    code: '80100',
    nl: 'Particuliere beveiliging',
    fr: 'Activités de sécurité privée',
    en: 'Particuliere beveiliging',
  },
  {
    code: '80200',
    nl: 'Diensten in verband met beveiligingssystemen',
    fr: 'Activités liées aux systèmes de sécurité',
    en: 'Diensten in verband met beveiligingssystemen',
  },
  {
    code: '80300',
    nl: 'Opsporingsdiensten',
    fr: "Activités d'enquête",
    en: 'Opsporingsdiensten',
  },
  {
    code: '81100',
    nl: 'Diverse ondersteunende activiteiten ten behoeve van voorzieningen',
    fr: 'Activités combinées de soutien lié aux bâtiments',
    en: 'Diverse ondersteunende activiteiten ten behoeve van voorzieningen',
  },
  {
    code: '81210',
    nl: 'Algemene reiniging van gebouwen',
    fr: 'Nettoyage courant des bâtiments',
    en: 'Algemene reiniging van gebouwen',
  },
  {
    code: '81220',
    nl: 'Overige reiniging van gebouwen; industriële reiniging',
    fr: 'Autres activités de nettoyage des bâtiments; nettoyage industriel',
    en: 'Overige reiniging van gebouwen; industriële reiniging',
  },
  {
    code: '81290',
    nl: 'Andere reinigingsactiviteiten',
    fr: 'Autres activités de nettoyage',
    en: 'Andere reinigingsactiviteiten',
  },
  {
    code: '81300',
    nl: 'Landschapsverzorging',
    fr: "Services d'aménagement paysager",
    en: 'Landschapsverzorging',
  },
  {
    code: '82110',
    nl: 'Diverse administratieve activiteiten ten behoeve van kantoren',
    fr: 'Services administratifs combinés de bureau',
    en: 'Diverse administratieve activiteiten ten behoeve van kantoren',
  },
  {
    code: '82190',
    nl: 'Fotokopiëren, documentvoorbereiding en andere gespecialiseerde ondersteunende activiteiten ten behoeve van kantoren',
    fr: 'Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau',
    en: 'Fotokopiëren, documentvoorbereiding en andere gespecialiseerde ondersteunende activiteiten ten behoeve van kantoren',
  },
  {
    code: '82200',
    nl: 'Callcenters',
    fr: "Activités des centres d'appels",
    en: 'Callcenters',
  },
  {
    code: '82300',
    nl: 'Organisatie van congressen en beurzen',
    fr: 'Organisation de salons professionnels et de congrès',
    en: 'Organisatie van congressen en beurzen',
  },
  {
    code: '82910',
    nl: 'Incasso- en kredietbureaus',
    fr: "Activités des agences de recouvrement de factures et des sociétés d'information financière sur la clientèle",
    en: 'Incasso- en kredietbureaus',
  },
  {
    code: '82920',
    nl: 'Verpakkingsbedrijven',
    fr: 'Activités de conditionnement',
    en: 'Verpakkingsbedrijven',
  },
  {
    code: '82990',
    nl: 'Overige zakelijke dienstverlening, n.e.g.',
    fr: 'Autres activités de soutien aux entreprises n.c.a.',
    en: 'Overige zakelijke dienstverlening, n.e.g.',
  },
  {
    code: '84111',
    nl: 'Federale overheid',
    fr: 'Administration publique fédérale',
    en: 'Federale overheid',
  },
  {
    code: '84112',
    nl: 'Overheden van gemeenschappen en gewesten',
    fr: 'Administration publique communautaire et régionale',
    en: 'Overheden van gemeenschappen en gewesten',
  },
  {
    code: '84113',
    nl: 'Provinciale overheid',
    fr: 'Administration publique provinciale',
    en: 'Provinciale overheid',
  },
  {
    code: '84114',
    nl: 'Gemeentelijke overheid, met uitzondering van het O.C.M.W.',
    fr: "Administration publique communale, sauf Centres Publics d'Action Sociale (C.P.A.S.)",
    en: 'Gemeentelijke overheid, met uitzondering van het O.C.M.W.',
  },
  {
    code: '84115',
    nl: 'Openbare Centra voor Maatschappelijk Welzijn (O.C.M.W.)',
    fr: "Centres Publics d'Action Sociale (C.P.A.S.)",
    en: 'Openbare Centra voor Maatschappelijk Welzijn (O.C.M.W.)',
  },
  {
    code: '84119',
    nl: 'Overig algemeen overheidsbestuur',
    fr: 'Autre administration publique générale',
    en: 'Overig algemeen overheidsbestuur',
  },
  {
    code: '84120',
    nl: 'Openbaar bestuur op het gebied van gezondheidszorg, onderwijs, cultuur en andere sociale dienstverlening, m.u.v. sociale verzekeringen',
    fr: "Administration publique (tutelle) de la santé, de la formation, de la culture et des autres services sociaux, à l'exclusion de la sécurité sociale",
    en: 'Openbaar bestuur op het gebied van gezondheidszorg, onderwijs, cultuur en andere sociale dienstverlening, m.u.v. sociale verzekeringen',
  },
  {
    code: '84130',
    nl: 'Openbaar bestuur op het gebied van het bedrijfsleven; stimuleren van het bedrijfsleven',
    fr: 'Administration publique (tutelle) des activités économiques',
    en: 'Openbaar bestuur op het gebied van het bedrijfsleven; stimuleren van het bedrijfsleven',
  },
  {
    code: '84210',
    nl: 'Buitenlandse zaken',
    fr: 'Affaires étrangères',
    en: 'Buitenlandse zaken',
  },
  { code: '84220', nl: 'Defensie', fr: 'Défense', en: 'Defensie' },
  { code: '84231', nl: 'Rechtbanken', fr: 'Tribunaux', en: 'Rechtbanken' },
  {
    code: '84232',
    nl: 'Strafinrichtingen',
    fr: 'Etablissements pénitentiaires',
    en: 'Strafinrichtingen',
  },
  {
    code: '84239',
    nl: 'Overige activiteiten met betrekking tot justitie',
    fr: 'Autres activités relatives à la justice',
    en: 'Overige activiteiten met betrekking tot justitie',
  },
  {
    code: '84241',
    nl: 'Federale Politie',
    fr: 'Police fédérale',
    en: 'Federale Politie',
  },
  {
    code: '84242',
    nl: 'Lokale Politie',
    fr: 'Police locale',
    en: 'Lokale Politie',
  },
  {
    code: '84249',
    nl: 'Overige openbare orde en civiele veiligheid',
    fr: "Autres activités d'ordre public et de sécurité civile",
    en: 'Overige openbare orde en civiele veiligheid',
  },
  { code: '84250', nl: 'Brandweer', fr: 'Services du feu', en: 'Brandweer' },
  {
    code: '84301',
    nl: 'Verplichte sociale verzekeringen, met uitzondering van ziekenfondsen',
    fr: "Sécurité sociale obligatoire, à l'exclusion des mutuelles",
    en: 'Verplichte sociale verzekeringen, met uitzondering van ziekenfondsen',
  },
  {
    code: '84302',
    nl: 'Ziekenfondsen en zorgkassen',
    fr: "Mutuelles et caisses d'assurance soins",
    en: 'Ziekenfondsen en zorgkassen',
  },
  {
    code: '84309',
    nl: 'Overige instellingen van de sociale zekerheid',
    fr: 'Autres organismes de sécurité sociale',
    en: 'Overige instellingen van de sociale zekerheid',
  },
  {
    code: '85101',
    nl: 'Gewoon kleuteronderwijs ingericht door de Gemeenschappen',
    fr: 'Enseignement maternel ordinaire communautaire',
    en: 'Gewoon kleuteronderwijs ingericht door de Gemeenschappen',
  },
  {
    code: '85102',
    nl: 'Provinciaal gesubsidieerd gewoon kleuteronderwijs',
    fr: 'Enseignement maternel ordinaire provincial subventionné',
    en: 'Provinciaal gesubsidieerd gewoon kleuteronderwijs',
  },
  {
    code: '85103',
    nl: 'Gemeentelijk gesubsidieerd gewoon kleuteronderwijs',
    fr: 'Enseignement maternel ordinaire communal subventionné',
    en: 'Gemeentelijk gesubsidieerd gewoon kleuteronderwijs',
  },
  {
    code: '85104',
    nl: 'Vrij gesubsidieerd gewoon kleuteronderwijs',
    fr: 'Enseignement maternel ordinaire libre subventionné',
    en: 'Vrij gesubsidieerd gewoon kleuteronderwijs',
  },
  {
    code: '85105',
    nl: 'Buitengewoon officieel kleuteronderwijs',
    fr: 'Enseignement maternel spécialisé organisé par les pouvoirs publics',
    en: 'Buitengewoon officieel kleuteronderwijs',
  },
  {
    code: '85106',
    nl: 'Vrij gesubsidieerd buitengewoon kleuteronderwijs',
    fr: 'Enseignement maternel spécialisé libre subventionné',
    en: 'Vrij gesubsidieerd buitengewoon kleuteronderwijs',
  },
  {
    code: '85109',
    nl: 'Gewoon kleuteronderwijs, n.e.g.',
    fr: 'Enseignement maternel n.c.a.',
    en: 'Gewoon kleuteronderwijs, n.e.g.',
  },
  {
    code: '85201',
    nl: 'Gewoon lager onderwijs ingericht door de Gemeenschappen',
    fr: 'Enseignement primaire ordinaire communautaire',
    en: 'Gewoon lager onderwijs ingericht door de Gemeenschappen',
  },
  {
    code: '85202',
    nl: 'Provinciaal gesubsidieerd gewoon lager onderwijs',
    fr: 'Enseignement primaire ordinaire provincial subventionné',
    en: 'Provinciaal gesubsidieerd gewoon lager onderwijs',
  },
  {
    code: '85203',
    nl: 'Gemeentelijk gesubsidieerd gewoon lager onderwijs',
    fr: 'Enseignement primaire ordinaire communal subventionné',
    en: 'Gemeentelijk gesubsidieerd gewoon lager onderwijs',
  },
  {
    code: '85204',
    nl: 'Vrij gesubsidieerd gewoon lager onderwijs',
    fr: 'Enseignement primaire ordinaire libre subventionné',
    en: 'Vrij gesubsidieerd gewoon lager onderwijs',
  },
  {
    code: '85205',
    nl: 'Buitengewoon officieel lager onderwijs',
    fr: 'Enseignement primaire spécialisé organisé par les pouvoirs publics',
    en: 'Buitengewoon officieel lager onderwijs',
  },
  {
    code: '85206',
    nl: 'Vrij gesubsidieerd buitengewoon lager onderwijs',
    fr: 'Enseignement primaire spécialisé libre subventionné',
    en: 'Vrij gesubsidieerd buitengewoon lager onderwijs',
  },
  {
    code: '85207',
    nl: "Alfabetiseringsprogramma's ten behoeve van volwassenen",
    fr: 'Alphabétisation des adultes',
    en: "Alfabetiseringsprogramma's ten behoeve van volwassenen",
  },
  {
    code: '85209',
    nl: 'Gewoon lager onderwijs, n.e.g.',
    fr: 'Enseignement primaire ordinaire n.c.a.',
    en: 'Gewoon lager onderwijs, n.e.g.',
  },
  {
    code: '85311',
    nl: 'Gewoon algemeen secundair onderwijs ingericht door de Gemeenschappen',
    fr: 'Enseignement secondaire général ordinaire communautaire',
    en: 'Gewoon algemeen secundair onderwijs ingericht door de Gemeenschappen',
  },
  {
    code: '85312',
    nl: 'Provinciaal gesubsidieerd gewoon algemeen secundair onderwijs',
    fr: 'Enseignement secondaire général ordinaire provincial subventionné',
    en: 'Provinciaal gesubsidieerd gewoon algemeen secundair onderwijs',
  },
  {
    code: '85313',
    nl: 'Gemeentelijk gesubsidieerd gewoon algemeen secundair onderwijs',
    fr: 'Enseignement secondaire général ordinaire communal subventionné',
    en: 'Gemeentelijk gesubsidieerd gewoon algemeen secundair onderwijs',
  },
  {
    code: '85314',
    nl: 'Vrij gesubsidieerd gewoon algemeen secundair onderwijs',
    fr: 'Enseignement secondaire général ordinaire libre subventionné',
    en: 'Vrij gesubsidieerd gewoon algemeen secundair onderwijs',
  },
  {
    code: '85319',
    nl: 'Gewoon algemeen secundair onderwijs, n.e.g.',
    fr: 'Enseignement secondaire ordinaire général n.c.a.',
    en: 'Gewoon algemeen secundair onderwijs, n.e.g.',
  },
  {
    code: '85321',
    nl: 'Gewoon technisch en beroepssecundair onderwijs ingericht door de Gemeenschappen',
    fr: 'Enseignement secondaire technique et professionnel ordinaire communautaire',
    en: 'Gewoon technisch en beroepssecundair onderwijs ingericht door de Gemeenschappen',
  },
  {
    code: '85322',
    nl: 'Provinciaal gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
    fr: 'Enseignement secondaire technique et professionnel ordinaire provincial subventionné',
    en: 'Provinciaal gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
  },
  {
    code: '85323',
    nl: 'Gemeentelijk gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
    fr: 'Enseignement secondaire technique et professionnel ordinaire communal subventionné',
    en: 'Gemeentelijk gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
  },
  {
    code: '85324',
    nl: 'Vrij gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
    fr: 'Enseignement secondaire technique et professionnel ordinaire libre subventionné',
    en: 'Vrij gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
  },
  {
    code: '85325',
    nl: 'Buitengewoon officieel secundair onderwijs',
    fr: 'Enseignement secondaire spécialisé organisé par les pouvoirs publics',
    en: 'Buitengewoon officieel secundair onderwijs',
  },
  {
    code: '85326',
    nl: 'Vrij gesubsidieerd buitengewoon secundair onderwijs',
    fr: 'Enseignement secondaire spécialisé libre subventionné',
    en: 'Vrij gesubsidieerd buitengewoon secundair onderwijs',
  },
  {
    code: '85329',
    nl: 'Technisch, beroeps- en buitengewoon secundair onderwijs, n.e.g.',
    fr: 'Enseignement secondaire technique, professionnel et spécialisé n.c.a.',
    en: 'Technisch, beroeps- en buitengewoon secundair onderwijs, n.e.g.',
  },
  {
    code: '85410',
    nl: 'Post-secundair niet-hoger onderwijs',
    fr: 'Enseignement post-secondaire non supérieur',
    en: 'Post-secundair niet-hoger onderwijs',
  },
  {
    code: '85421',
    nl: 'Officieel hoger onderwijs',
    fr: 'Enseignement supérieur organisé par les pouvoirs publics',
    en: 'Officieel hoger onderwijs',
  },
  {
    code: '85422',
    nl: 'Vrij gesubsidieerd hoger onderwijs',
    fr: 'Enseignement supérieur libre subventionné',
    en: 'Vrij gesubsidieerd hoger onderwijs',
  },
  {
    code: '85429',
    nl: 'Hoger onderwijs, n.e.g.',
    fr: 'Enseignement supérieur n.c.a.',
    en: 'Hoger onderwijs, n.e.g.',
  },
  {
    code: '85510',
    nl: 'Sport- en recreatieonderwijs',
    fr: "Enseignement de disciplines sportives et d'activités de loisirs",
    en: 'Sport- en recreatieonderwijs',
  },
  {
    code: '85520',
    nl: 'Cultureel onderwijs',
    fr: 'Enseignement culturel',
    en: 'Cultureel onderwijs',
  },
  {
    code: '85531',
    nl: 'Autorijscholen',
    fr: 'Enseignement de la conduite de véhicules à moteurs',
    en: 'Autorijscholen',
  },
  {
    code: '85532',
    nl: 'Vlieg- en vaaronderricht',
    fr: "Enseignement de la conduite d'aéronefs et de bateaux",
    en: 'Vlieg- en vaaronderricht',
  },
  {
    code: '85591',
    nl: 'Onderwijs voor sociale promotie',
    fr: 'Enseignement de promotion sociale',
    en: 'Onderwijs voor sociale promotie',
  },
  {
    code: '85592',
    nl: 'Beroepsopleiding',
    fr: 'Formation professionnelle',
    en: 'Beroepsopleiding',
  },
  {
    code: '85593',
    nl: 'Sociaal-cultureel vormingswerk',
    fr: 'Formation socio-culturelle',
    en: 'Sociaal-cultureel vormingswerk',
  },
  {
    code: '85599',
    nl: 'Overige vormen van onderwijs',
    fr: "Autres formes d'enseignement",
    en: 'Overige vormen van onderwijs',
  },
  {
    code: '85601',
    nl: 'Activiteiten van Centra voor Leerlingbegeleiding (C.L.B.)',
    fr: 'Activités des Centres Psycho-Médico-Sociaux (P.M.S.)',
    en: 'Activiteiten van Centra voor Leerlingbegeleiding (C.L.B.)',
  },
  {
    code: '85609',
    nl: 'Overige onderwijsondersteunende dienstverlening',
    fr: "Autres services de soutien à l'enseignement",
    en: 'Overige onderwijsondersteunende dienstverlening',
  },
  {
    code: '86101',
    nl: 'Algemene ziekenhuizen, m.u.v. geriatrische en gespecialiseerde ziekenhuizen',
    fr: 'Activités des hôpitaux généraux, sauf hôpitaux gériatriques et spécialisés',
    en: 'Algemene ziekenhuizen, m.u.v. geriatrische en gespecialiseerde ziekenhuizen',
  },
  {
    code: '86102',
    nl: 'Geriatrische ziekenhuizen',
    fr: 'Activités des hôpitaux gériatriques',
    en: 'Geriatrische ziekenhuizen',
  },
  {
    code: '86103',
    nl: 'Gespecialiseerde ziekenhuizen',
    fr: 'Activités des hôpitaux spécialisés',
    en: 'Gespecialiseerde ziekenhuizen',
  },
  {
    code: '86104',
    nl: 'Psychiatrische ziekenhuizen',
    fr: 'Activités des hôpitaux psychiatriques',
    en: 'Psychiatrische ziekenhuizen',
  },
  {
    code: '86109',
    nl: 'Overige hospitalisatiediensten',
    fr: 'Autres activités hospitalières',
    en: 'Overige hospitalisatiediensten',
  },
  {
    code: '86210',
    nl: 'Huisartspraktijken',
    fr: 'Activités des médecins généralistes',
    en: 'Huisartspraktijken',
  },
  {
    code: '86220',
    nl: 'Praktijken van specialisten',
    fr: 'Activités des médecins spécialistes',
    en: 'Praktijken van specialisten',
  },
  {
    code: '86230',
    nl: 'Tandartspraktijken',
    fr: 'Pratique dentaire',
    en: 'Tandartspraktijken',
  },
  {
    code: '86901',
    nl: 'Activiteiten van medische laboratoria',
    fr: 'Activités des laboratoires médicaux',
    en: 'Activiteiten van medische laboratoria',
  },
  {
    code: '86902',
    nl: 'Activiteiten van bloedtransfusiecentra en bloed- en organenbanken',
    fr: "Activités des centres de collecte de sang, des banques de sang et d'organes",
    en: 'Activiteiten van bloedtransfusiecentra en bloed- en organenbanken',
  },
  {
    code: '86903',
    nl: 'Ziekenvervoer',
    fr: 'Transport par ambulance',
    en: 'Ziekenvervoer',
  },
  {
    code: '86904',
    nl: 'Activiteiten op het vlak van geestelijke gezondheidszorg, m.u.v. psychiatrische ziekenhuizen en verzorgingstehuizen',
    fr: 'Activités relatives à la santé mentale, sauf hôpitaux et maisons de soins psychiatriques',
    en: 'Activiteiten op het vlak van geestelijke gezondheidszorg, m.u.v. psychiatrische ziekenhuizen en verzorgingstehuizen',
  },
  {
    code: '86905',
    nl: 'Ambulante revalidatieactiviteiten',
    fr: 'Activités de revalidation ambulatoire',
    en: 'Ambulante revalidatieactiviteiten',
  },
  {
    code: '86906',
    nl: 'Verpleegkundige activiteiten',
    fr: "Activités des praticiens de l'art infirmier",
    en: 'Verpleegkundige activiteiten',
  },
  {
    code: '86907',
    nl: 'Activiteiten van vroedvrouwen',
    fr: 'Activités des sages-femmes',
    en: 'Activiteiten van vroedvrouwen',
  },
  {
    code: '86909',
    nl: 'Overige menselijke gezondheidszorg, n.e.g.',
    fr: 'Autres activités pour la santé humaine n.c.a.',
    en: 'Overige menselijke gezondheidszorg, n.e.g.',
  },
  {
    code: '87101',
    nl: 'Rust- en verzorgingstehuizen (R.V.T.)',
    fr: 'Activités des maisons de repos et de soins (M.R.S.)',
    en: 'Rust- en verzorgingstehuizen (R.V.T.)',
  },
  {
    code: '87109',
    nl: 'Overige verpleeginstellingen met huisvesting',
    fr: 'Autres activités de soins infirmiers résidentiels',
    en: 'Overige verpleeginstellingen met huisvesting',
  },
  {
    code: '87201',
    nl: 'Instellingen met huisvesting voor minderjarigen met een mentale handicap',
    fr: 'Activités de soins résidentiels pour mineurs avec un handicap mental',
    en: 'Instellingen met huisvesting voor minderjarigen met een mentale handicap',
  },
  {
    code: '87202',
    nl: 'Instellingen met huisvesting voor volwassenen met een mentale handicap',
    fr: 'Activités de soins résidentiels pour adultes avec un handicap mental',
    en: 'Instellingen met huisvesting voor volwassenen met een mentale handicap',
  },
  {
    code: '87203',
    nl: 'Instellingen met huisvesting voor personen met psychiatrische problemen',
    fr: 'Activités de soins résidentiels pour personnes avec un problème psychiatrique',
    en: 'Instellingen met huisvesting voor personen met psychiatrische problemen',
  },
  {
    code: '87204',
    nl: 'Instellingen met huisvesting voor drugs- en alcoholverslaafden',
    fr: 'Activités de soins résidentiels pour personnes toxicodépendantes',
    en: 'Instellingen met huisvesting voor drugs- en alcoholverslaafden',
  },
  {
    code: '87205',
    nl: 'Activiteiten van beschut wonen voor personen met psychiatrische problemen',
    fr: 'Activités des habitations protégées pour personnes avec un problème psychiatrique',
    en: 'Activiteiten van beschut wonen voor personen met psychiatrische problemen',
  },
  {
    code: '87209',
    nl: 'Andere instellingen met huisvesting voor personen met een mentale handicap of psychiatrische problemen en voor drugs- en alcoholverslaafden',
    fr: 'Autres activités de soins résidentiels pour personnes avec un handicap mental, un problème psychiatrique ou toxicodépendantes',
    en: 'Andere instellingen met huisvesting voor personen met een mentale handicap of psychiatrische problemen en voor drugs- en alcoholverslaafden',
  },
  {
    code: '87301',
    nl: 'Rusthuizen voor ouderen (R.O.B.)',
    fr: 'Activités des maisons de repos pour personnes âgées (M.R.P.A.)',
    en: 'Rusthuizen voor ouderen (R.O.B.)',
  },
  {
    code: '87302',
    nl: 'Serviceflats voor ouderen',
    fr: 'Activités des résidences services pour personnes âgées',
    en: 'Serviceflats voor ouderen',
  },
  {
    code: '87303',
    nl: 'Instellingen met huisvesting voor minderjarigen met een lichameijke handicap',
    fr: 'Activités de soins résidentiels pour mineurs avec un handicap moteur',
    en: 'Instellingen met huisvesting voor minderjarigen met een lichameijke handicap',
  },
  {
    code: '87304',
    nl: 'Instellingen met huisvesting voor volwassenen met een lichameijke handicap',
    fr: 'Activités de soins résidentiels pour adultes avec un handicap moteur',
    en: 'Instellingen met huisvesting voor volwassenen met een lichameijke handicap',
  },
  {
    code: '87309',
    nl: 'Instellingen met huisvesting voor ouderen en voor personen met een lichamelijke handicap, n.e.g.',
    fr: 'Autres activités de soins résidentiels pour personnes âgées ou avec un handicap moteur',
    en: 'Instellingen met huisvesting voor ouderen en voor personen met een lichamelijke handicap, n.e.g.',
  },
  {
    code: '87901',
    nl: 'Integrale jeugdhulp met huisvesting',
    fr: "Services d'aide à la jeunesse avec hébergement",
    en: 'Integrale jeugdhulp met huisvesting',
  },
  {
    code: '87902',
    nl: 'Algemeen welzijnswerk met huisvesting',
    fr: 'Services sociaux généraux avec hébergement',
    en: 'Algemeen welzijnswerk met huisvesting',
  },
  {
    code: '87909',
    nl: 'Overige maatschappelijke dienstverlening met huisvesting, n.e.g.',
    fr: 'Autres activités de soins résidentiels n.c.a.',
    en: 'Overige maatschappelijke dienstverlening met huisvesting, n.e.g.',
  },
  {
    code: '88101',
    nl: 'Activiteiten van gezins- en bejaardenzorg aan huis, m.u.v. (thuis)verpleging',
    fr: 'Activités des aides familiales à domicile, sauf soins à domicile',
    en: 'Activiteiten van gezins- en bejaardenzorg aan huis, m.u.v. (thuis)verpleging',
  },
  {
    code: '88102',
    nl: 'Activiteiten van dag- en dienstencentra voor ouderen',
    fr: 'Activités des centres de jour et de services pour personnes âgées',
    en: 'Activiteiten van dag- en dienstencentra voor ouderen',
  },
  {
    code: '88103',
    nl: 'Activiteiten van dagcentra voor minderjarigen met een lichamelijke handicap, met inbegrip van ambulante hulpverlening',
    fr: 'Activités des centres de jour pour mineurs avec un handicap moteur, y compris les services ambulatoires',
    en: 'Activiteiten van dagcentra voor minderjarigen met een lichamelijke handicap, met inbegrip van ambulante hulpverlening',
  },
  {
    code: '88104',
    nl: 'Activiteiten van dagcentra voor volwassenen met een lichamelijke handicap, met inbegrip van ambulante hulpverlening',
    fr: 'Activités des centres de jour pour adultes avec un handicap moteur, y compris les services ambulatoires',
    en: 'Activiteiten van dagcentra voor volwassenen met een lichamelijke handicap, met inbegrip van ambulante hulpverlening',
  },
  {
    code: '88109',
    nl: 'Overige maatschappelijke dienstverlening zonder huisvesting voor ouderen en lichamelijk gehandicapten',
    fr: 'Autre action sociale sans hébergement pour personnes âgées et pour personnes avec un handicap moteur',
    en: 'Overige maatschappelijke dienstverlening zonder huisvesting voor ouderen en lichamelijk gehandicapten',
  },
  {
    code: '88911',
    nl: 'Kinderdagverblijven en crèches',
    fr: "Activités des crèches et des garderies d'enfants",
    en: 'Kinderdagverblijven en crèches',
  },
  {
    code: '88912',
    nl: 'Kinderopvang door onthaalmoeders',
    fr: "Activités des gardiennes d'enfants",
    en: 'Kinderopvang door onthaalmoeders',
  },
  {
    code: '88919',
    nl: 'Overige kinderopvang',
    fr: 'Autre action sociale sans hébergement pour jeunes enfants',
    en: 'Overige kinderopvang',
  },
  {
    code: '88991',
    nl: 'Activiteiten van dagcentra voor minderjarigen met een mentale handicap, met inbegrip van ambulante hulpverlening',
    fr: 'Activités des centres de jour pour mineurs avec un handicap mental, y compris les services ambulatoires',
    en: 'Activiteiten van dagcentra voor minderjarigen met een mentale handicap, met inbegrip van ambulante hulpverlening',
  },
  {
    code: '88992',
    nl: 'Activiteiten van dagcentra voor volwassenen met een mentale handicap, met inbegrip van ambulante hulpverlening',
    fr: 'Activités des centres de jour pour adultes avec un handicap mental, y compris les services ambulatoires',
    en: 'Activiteiten van dagcentra voor volwassenen met een mentale handicap, met inbegrip van ambulante hulpverlening',
  },
  {
    code: '88993',
    nl: 'Ambulante hulpverlening aan drugs- en alcoholverslaafden',
    fr: 'Action sociale ambulatoire pour personnes toxicodépendantes',
    en: 'Ambulante hulpverlening aan drugs- en alcoholverslaafden',
  },
  {
    code: '88994',
    nl: 'Integrale jeugdhulp zonder huisvesting',
    fr: "Services d'aide à la jeunesse sans hébergement",
    en: 'Integrale jeugdhulp zonder huisvesting',
  },
  {
    code: '88995',
    nl: 'Beschutte en sociale werkplaatsen',
    fr: 'Activités des entreprises de travail adapté',
    en: 'Beschutte en sociale werkplaatsen',
  },
  {
    code: '88996',
    nl: 'Algemeen welzijnswerk zonder huisvesting',
    fr: 'Services sociaux généraux sans hébergement',
    en: 'Algemeen welzijnswerk zonder huisvesting',
  },
  {
    code: '88999',
    nl: 'Andere vormen van maatschappelijke dienstverlening zonder huisvesting, n.e.g.',
    fr: "Autres formes d'action sociale sans hébergement n.c.a.",
    en: 'Andere vormen van maatschappelijke dienstverlening zonder huisvesting, n.e.g.',
  },
  {
    code: '90011',
    nl: 'Beoefening van uitvoerende kunsten door zelfstandig werkende artiesten',
    fr: 'Réalisation de spectacles par des artistes indépendants',
    en: 'Beoefening van uitvoerende kunsten door zelfstandig werkende artiesten',
  },
  {
    code: '90012',
    nl: 'Beoefening van uitvoerende kunsten door artistieke ensembles',
    fr: 'Réalisation de spectacles par des ensembles artistiques',
    en: 'Beoefening van uitvoerende kunsten door artistieke ensembles',
  },
  {
    code: '90021',
    nl: 'Promotie en organisatie van uitvoerende kunstevenementen',
    fr: 'Promotion et organisation de spectacles vivants',
    en: 'Promotie en organisatie van uitvoerende kunstevenementen',
  },
  {
    code: '90022',
    nl: 'Ontwerp en bouw van podia',
    fr: 'Conception et réalisation de décors',
    en: 'Ontwerp en bouw van podia',
  },
  {
    code: '90023',
    nl: 'Gespecialiseerde beeld-, verlichtings- en geluidstechnieken',
    fr: "Services spécialisés du son, de l'image et de l'éclairage",
    en: 'Gespecialiseerde beeld-, verlichtings- en geluidstechnieken',
  },
  {
    code: '90029',
    nl: 'Overige ondersteunende activiteiten voor de uitvoerende kunsten',
    fr: 'Autres activités de soutien au spectacle vivant',
    en: 'Overige ondersteunende activiteiten voor de uitvoerende kunsten',
  },
  {
    code: '90031',
    nl: 'Scheppende kunsten, m.u.v. ondersteunende diensten',
    fr: 'Création artistique, sauf activités de soutien',
    en: 'Scheppende kunsten, m.u.v. ondersteunende diensten',
  },
  {
    code: '90032',
    nl: 'Ondersteunende activiteiten voor scheppende kunsten',
    fr: 'Activités de soutien à la création artistique',
    en: 'Ondersteunende activiteiten voor scheppende kunsten',
  },
  {
    code: '90041',
    nl: 'Exploitatie van schouwburgen, concertzalen en dergelijke',
    fr: 'Gestion de salles de théâtre, de concerts et similaires',
    en: 'Exploitatie van schouwburgen, concertzalen en dergelijke',
  },
  {
    code: '90042',
    nl: 'Exploitatie van culturele centra en multifunctionele zalen ten behoeve van culturele activiteiten',
    fr: 'Gestion de centres culturels et de salles multifonctionnelles à vocation culturelle',
    en: 'Exploitatie van culturele centra en multifunctionele zalen ten behoeve van culturele activiteiten',
  },
  {
    code: '91011',
    nl: 'Bibliotheken,mediatheken en ludotheken',
    fr: 'Gestion des bibliothèques, des médiathèques et des ludothèques',
    en: 'Bibliotheken,mediatheken en ludotheken',
  },
  {
    code: '91012',
    nl: 'Openbare archieven',
    fr: 'Gestion des archives publiques',
    en: 'Openbare archieven',
  },
  { code: '91020', nl: 'Musea', fr: 'Gestion des musées', en: 'Musea' },
  {
    code: '91030',
    nl: 'Exploitatie van monumenten en dergelijke toeristenattracties',
    fr: 'Gestion des sites et monuments historiques et des attractions touristiques similaires',
    en: 'Exploitatie van monumenten en dergelijke toeristenattracties',
  },
  {
    code: '91041',
    nl: 'Botanische tuinen en dierentuinen',
    fr: 'Gestion des jardins botaniques et zoologiques',
    en: 'Botanische tuinen en dierentuinen',
  },
  {
    code: '91042',
    nl: 'Beheer en instandhouding van natuurgebieden',
    fr: 'Gestion et conservation des sites naturels',
    en: 'Beheer en instandhouding van natuurgebieden',
  },
  {
    code: '92000',
    nl: 'Loterijen en kansspelen',
    fr: "Organisation de jeux de hasard et d'argent",
    en: 'Loterijen en kansspelen',
  },
  {
    code: '93110',
    nl: 'Exploitatie van sportaccommodaties',
    fr: "Gestion d'installations sportives",
    en: 'Exploitatie van sportaccommodaties',
  },
  {
    code: '93121',
    nl: 'Activiteiten van voetbalclubs',
    fr: 'Activités de clubs de football',
    en: 'Activiteiten van voetbalclubs',
  },
  {
    code: '93122',
    nl: 'Activiteiten van tennisclubs',
    fr: 'Activités de clubs de tennis',
    en: 'Activiteiten van tennisclubs',
  },
  {
    code: '93123',
    nl: 'Activiteiten van overige balsportclubs',
    fr: "Activités de clubs d'autres sports de ballon",
    en: 'Activiteiten van overige balsportclubs',
  },
  {
    code: '93124',
    nl: 'Activiteiten van wielerclubs',
    fr: 'Activités de clubs cyclistes',
    en: 'Activiteiten van wielerclubs',
  },
  {
    code: '93125',
    nl: 'Activiteiten van vechtsportclubs',
    fr: 'Activités de clubs de sports de combat',
    en: 'Activiteiten van vechtsportclubs',
  },
  {
    code: '93126',
    nl: 'Activiteiten van watersportclubs',
    fr: 'Activités de clubs de sports nautiques',
    en: 'Activiteiten van watersportclubs',
  },
  {
    code: '93127',
    nl: 'Activiteiten van paardensportclubs',
    fr: 'Activités de clubs équestres',
    en: 'Activiteiten van paardensportclubs',
  },
  {
    code: '93128',
    nl: 'Activiteiten van atletiekclubs',
    fr: "Activités de clubs d'athlétisme",
    en: 'Activiteiten van atletiekclubs',
  },
  {
    code: '93129',
    nl: 'Activiteiten van overige sportclubs',
    fr: "Activités de clubs d'autres sports",
    en: 'Activiteiten van overige sportclubs',
  },
  {
    code: '93130',
    nl: 'Fitnesscentra',
    fr: 'Activités des centres de culture physique',
    en: 'Fitnesscentra',
  },
  {
    code: '93191',
    nl: 'Activiteiten van sportbonden en -federaties',
    fr: 'Activités des ligues et des fédérations sportives',
    en: 'Activiteiten van sportbonden en -federaties',
  },
  {
    code: '93192',
    nl: 'Zelfstandig werkende sportbeoefenaaars',
    fr: 'Activités des sportifs indépendants',
    en: 'Zelfstandig werkende sportbeoefenaaars',
  },
  {
    code: '93199',
    nl: 'Overige sportactiviteiten, n.e.g.',
    fr: 'Autres activités sportives n.c.a.',
    en: 'Overige sportactiviteiten, n.e.g.',
  },
  {
    code: '93211',
    nl: 'Exploitatie van kermisattracties',
    fr: 'Activités foraines',
    en: 'Exploitatie van kermisattracties',
  },
  {
    code: '93212',
    nl: 'Exploitatie van pret- en themaparken',
    fr: "Activités des parcs d'attractions et des parcs à thèmes",
    en: 'Exploitatie van pret- en themaparken',
  },
  {
    code: '93291',
    nl: 'Exploitatie van snooker- en biljartenzalen',
    fr: 'Exploitation de salles de billard et de snooker',
    en: 'Exploitatie van snooker- en biljartenzalen',
  },
  {
    code: '93292',
    nl: 'Exploitatie van recreatiedomeinen',
    fr: 'Exploitation de domaines récréatifs',
    en: 'Exploitatie van recreatiedomeinen',
  },
  {
    code: '93299',
    nl: 'Overige recreatie- en ontspanningsactiviteiten, n.e.g.',
    fr: 'Autres activités récréatives et de loisirs n.c.a.',
    en: 'Overige recreatie- en ontspanningsactiviteiten, n.e.g.',
  },
  {
    code: '94110',
    nl: 'Bedrijfs- en werkgeversorganisaties',
    fr: 'Activités des organisations patronales et économiques',
    en: 'Bedrijfs- en werkgeversorganisaties',
  },
  {
    code: '94120',
    nl: 'Beroepsorganisaties',
    fr: 'Activités des organisations professionnelles',
    en: 'Beroepsorganisaties',
  },
  {
    code: '94200',
    nl: 'Vakverenigingen',
    fr: 'Activités des syndicats de salariés',
    en: 'Vakverenigingen',
  },
  {
    code: '94910',
    nl: 'Religieuze organisaties',
    fr: 'Activités des organisations religieuses et philosophiques',
    en: 'Religieuze organisaties',
  },
  {
    code: '94920',
    nl: 'Politieke organisaties',
    fr: 'Activités des organisations politiques',
    en: 'Politieke organisaties',
  },
  {
    code: '94991',
    nl: 'Verenigingen op het vlak van jeugdwerk',
    fr: 'Associations de jeunesse',
    en: 'Verenigingen op het vlak van jeugdwerk',
  },
  {
    code: '94992',
    nl: 'Verenigingen en bewegingen voor volwassenen',
    fr: 'Associations et mouvements pour adultes',
    en: 'Verenigingen en bewegingen voor volwassenen',
  },
  {
    code: '94993',
    nl: 'Verenigingen op het vlak van ziektepreventie en gezondheidsbevordering',
    fr: 'Associations pour la prévention de la santé',
    en: 'Verenigingen op het vlak van ziektepreventie en gezondheidsbevordering',
  },
  {
    code: '94994',
    nl: 'Verenigingen op het vlak van milieu en mobiliteit',
    fr: "Associations pour l'environnement et la mobilité",
    en: 'Verenigingen op het vlak van milieu en mobiliteit',
  },
  {
    code: '94995',
    nl: 'Verenigingen op het vlak van ontwikkelingssamenwerking',
    fr: 'Associations pour la coopération au développement',
    en: 'Verenigingen op het vlak van ontwikkelingssamenwerking',
  },
  {
    code: '94999',
    nl: 'Overige verenigingen, n.e.g.',
    fr: 'Autres associations n.c.a.',
    en: 'Overige verenigingen, n.e.g.',
  },
  {
    code: '95110',
    nl: 'Reparatie van computers en randapparatuur',
    fr: "Réparation d'ordinateurs et d'équipements périphériques",
    en: 'Reparatie van computers en randapparatuur',
  },
  {
    code: '95120',
    nl: 'Reparatie van communicatieapparatuur',
    fr: "Réparation d'équipements de communication",
    en: 'Reparatie van communicatieapparatuur',
  },
  {
    code: '95210',
    nl: 'Reparatie van consumentenelektronica',
    fr: 'Réparation de produits électroniques grand public',
    en: 'Reparatie van consumentenelektronica',
  },
  {
    code: '95220',
    nl: 'Reparatie van huishoudapparaten en van werktuigen voor gebruik in huis en tuin',
    fr: "Réparation d'appareils électroménagers et d'équipements pour la maison et le jardin",
    en: 'Reparatie van huishoudapparaten en van werktuigen voor gebruik in huis en tuin',
  },
  {
    code: '95230',
    nl: 'Reparatie van schoeisel en lederwaren',
    fr: "Réparation de chaussures et d'articles en cuir",
    en: 'Reparatie van schoeisel en lederwaren',
  },
  {
    code: '95240',
    nl: 'Reparatie van meubelen en stoffering',
    fr: "Réparation de meubles et d'équipements du foyer",
    en: 'Reparatie van meubelen en stoffering',
  },
  {
    code: '95250',
    nl: 'Reparatie van uurwerken en sieraden',
    fr: "Réparation d'articles d'horlogerie et de bijouterie",
    en: 'Reparatie van uurwerken en sieraden',
  },
  {
    code: '95290',
    nl: 'Reparatie van andere consumentenartikelen',
    fr: "Réparation d'autres biens personnels et domestiques",
    en: 'Reparatie van andere consumentenartikelen',
  },
  {
    code: '96011',
    nl: 'Activiteiten van industriële wasserijen',
    fr: 'Activités des blanchisseries industrielles',
    en: 'Activiteiten van industriële wasserijen',
  },
  {
    code: '96012',
    nl: 'Activiteiten van wasserettes en wassalons ten behoeve van particulieren',
    fr: 'Activités des blanchisseries et des salons-lavoirs pour particuliers',
    en: 'Activiteiten van wasserettes en wassalons ten behoeve van particulieren',
  },
  { code: '96021', nl: 'Haarverzorging', fr: 'Coiffure', en: 'Haarverzorging' },
  {
    code: '96022',
    nl: 'Schoonheidsverzorging',
    fr: 'Soins de beauté',
    en: 'Schoonheidsverzorging',
  },
  {
    code: '96031',
    nl: 'Uitvaartverzorging',
    fr: 'Soins funéraires',
    en: 'Uitvaartverzorging',
  },
  {
    code: '96032',
    nl: 'Beheer van kerkhoven en activiteiten van crematoria',
    fr: 'Gestion des cimetières et services des crématoriums',
    en: 'Beheer van kerkhoven en activiteiten van crematoria',
  },
  {
    code: '96040',
    nl: "Sauna's, solaria, baden enz.",
    fr: 'Entretien corporel',
    en: "Sauna's, solaria, baden enz.",
  },
  {
    code: '96091',
    nl: 'Contactbemiddelingsbureaus en dergelijke',
    fr: 'Services de rencontres',
    en: 'Contactbemiddelingsbureaus en dergelijke',
  },
  {
    code: '96092',
    nl: 'Plaatsen van tatouages en piercings',
    fr: 'Services de tatouage et de piercing',
    en: 'Plaatsen van tatouages en piercings',
  },
  {
    code: '96093',
    nl: 'Diensten in verband met de verzorging van huisdieren, m.u.v. veterinaire diensten',
    fr: 'Services de soins pour animaux de compagnie, sauf soins vétérinaires',
    en: 'Diensten in verband met de verzorging van huisdieren, m.u.v. veterinaire diensten',
  },
  {
    code: '96094',
    nl: 'Africhten van huisdieren',
    fr: 'Activités de dressage pour animaux de compagnie',
    en: 'Africhten van huisdieren',
  },
  {
    code: '96095',
    nl: 'Pensions voor huisdieren',
    fr: "Hébergement d'animaux de compagnie",
    en: 'Pensions voor huisdieren',
  },
  {
    code: '96099',
    nl: 'Overige persoonlijke diensten',
    fr: 'Autres services personnels',
    en: 'Overige persoonlijke diensten',
  },
  {
    code: '97000',
    nl: 'Huishoudens als werkgever van huishoudelijk personeel',
    fr: "Activités des ménages en tant qu'employeurs de personnel domestique",
    en: 'Huishoudens als werkgever van huishoudelijk personeel',
  },
  {
    code: '98100',
    nl: 'Niet-gedifferentieerde productie van goederen door particuliere huis- houdens voor eigen gebruik',
    fr: 'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
    en: 'Niet-gedifferentieerde productie van goederen door particuliere huis- houdens voor eigen gebruik',
  },
  {
    code: '98200',
    nl: 'Niet-gedifferentieerde productie van diensten door particuliere huis-houdens voor eigen gebruik',
    fr: 'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
    en: 'Niet-gedifferentieerde productie van diensten door particuliere huis-houdens voor eigen gebruik',
  },
  {
    code: '99000',
    nl: 'Extraterritoriale organisaties en lichamen',
    fr: 'Activités des organisations et organismes extraterritoriaux',
    en: 'Extraterritoriale organisaties en lichamen',
  },
]
